(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2d1f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2d1f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("l9SKL", function(module, exports) {
(function(e, t) {
    if (typeof define === "function" && define.amd) define([], t);
    else if (0, module.exports) module.exports = t();
    else e.htmx = e.htmx || t();
})(typeof self !== "undefined" ? self : this, function() {
    return function() {
        "use strict";
        var Q = {
            onLoad: F,
            process: zt,
            on: de,
            off: ge,
            trigger: ce,
            ajax: Nr,
            find: C,
            findAll: f,
            closest: v,
            values: function(e, t) {
                var r = dr(e, t || "post");
                return r.values;
            },
            remove: _,
            addClass: z,
            removeClass: n,
            toggleClass: $,
            takeClass: W,
            defineExtension: Ur,
            removeExtension: Br,
            logAll: V,
            logNone: j,
            logger: null,
            config: {
                historyEnabled: true,
                historyCacheSize: 10,
                refreshOnHistoryMiss: false,
                defaultSwapStyle: "innerHTML",
                defaultSwapDelay: 0,
                defaultSettleDelay: 20,
                includeIndicatorStyles: true,
                indicatorClass: "htmx-indicator",
                requestClass: "htmx-request",
                addedClass: "htmx-added",
                settlingClass: "htmx-settling",
                swappingClass: "htmx-swapping",
                allowEval: true,
                allowScriptTags: true,
                inlineScriptNonce: "",
                attributesToSettle: [
                    "class",
                    "style",
                    "width",
                    "height"
                ],
                withCredentials: false,
                timeout: 0,
                wsReconnectDelay: "full-jitter",
                wsBinaryType: "blob",
                disableSelector: "[hx-disable], [data-hx-disable]",
                useTemplateFragments: false,
                scrollBehavior: "smooth",
                defaultFocusScroll: false,
                getCacheBusterParam: false,
                globalViewTransitions: false,
                methodsThatUseUrlParams: [
                    "get"
                ],
                selfRequestsOnly: false,
                ignoreTitle: false,
                scrollIntoViewOnBoost: true,
                triggerSpecsCache: null
            },
            parseInterval: d,
            _: t,
            createEventSource: function(e) {
                return new EventSource(e, {
                    withCredentials: true
                });
            },
            createWebSocket: function(e) {
                var t = new WebSocket(e, []);
                t.binaryType = Q.config.wsBinaryType;
                return t;
            },
            version: "1.9.12"
        };
        var r = {
            addTriggerHandler: Lt,
            bodyContains: se,
            canAccessLocalStorage: U,
            findThisElement: xe,
            filterValues: yr,
            hasAttribute: o,
            getAttributeValue: te,
            getClosestAttributeValue: ne,
            getClosestMatch: c,
            getExpressionVars: Hr,
            getHeaders: xr,
            getInputValues: dr,
            getInternalData: ae,
            getSwapSpecification: wr,
            getTriggerSpecs: it,
            getTarget: ye,
            makeFragment: l,
            mergeObjects: le,
            makeSettleInfo: T,
            oobSwap: Ee,
            querySelectorExt: ue,
            selectAndSwap: je,
            settleImmediately: nr,
            shouldCancel: ut,
            triggerEvent: ce,
            triggerErrorEvent: fe,
            withExtensions: R
        };
        var w = [
            "get",
            "post",
            "put",
            "delete",
            "patch"
        ];
        var i = w.map(function(e) {
            return "[hx-" + e + "], [data-hx-" + e + "]";
        }).join(", ");
        var S = e("head"), q = e("title"), H = e("svg", true);
        function e(e, t) {
            return new RegExp("<" + e + "(\\s[^>]*>|>)([\\s\\S]*?)<\\/" + e + ">", !!t ? "gim" : "im");
        }
        function d(e) {
            if (e == undefined) return undefined;
            let t = NaN;
            if (e.slice(-2) == "ms") t = parseFloat(e.slice(0, -2));
            else if (e.slice(-1) == "s") t = parseFloat(e.slice(0, -1)) * 1e3;
            else if (e.slice(-1) == "m") t = parseFloat(e.slice(0, -1)) * 60000;
            else t = parseFloat(e);
            return isNaN(t) ? undefined : t;
        }
        function ee(e, t) {
            return e.getAttribute && e.getAttribute(t);
        }
        function o(e, t) {
            return e.hasAttribute && (e.hasAttribute(t) || e.hasAttribute("data-" + t));
        }
        function te(e, t) {
            return ee(e, t) || ee(e, "data-" + t);
        }
        function u(e) {
            return e.parentElement;
        }
        function re() {
            return document;
        }
        function c(e, t) {
            while(e && !t(e))e = u(e);
            return e ? e : null;
        }
        function L(e, t, r) {
            var n = te(t, r);
            var i = te(t, "hx-disinherit");
            if (e !== t && i && (i === "*" || i.split(" ").indexOf(r) >= 0)) return "unset";
            else return n;
        }
        function ne(t, r) {
            var n = null;
            c(t, function(e) {
                return n = L(t, e, r);
            });
            if (n !== "unset") return n;
        }
        function h(e, t) {
            var r = e.matches || e.matchesSelector || e.msMatchesSelector || e.mozMatchesSelector || e.webkitMatchesSelector || e.oMatchesSelector;
            return r && r.call(e, t);
        }
        function A(e) {
            var t = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
            var r = t.exec(e);
            if (r) return r[1].toLowerCase();
            else return "";
        }
        function s(e, t) {
            var r = new DOMParser;
            var n = r.parseFromString(e, "text/html");
            var i = n.body;
            while(t > 0){
                t--;
                i = i.firstChild;
            }
            if (i == null) i = re().createDocumentFragment();
            return i;
        }
        function N(e) {
            return /<body/.test(e);
        }
        function l(e) {
            var t = !N(e);
            var r = A(e);
            var n = e;
            if (r === "head") n = n.replace(S, "");
            if (Q.config.useTemplateFragments && t) {
                var i = s("<body><template>" + n + "</template></body>", 0);
                var a = i.querySelector("template").content;
                if (Q.config.allowScriptTags) oe(a.querySelectorAll("script"), function(e) {
                    if (Q.config.inlineScriptNonce) e.nonce = Q.config.inlineScriptNonce;
                    e.htmxExecuted = navigator.userAgent.indexOf("Firefox") === -1;
                });
                else oe(a.querySelectorAll("script"), function(e) {
                    _(e);
                });
                return a;
            }
            switch(r){
                case "thead":
                case "tbody":
                case "tfoot":
                case "colgroup":
                case "caption":
                    return s("<table>" + n + "</table>", 1);
                case "col":
                    return s("<table><colgroup>" + n + "</colgroup></table>", 2);
                case "tr":
                    return s("<table><tbody>" + n + "</tbody></table>", 2);
                case "td":
                case "th":
                    return s("<table><tbody><tr>" + n + "</tr></tbody></table>", 3);
                case "script":
                case "style":
                    return s("<div>" + n + "</div>", 1);
                default:
                    return s(n, 0);
            }
        }
        function ie(e) {
            if (e) e();
        }
        function I(e, t) {
            return Object.prototype.toString.call(e) === "[object " + t + "]";
        }
        function k(e) {
            return I(e, "Function");
        }
        function P(e) {
            return I(e, "Object");
        }
        function ae(e) {
            var t = "htmx-internal-data";
            var r = e[t];
            if (!r) r = e[t] = {};
            return r;
        }
        function M(e) {
            var t = [];
            if (e) for(var r = 0; r < e.length; r++)t.push(e[r]);
            return t;
        }
        function oe(e, t) {
            if (e) for(var r = 0; r < e.length; r++)t(e[r]);
        }
        function X(e) {
            var t = e.getBoundingClientRect();
            var r = t.top;
            var n = t.bottom;
            return r < window.innerHeight && n >= 0;
        }
        function se(e) {
            if (e.getRootNode && e.getRootNode() instanceof window.ShadowRoot) return re().body.contains(e.getRootNode().host);
            else return re().body.contains(e);
        }
        function D(e) {
            return e.trim().split(/\s+/);
        }
        function le(e, t) {
            for(var r in t)if (t.hasOwnProperty(r)) e[r] = t[r];
            return e;
        }
        function E(e) {
            try {
                return JSON.parse(e);
            } catch (e) {
                b(e);
                return null;
            }
        }
        function U() {
            var e = "htmx:localStorageTest";
            try {
                localStorage.setItem(e, e);
                localStorage.removeItem(e);
                return true;
            } catch (e) {
                return false;
            }
        }
        function B(t) {
            try {
                var e = new URL(t);
                if (e) t = e.pathname + e.search;
                if (!/^\/$/.test(t)) t = t.replace(/\/+$/, "");
                return t;
            } catch (e) {
                return t;
            }
        }
        function t(e) {
            return Tr(re().body, function() {
                return eval(e);
            });
        }
        function F(t) {
            var e = Q.on("htmx:load", function(e) {
                t(e.detail.elt);
            });
            return e;
        }
        function V() {
            Q.logger = function(e, t, r) {
                if (console) console.log(t, e, r);
            };
        }
        function j() {
            Q.logger = null;
        }
        function C(e, t) {
            if (t) return e.querySelector(t);
            else return C(re(), e);
        }
        function f(e, t) {
            if (t) return e.querySelectorAll(t);
            else return f(re(), e);
        }
        function _(e, t) {
            e = p(e);
            if (t) setTimeout(function() {
                _(e);
                e = null;
            }, t);
            else e.parentElement.removeChild(e);
        }
        function z(e, t, r) {
            e = p(e);
            if (r) setTimeout(function() {
                z(e, t);
                e = null;
            }, r);
            else e.classList && e.classList.add(t);
        }
        function n(e, t, r) {
            e = p(e);
            if (r) setTimeout(function() {
                n(e, t);
                e = null;
            }, r);
            else if (e.classList) {
                e.classList.remove(t);
                if (e.classList.length === 0) e.removeAttribute("class");
            }
        }
        function $(e, t) {
            e = p(e);
            e.classList.toggle(t);
        }
        function W(e, t) {
            e = p(e);
            oe(e.parentElement.children, function(e) {
                n(e, t);
            });
            z(e, t);
        }
        function v(e, t) {
            e = p(e);
            if (e.closest) return e.closest(t);
            else {
                do {
                    if (e == null || h(e, t)) return e;
                }while (e = e && u(e));
                return null;
            }
        }
        function g(e, t) {
            return e.substring(0, t.length) === t;
        }
        function G(e, t) {
            return e.substring(e.length - t.length) === t;
        }
        function J(e) {
            var t = e.trim();
            if (g(t, "<") && G(t, "/>")) return t.substring(1, t.length - 2);
            else return t;
        }
        function Z(e, t) {
            if (t.indexOf("closest ") === 0) return [
                v(e, J(t.substr(8)))
            ];
            else if (t.indexOf("find ") === 0) return [
                C(e, J(t.substr(5)))
            ];
            else if (t === "next") return [
                e.nextElementSibling
            ];
            else if (t.indexOf("next ") === 0) return [
                K(e, J(t.substr(5)))
            ];
            else if (t === "previous") return [
                e.previousElementSibling
            ];
            else if (t.indexOf("previous ") === 0) return [
                Y(e, J(t.substr(9)))
            ];
            else if (t === "document") return [
                document
            ];
            else if (t === "window") return [
                window
            ];
            else if (t === "body") return [
                document.body
            ];
            else return re().querySelectorAll(J(t));
        }
        var K = function(e, t) {
            var r = re().querySelectorAll(t);
            for(var n = 0; n < r.length; n++){
                var i = r[n];
                if (i.compareDocumentPosition(e) === Node.DOCUMENT_POSITION_PRECEDING) return i;
            }
        };
        var Y = function(e, t) {
            var r = re().querySelectorAll(t);
            for(var n = r.length - 1; n >= 0; n--){
                var i = r[n];
                if (i.compareDocumentPosition(e) === Node.DOCUMENT_POSITION_FOLLOWING) return i;
            }
        };
        function ue(e, t) {
            if (t) return Z(e, t)[0];
            else return Z(re().body, e)[0];
        }
        function p(e) {
            if (I(e, "String")) return C(e);
            else return e;
        }
        function ve(e, t, r) {
            if (k(t)) return {
                target: re().body,
                event: e,
                listener: t
            };
            else return {
                target: p(e),
                event: t,
                listener: r
            };
        }
        function de(t, r, n) {
            jr(function() {
                var e = ve(t, r, n);
                e.target.addEventListener(e.event, e.listener);
            });
            var e = k(r);
            return e ? r : n;
        }
        function ge(t, r, n) {
            jr(function() {
                var e = ve(t, r, n);
                e.target.removeEventListener(e.event, e.listener);
            });
            return k(r) ? r : n;
        }
        var pe = re().createElement("output");
        function me(e, t) {
            var r = ne(e, t);
            if (r) {
                if (r === "this") return [
                    xe(e, t)
                ];
                else {
                    var n = Z(e, r);
                    if (n.length === 0) {
                        b('The selector "' + r + '" on ' + t + " returned no matches!");
                        return [
                            pe
                        ];
                    } else return n;
                }
            }
        }
        function xe(e, t) {
            return c(e, function(e) {
                return te(e, t) != null;
            });
        }
        function ye(e) {
            var t = ne(e, "hx-target");
            if (t) {
                if (t === "this") return xe(e, "hx-target");
                else return ue(e, t);
            } else {
                var r = ae(e);
                if (r.boosted) return re().body;
                else return e;
            }
        }
        function be(e) {
            var t = Q.config.attributesToSettle;
            for(var r = 0; r < t.length; r++){
                if (e === t[r]) return true;
            }
            return false;
        }
        function we(t, r) {
            oe(t.attributes, function(e) {
                if (!r.hasAttribute(e.name) && be(e.name)) t.removeAttribute(e.name);
            });
            oe(r.attributes, function(e) {
                if (be(e.name)) t.setAttribute(e.name, e.value);
            });
        }
        function Se(e, t) {
            var r = Fr(t);
            for(var n = 0; n < r.length; n++){
                var i = r[n];
                try {
                    if (i.isInlineSwap(e)) return true;
                } catch (e) {
                    b(e);
                }
            }
            return e === "outerHTML";
        }
        function Ee(e, i, a) {
            var t = "#" + ee(i, "id");
            var o = "outerHTML";
            if (e === "true") ;
            else if (e.indexOf(":") > 0) {
                o = e.substr(0, e.indexOf(":"));
                t = e.substr(e.indexOf(":") + 1, e.length);
            } else o = e;
            var r = re().querySelectorAll(t);
            if (r) {
                oe(r, function(e) {
                    var t;
                    var r = i.cloneNode(true);
                    t = re().createDocumentFragment();
                    t.appendChild(r);
                    if (!Se(o, e)) t = r;
                    var n = {
                        shouldSwap: true,
                        target: e,
                        fragment: t
                    };
                    if (!ce(e, "htmx:oobBeforeSwap", n)) return;
                    e = n.target;
                    if (n["shouldSwap"]) Fe(o, e, e, t, a);
                    oe(a.elts, function(e) {
                        ce(e, "htmx:oobAfterSwap", n);
                    });
                });
                i.parentNode.removeChild(i);
            } else {
                i.parentNode.removeChild(i);
                fe(re().body, "htmx:oobErrorNoTarget", {
                    content: i
                });
            }
            return e;
        }
        function Ce(e, t, r) {
            var n = ne(e, "hx-select-oob");
            if (n) {
                var i = n.split(",");
                for(var a = 0; a < i.length; a++){
                    var o = i[a].split(":", 2);
                    var s = o[0].trim();
                    if (s.indexOf("#") === 0) s = s.substring(1);
                    var l = o[1] || "true";
                    var u = t.querySelector("#" + s);
                    if (u) Ee(l, u, r);
                }
            }
            oe(f(t, "[hx-swap-oob], [data-hx-swap-oob]"), function(e) {
                var t = te(e, "hx-swap-oob");
                if (t != null) Ee(t, e, r);
            });
        }
        function Re(e) {
            oe(f(e, "[hx-preserve], [data-hx-preserve]"), function(e) {
                var t = te(e, "id");
                var r = re().getElementById(t);
                if (r != null) e.parentNode.replaceChild(r, e);
            });
        }
        function Te(o, e, s) {
            oe(e.querySelectorAll("[id]"), function(e) {
                var t = ee(e, "id");
                if (t && t.length > 0) {
                    var r = t.replace("'", "\\'");
                    var n = e.tagName.replace(":", "\\:");
                    var i = o.querySelector(n + "[id='" + r + "']");
                    if (i && i !== o) {
                        var a = e.cloneNode();
                        we(e, i);
                        s.tasks.push(function() {
                            we(e, a);
                        });
                    }
                }
            });
        }
        function Oe(e) {
            return function() {
                n(e, Q.config.addedClass);
                zt(e);
                Nt(e);
                qe(e);
                ce(e, "htmx:load");
            };
        }
        function qe(e) {
            var t = "[autofocus]";
            var r = h(e, t) ? e : e.querySelector(t);
            if (r != null) r.focus();
        }
        function a(e, t, r, n) {
            Te(e, r, n);
            while(r.childNodes.length > 0){
                var i = r.firstChild;
                z(i, Q.config.addedClass);
                e.insertBefore(i, t);
                if (i.nodeType !== Node.TEXT_NODE && i.nodeType !== Node.COMMENT_NODE) n.tasks.push(Oe(i));
            }
        }
        function He(e, t) {
            var r = 0;
            while(r < e.length)t = (t << 5) - t + e.charCodeAt(r++) | 0;
            return t;
        }
        function Le(e) {
            var t = 0;
            if (e.attributes) for(var r = 0; r < e.attributes.length; r++){
                var n = e.attributes[r];
                if (n.value) {
                    t = He(n.name, t);
                    t = He(n.value, t);
                }
            }
            return t;
        }
        function Ae(e) {
            var t = ae(e);
            if (t.onHandlers) {
                for(var r = 0; r < t.onHandlers.length; r++){
                    const n = t.onHandlers[r];
                    e.removeEventListener(n.event, n.listener);
                }
                delete t.onHandlers;
            }
        }
        function Ne(e) {
            var t = ae(e);
            if (t.timeout) clearTimeout(t.timeout);
            if (t.webSocket) t.webSocket.close();
            if (t.sseEventSource) t.sseEventSource.close();
            if (t.listenerInfos) oe(t.listenerInfos, function(e) {
                if (e.on) e.on.removeEventListener(e.trigger, e.listener);
            });
            Ae(e);
            oe(Object.keys(t), function(e) {
                delete t[e];
            });
        }
        function m(e) {
            ce(e, "htmx:beforeCleanupElement");
            Ne(e);
            if (e.children) oe(e.children, function(e) {
                m(e);
            });
        }
        function Ie(t, e, r) {
            if (t.tagName === "BODY") return Ue(t, e, r);
            else {
                var n;
                var i = t.previousSibling;
                a(u(t), t, e, r);
                if (i == null) n = u(t).firstChild;
                else n = i.nextSibling;
                r.elts = r.elts.filter(function(e) {
                    return e != t;
                });
                while(n && n !== t){
                    if (n.nodeType === Node.ELEMENT_NODE) r.elts.push(n);
                    n = n.nextElementSibling;
                }
                m(t);
                u(t).removeChild(t);
            }
        }
        function ke(e, t, r) {
            return a(e, e.firstChild, t, r);
        }
        function Pe(e, t, r) {
            return a(u(e), e, t, r);
        }
        function Me(e, t, r) {
            return a(e, null, t, r);
        }
        function Xe(e, t, r) {
            return a(u(e), e.nextSibling, t, r);
        }
        function De(e, t, r) {
            m(e);
            return u(e).removeChild(e);
        }
        function Ue(e, t, r) {
            var n = e.firstChild;
            a(e, n, t, r);
            if (n) {
                while(n.nextSibling){
                    m(n.nextSibling);
                    e.removeChild(n.nextSibling);
                }
                m(n);
                e.removeChild(n);
            }
        }
        function Be(e, t, r) {
            var n = r || ne(e, "hx-select");
            if (n) {
                var i = re().createDocumentFragment();
                oe(t.querySelectorAll(n), function(e) {
                    i.appendChild(e);
                });
                t = i;
            }
            return t;
        }
        function Fe(e, t, r, n, i) {
            switch(e){
                case "none":
                    return;
                case "outerHTML":
                    Ie(r, n, i);
                    return;
                case "afterbegin":
                    ke(r, n, i);
                    return;
                case "beforebegin":
                    Pe(r, n, i);
                    return;
                case "beforeend":
                    Me(r, n, i);
                    return;
                case "afterend":
                    Xe(r, n, i);
                    return;
                case "delete":
                    De(r, n, i);
                    return;
                default:
                    var a = Fr(t);
                    for(var o = 0; o < a.length; o++){
                        var s = a[o];
                        try {
                            var l = s.handleSwap(e, r, n, i);
                            if (l) {
                                if (typeof l.length !== "undefined") for(var u = 0; u < l.length; u++){
                                    var f = l[u];
                                    if (f.nodeType !== Node.TEXT_NODE && f.nodeType !== Node.COMMENT_NODE) i.tasks.push(Oe(f));
                                }
                                return;
                            }
                        } catch (e) {
                            b(e);
                        }
                    }
                    if (e === "innerHTML") Ue(r, n, i);
                    else Fe(Q.config.defaultSwapStyle, t, r, n, i);
            }
        }
        function Ve(e) {
            if (e.indexOf("<title") > -1) {
                var t = e.replace(H, "");
                var r = t.match(q);
                if (r) return r[2];
            }
        }
        function je(e, t, r, n, i, a) {
            i.title = Ve(n);
            var o = l(n);
            if (o) {
                Ce(r, o, i);
                o = Be(r, o, a);
                Re(o);
                return Fe(e, r, t, o, i);
            }
        }
        function _e(e, t, r) {
            var n = e.getResponseHeader(t);
            if (n.indexOf("{") === 0) {
                var i = E(n);
                for(var a in i)if (i.hasOwnProperty(a)) {
                    var o = i[a];
                    if (!P(o)) o = {
                        value: o
                    };
                    ce(r, a, o);
                }
            } else {
                var s = n.split(",");
                for(var l = 0; l < s.length; l++)ce(r, s[l].trim(), []);
            }
        }
        var ze = /\s/;
        var x = /[\s,]/;
        var $e = /[_$a-zA-Z]/;
        var We = /[_$a-zA-Z0-9]/;
        var Ge = [
            '"',
            "'",
            "/"
        ];
        var Je = /[^\s]/;
        var Ze = /[{(]/;
        var Ke = /[})]/;
        function Ye(e) {
            var t = [];
            var r = 0;
            while(r < e.length){
                if ($e.exec(e.charAt(r))) {
                    var n = r;
                    while(We.exec(e.charAt(r + 1)))r++;
                    t.push(e.substr(n, r - n + 1));
                } else if (Ge.indexOf(e.charAt(r)) !== -1) {
                    var i = e.charAt(r);
                    var n = r;
                    r++;
                    while(r < e.length && e.charAt(r) !== i){
                        if (e.charAt(r) === "\\") r++;
                        r++;
                    }
                    t.push(e.substr(n, r - n + 1));
                } else {
                    var a = e.charAt(r);
                    t.push(a);
                }
                r++;
            }
            return t;
        }
        function Qe(e, t, r) {
            return $e.exec(e.charAt(0)) && e !== "true" && e !== "false" && e !== "this" && e !== r && t !== ".";
        }
        function et(e, t, r) {
            if (t[0] === "[") {
                t.shift();
                var n = 1;
                var i = " return (function(" + r + "){ return (";
                var a = null;
                while(t.length > 0){
                    var o = t[0];
                    if (o === "]") {
                        n--;
                        if (n === 0) {
                            if (a === null) i = i + "true";
                            t.shift();
                            i += ")})";
                            try {
                                var s = Tr(e, function() {
                                    return Function(i)();
                                }, function() {
                                    return true;
                                });
                                s.source = i;
                                return s;
                            } catch (e) {
                                fe(re().body, "htmx:syntax:error", {
                                    error: e,
                                    source: i
                                });
                                return null;
                            }
                        }
                    } else if (o === "[") n++;
                    if (Qe(o, a, r)) i += "((" + r + "." + o + ") ? (" + r + "." + o + ") : (window." + o + "))";
                    else i = i + o;
                    a = t.shift();
                }
            }
        }
        function y(e, t) {
            var r = "";
            while(e.length > 0 && !t.test(e[0]))r += e.shift();
            return r;
        }
        function tt(e) {
            var t;
            if (e.length > 0 && Ze.test(e[0])) {
                e.shift();
                t = y(e, Ke).trim();
                e.shift();
            } else t = y(e, x);
            return t;
        }
        var rt = "input, textarea, select";
        function nt(e, t, r) {
            var n = [];
            var i = Ye(t);
            do {
                y(i, Je);
                var a = i.length;
                var o = y(i, /[,\[\s]/);
                if (o !== "") {
                    if (o === "every") {
                        var s = {
                            trigger: "every"
                        };
                        y(i, Je);
                        s.pollInterval = d(y(i, /[,\[\s]/));
                        y(i, Je);
                        var l = et(e, i, "event");
                        if (l) s.eventFilter = l;
                        n.push(s);
                    } else if (o.indexOf("sse:") === 0) n.push({
                        trigger: "sse",
                        sseEvent: o.substr(4)
                    });
                    else {
                        var u = {
                            trigger: o
                        };
                        var l = et(e, i, "event");
                        if (l) u.eventFilter = l;
                        while(i.length > 0 && i[0] !== ","){
                            y(i, Je);
                            var f = i.shift();
                            if (f === "changed") u.changed = true;
                            else if (f === "once") u.once = true;
                            else if (f === "consume") u.consume = true;
                            else if (f === "delay" && i[0] === ":") {
                                i.shift();
                                u.delay = d(y(i, x));
                            } else if (f === "from" && i[0] === ":") {
                                i.shift();
                                if (Ze.test(i[0])) var c = tt(i);
                                else {
                                    var c = y(i, x);
                                    if (c === "closest" || c === "find" || c === "next" || c === "previous") {
                                        i.shift();
                                        var h = tt(i);
                                        if (h.length > 0) c += " " + h;
                                    }
                                }
                                u.from = c;
                            } else if (f === "target" && i[0] === ":") {
                                i.shift();
                                u.target = tt(i);
                            } else if (f === "throttle" && i[0] === ":") {
                                i.shift();
                                u.throttle = d(y(i, x));
                            } else if (f === "queue" && i[0] === ":") {
                                i.shift();
                                u.queue = y(i, x);
                            } else if (f === "root" && i[0] === ":") {
                                i.shift();
                                u[f] = tt(i);
                            } else if (f === "threshold" && i[0] === ":") {
                                i.shift();
                                u[f] = y(i, x);
                            } else fe(e, "htmx:syntax:error", {
                                token: i.shift()
                            });
                        }
                        n.push(u);
                    }
                }
                if (i.length === a) fe(e, "htmx:syntax:error", {
                    token: i.shift()
                });
                y(i, Je);
            }while (i[0] === "," && i.shift());
            if (r) r[t] = n;
            return n;
        }
        function it(e) {
            var t = te(e, "hx-trigger");
            var r = [];
            if (t) {
                var n = Q.config.triggerSpecsCache;
                r = n && n[t] || nt(e, t, n);
            }
            if (r.length > 0) return r;
            else if (h(e, "form")) return [
                {
                    trigger: "submit"
                }
            ];
            else if (h(e, 'input[type="button"], input[type="submit"]')) return [
                {
                    trigger: "click"
                }
            ];
            else if (h(e, rt)) return [
                {
                    trigger: "change"
                }
            ];
            else return [
                {
                    trigger: "click"
                }
            ];
        }
        function at(e) {
            ae(e).cancelled = true;
        }
        function ot(e, t, r) {
            var n = ae(e);
            n.timeout = setTimeout(function() {
                if (se(e) && n.cancelled !== true) {
                    if (!ct(r, e, Wt("hx:poll:trigger", {
                        triggerSpec: r,
                        target: e
                    }))) t(e);
                    ot(e, t, r);
                }
            }, r.pollInterval);
        }
        function st(e) {
            return location.hostname === e.hostname && ee(e, "href") && ee(e, "href").indexOf("#") !== 0;
        }
        function lt(t, r, e) {
            if (t.tagName === "A" && st(t) && (t.target === "" || t.target === "_self") || t.tagName === "FORM") {
                r.boosted = true;
                var n, i;
                if (t.tagName === "A") {
                    n = "get";
                    i = ee(t, "href");
                } else {
                    var a = ee(t, "method");
                    n = a ? a.toLowerCase() : "get";
                    n;
                    i = ee(t, "action");
                }
                e.forEach(function(e) {
                    ht(t, function(e, t) {
                        if (v(e, Q.config.disableSelector)) {
                            m(e);
                            return;
                        }
                        he(n, i, e, t);
                    }, r, e, true);
                });
            }
        }
        function ut(e, t) {
            if (e.type === "submit" || e.type === "click") {
                if (t.tagName === "FORM") return true;
                if (h(t, 'input[type="submit"], button') && v(t, "form") !== null) return true;
                if (t.tagName === "A" && t.href && (t.getAttribute("href") === "#" || t.getAttribute("href").indexOf("#") !== 0)) return true;
            }
            return false;
        }
        function ft(e, t) {
            return ae(e).boosted && e.tagName === "A" && t.type === "click" && (t.ctrlKey || t.metaKey);
        }
        function ct(e, t, r) {
            var n = e.eventFilter;
            if (n) try {
                return n.call(t, r) !== true;
            } catch (e) {
                fe(re().body, "htmx:eventFilter:error", {
                    error: e,
                    source: n.source
                });
                return true;
            }
            return false;
        }
        function ht(a, o, e, s, l) {
            var u = ae(a);
            var t;
            if (s.from) t = Z(a, s.from);
            else t = [
                a
            ];
            if (s.changed) t.forEach(function(e) {
                var t = ae(e);
                t.lastValue = e.value;
            });
            oe(t, function(n) {
                var i = function(e) {
                    if (!se(a)) {
                        n.removeEventListener(s.trigger, i);
                        return;
                    }
                    if (ft(a, e)) return;
                    if (l || ut(e, a)) e.preventDefault();
                    if (ct(s, a, e)) return;
                    var t = ae(e);
                    t.triggerSpec = s;
                    if (t.handledFor == null) t.handledFor = [];
                    if (t.handledFor.indexOf(a) < 0) {
                        t.handledFor.push(a);
                        if (s.consume) e.stopPropagation();
                        if (s.target && e.target) {
                            if (!h(e.target, s.target)) return;
                        }
                        if (s.once) {
                            if (u.triggeredOnce) return;
                            else u.triggeredOnce = true;
                        }
                        if (s.changed) {
                            var r = ae(n);
                            if (r.lastValue === n.value) return;
                            r.lastValue = n.value;
                        }
                        if (u.delayed) clearTimeout(u.delayed);
                        if (u.throttle) return;
                        if (s.throttle > 0) {
                            if (!u.throttle) {
                                o(a, e);
                                u.throttle = setTimeout(function() {
                                    u.throttle = null;
                                }, s.throttle);
                            }
                        } else if (s.delay > 0) u.delayed = setTimeout(function() {
                            o(a, e);
                        }, s.delay);
                        else {
                            ce(a, "htmx:trigger");
                            o(a, e);
                        }
                    }
                };
                if (e.listenerInfos == null) e.listenerInfos = [];
                e.listenerInfos.push({
                    trigger: s.trigger,
                    listener: i,
                    on: n
                });
                n.addEventListener(s.trigger, i);
            });
        }
        var vt = false;
        var dt = null;
        function gt() {
            if (!dt) {
                dt = function() {
                    vt = true;
                };
                window.addEventListener("scroll", dt);
                setInterval(function() {
                    if (vt) {
                        vt = false;
                        oe(re().querySelectorAll("[hx-trigger='revealed'],[data-hx-trigger='revealed']"), function(e) {
                            pt(e);
                        });
                    }
                }, 200);
            }
        }
        function pt(t) {
            if (!o(t, "data-hx-revealed") && X(t)) {
                t.setAttribute("data-hx-revealed", "true");
                var e = ae(t);
                if (e.initHash) ce(t, "revealed");
                else t.addEventListener("htmx:afterProcessNode", function(e) {
                    ce(t, "revealed");
                }, {
                    once: true
                });
            }
        }
        function mt(e, t, r) {
            var n = D(r);
            for(var i = 0; i < n.length; i++){
                var a = n[i].split(/:(.+)/);
                if (a[0] === "connect") xt(e, a[1], 0);
                if (a[0] === "send") bt(e);
            }
        }
        function xt(s, r, n) {
            if (!se(s)) return;
            if (r.indexOf("/") == 0) {
                var e = location.hostname + (location.port ? ":" + location.port : "");
                if (location.protocol == "https:") r = "wss://" + e + r;
                else if (location.protocol == "http:") r = "ws://" + e + r;
            }
            var t = Q.createWebSocket(r);
            t.onerror = function(e) {
                fe(s, "htmx:wsError", {
                    error: e,
                    socket: t
                });
                yt(s);
            };
            t.onclose = function(e) {
                if ([
                    1006,
                    1012,
                    1013
                ].indexOf(e.code) >= 0) {
                    var t = wt(n);
                    setTimeout(function() {
                        xt(s, r, n + 1);
                    }, t);
                }
            };
            t.onopen = function(e) {
                n = 0;
            };
            ae(s).webSocket = t;
            t.addEventListener("message", function(e) {
                if (yt(s)) return;
                var t = e.data;
                R(s, function(e) {
                    t = e.transformResponse(t, null, s);
                });
                var r = T(s);
                var n = l(t);
                var i = M(n.children);
                for(var a = 0; a < i.length; a++){
                    var o = i[a];
                    Ee(te(o, "hx-swap-oob") || "true", o, r);
                }
                nr(r.tasks);
            });
        }
        function yt(e) {
            if (!se(e)) {
                ae(e).webSocket.close();
                return true;
            }
        }
        function bt(u) {
            var f = c(u, function(e) {
                return ae(e).webSocket != null;
            });
            if (f) u.addEventListener(it(u)[0].trigger, function(e) {
                var t = ae(f).webSocket;
                var r = xr(u, f);
                var n = dr(u, "post");
                var i = n.errors;
                var a = n.values;
                var o = Hr(u);
                var s = le(a, o);
                var l = yr(s, u);
                l["HEADERS"] = r;
                if (i && i.length > 0) {
                    ce(u, "htmx:validation:halted", i);
                    return;
                }
                t.send(JSON.stringify(l));
                if (ut(e, u)) e.preventDefault();
            });
            else fe(u, "htmx:noWebSocketSourceError");
        }
        function wt(e) {
            var t = Q.config.wsReconnectDelay;
            if (typeof t === "function") return t(e);
            if (t === "full-jitter") {
                var r = Math.min(e, 6);
                var n = 1e3 * Math.pow(2, r);
                return n * Math.random();
            }
            b('htmx.config.wsReconnectDelay must either be a function or the string "full-jitter"');
        }
        function St(e, t, r) {
            var n = D(r);
            for(var i = 0; i < n.length; i++){
                var a = n[i].split(/:(.+)/);
                if (a[0] === "connect") Et(e, a[1]);
                if (a[0] === "swap") Ct(e, a[1]);
            }
        }
        function Et(t, e) {
            var r = Q.createEventSource(e);
            r.onerror = function(e) {
                fe(t, "htmx:sseError", {
                    error: e,
                    source: r
                });
                Tt(t);
            };
            ae(t).sseEventSource = r;
        }
        function Ct(a, o) {
            var s = c(a, Ot);
            if (s) {
                var l = ae(s).sseEventSource;
                var u = function(e) {
                    if (Tt(s)) return;
                    if (!se(a)) {
                        l.removeEventListener(o, u);
                        return;
                    }
                    var t = e.data;
                    R(a, function(e) {
                        t = e.transformResponse(t, null, a);
                    });
                    var r = wr(a);
                    var n = ye(a);
                    var i = T(a);
                    je(r.swapStyle, n, a, t, i);
                    nr(i.tasks);
                    ce(a, "htmx:sseMessage", e);
                };
                ae(a).sseListener = u;
                l.addEventListener(o, u);
            } else fe(a, "htmx:noSSESourceError");
        }
        function Rt(e, t, r) {
            var n = c(e, Ot);
            if (n) {
                var i = ae(n).sseEventSource;
                var a = function() {
                    if (!Tt(n)) {
                        if (se(e)) t(e);
                        else i.removeEventListener(r, a);
                    }
                };
                ae(e).sseListener = a;
                i.addEventListener(r, a);
            } else fe(e, "htmx:noSSESourceError");
        }
        function Tt(e) {
            if (!se(e)) {
                ae(e).sseEventSource.close();
                return true;
            }
        }
        function Ot(e) {
            return ae(e).sseEventSource != null;
        }
        function qt(e, t, r, n) {
            var i = function() {
                if (!r.loaded) {
                    r.loaded = true;
                    t(e);
                }
            };
            if (n > 0) setTimeout(i, n);
            else i();
        }
        function Ht(t, i, e) {
            var a = false;
            oe(w, function(r) {
                if (o(t, "hx-" + r)) {
                    var n = te(t, "hx-" + r);
                    a = true;
                    i.path = n;
                    i.verb = r;
                    e.forEach(function(e) {
                        Lt(t, e, i, function(e, t) {
                            if (v(e, Q.config.disableSelector)) {
                                m(e);
                                return;
                            }
                            he(r, n, e, t);
                        });
                    });
                }
            });
            return a;
        }
        function Lt(n, e, t, r) {
            if (e.sseEvent) Rt(n, r, e.sseEvent);
            else if (e.trigger === "revealed") {
                gt();
                ht(n, r, t, e);
                pt(n);
            } else if (e.trigger === "intersect") {
                var i = {};
                if (e.root) i.root = ue(n, e.root);
                if (e.threshold) i.threshold = parseFloat(e.threshold);
                var a = new IntersectionObserver(function(e) {
                    for(var t = 0; t < e.length; t++){
                        var r = e[t];
                        if (r.isIntersecting) {
                            ce(n, "intersect");
                            break;
                        }
                    }
                }, i);
                a.observe(n);
                ht(n, r, t, e);
            } else if (e.trigger === "load") {
                if (!ct(e, n, Wt("load", {
                    elt: n
                }))) qt(n, r, t, e.delay);
            } else if (e.pollInterval > 0) {
                t.polling = true;
                ot(n, r, e);
            } else ht(n, r, t, e);
        }
        function At(e) {
            if (!e.htmxExecuted && Q.config.allowScriptTags && (e.type === "text/javascript" || e.type === "module" || e.type === "")) {
                var t = re().createElement("script");
                oe(e.attributes, function(e) {
                    t.setAttribute(e.name, e.value);
                });
                t.textContent = e.textContent;
                t.async = false;
                if (Q.config.inlineScriptNonce) t.nonce = Q.config.inlineScriptNonce;
                var r = e.parentElement;
                try {
                    r.insertBefore(t, e);
                } catch (e) {
                    b(e);
                } finally{
                    if (e.parentElement) e.parentElement.removeChild(e);
                }
            }
        }
        function Nt(e) {
            if (h(e, "script")) At(e);
            oe(f(e, "script"), function(e) {
                At(e);
            });
        }
        function It(e) {
            var t = e.attributes;
            if (!t) return false;
            for(var r = 0; r < t.length; r++){
                var n = t[r].name;
                if (g(n, "hx-on:") || g(n, "data-hx-on:") || g(n, "hx-on-") || g(n, "data-hx-on-")) return true;
            }
            return false;
        }
        function kt(e) {
            var t = null;
            var r = [];
            if (It(e)) r.push(e);
            if (document.evaluate) {
                var n = document.evaluate('.//*[@*[ starts-with(name(), "hx-on:") or starts-with(name(), "data-hx-on:") or starts-with(name(), "hx-on-") or starts-with(name(), "data-hx-on-") ]]', e);
                while(t = n.iterateNext())r.push(t);
            } else if (typeof e.getElementsByTagName === "function") {
                var i = e.getElementsByTagName("*");
                for(var a = 0; a < i.length; a++)if (It(i[a])) r.push(i[a]);
            }
            return r;
        }
        function Pt(e) {
            if (e.querySelectorAll) {
                var t = ", [hx-boost] a, [data-hx-boost] a, a[hx-boost], a[data-hx-boost]";
                var r = e.querySelectorAll(i + t + ", form, [type='submit'], [hx-sse], [data-hx-sse], [hx-ws]," + " [data-hx-ws], [hx-ext], [data-hx-ext], [hx-trigger], [data-hx-trigger], [hx-on], [data-hx-on]");
                return r;
            } else return [];
        }
        function Mt(e) {
            var t = v(e.target, "button, input[type='submit']");
            var r = Dt(e);
            if (r) r.lastButtonClicked = t;
        }
        function Xt(e) {
            var t = Dt(e);
            if (t) t.lastButtonClicked = null;
        }
        function Dt(e) {
            var t = v(e.target, "button, input[type='submit']");
            if (!t) return;
            var r = p("#" + ee(t, "form")) || v(t, "form");
            if (!r) return;
            return ae(r);
        }
        function Ut(e) {
            e.addEventListener("click", Mt);
            e.addEventListener("focusin", Mt);
            e.addEventListener("focusout", Xt);
        }
        function Bt(e) {
            var t = Ye(e);
            var r = 0;
            for(var n = 0; n < t.length; n++){
                const i = t[n];
                if (i === "{") r++;
                else if (i === "}") r--;
            }
            return r;
        }
        function Ft(t, e, r) {
            var n = ae(t);
            if (!Array.isArray(n.onHandlers)) n.onHandlers = [];
            var i;
            var a = function(e) {
                return Tr(t, function() {
                    if (!i) i = new Function("event", r);
                    i.call(t, e);
                });
            };
            t.addEventListener(e, a);
            n.onHandlers.push({
                event: e,
                listener: a
            });
        }
        function Vt(e) {
            var t = te(e, "hx-on");
            if (t) {
                var r = {};
                var n = t.split("\n");
                var i = null;
                var a = 0;
                while(n.length > 0){
                    var o = n.shift();
                    var s = o.match(/^\s*([a-zA-Z:\-\.]+:)(.*)/);
                    if (a === 0 && s) {
                        o.split(":");
                        i = s[1].slice(0, -1);
                        r[i] = s[2];
                    } else r[i] += o;
                    a += Bt(o);
                }
                for(var l in r)Ft(e, l, r[l]);
            }
        }
        function jt(e) {
            Ae(e);
            for(var t = 0; t < e.attributes.length; t++){
                var r = e.attributes[t].name;
                var n = e.attributes[t].value;
                if (g(r, "hx-on") || g(r, "data-hx-on")) {
                    var i = r.indexOf("-on") + 3;
                    var a = r.slice(i, i + 1);
                    if (a === "-" || a === ":") {
                        var o = r.slice(i + 1);
                        if (g(o, ":")) o = "htmx" + o;
                        else if (g(o, "-")) o = "htmx:" + o.slice(1);
                        else if (g(o, "htmx-")) o = "htmx:" + o.slice(5);
                        Ft(e, o, n);
                    }
                }
            }
        }
        function _t(t) {
            if (v(t, Q.config.disableSelector)) {
                m(t);
                return;
            }
            var r = ae(t);
            if (r.initHash !== Le(t)) {
                Ne(t);
                r.initHash = Le(t);
                Vt(t);
                ce(t, "htmx:beforeProcessNode");
                if (t.value) r.lastValue = t.value;
                var e = it(t);
                var n = Ht(t, r, e);
                if (!n) {
                    if (ne(t, "hx-boost") === "true") lt(t, r, e);
                    else if (o(t, "hx-trigger")) e.forEach(function(e) {
                        Lt(t, e, r, function() {});
                    });
                }
                if (t.tagName === "FORM" || ee(t, "type") === "submit" && o(t, "form")) Ut(t);
                var i = te(t, "hx-sse");
                if (i) St(t, r, i);
                var a = te(t, "hx-ws");
                if (a) mt(t, r, a);
                ce(t, "htmx:afterProcessNode");
            }
        }
        function zt(e) {
            e = p(e);
            if (v(e, Q.config.disableSelector)) {
                m(e);
                return;
            }
            _t(e);
            oe(Pt(e), function(e) {
                _t(e);
            });
            oe(kt(e), jt);
        }
        function $t(e) {
            return e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
        }
        function Wt(e, t) {
            var r;
            if (window.CustomEvent && typeof window.CustomEvent === "function") r = new CustomEvent(e, {
                bubbles: true,
                cancelable: true,
                detail: t
            });
            else {
                r = re().createEvent("CustomEvent");
                r.initCustomEvent(e, true, true, t);
            }
            return r;
        }
        function fe(e, t, r) {
            ce(e, t, le({
                error: t
            }, r));
        }
        function Gt(e) {
            return e === "htmx:afterProcessNode";
        }
        function R(e, t) {
            oe(Fr(e), function(e) {
                try {
                    t(e);
                } catch (e) {
                    b(e);
                }
            });
        }
        function b(e) {
            if (console.error) console.error(e);
            else if (console.log) console.log("ERROR: ", e);
        }
        function ce(e, t, r) {
            e = p(e);
            if (r == null) r = {};
            r["elt"] = e;
            var n = Wt(t, r);
            if (Q.logger && !Gt(t)) Q.logger(e, t, r);
            if (r.error) {
                b(r.error);
                ce(e, "htmx:error", {
                    errorInfo: r
                });
            }
            var i = e.dispatchEvent(n);
            var a = $t(t);
            if (i && a !== t) {
                var o = Wt(a, n.detail);
                i = i && e.dispatchEvent(o);
            }
            R(e, function(e) {
                i = i && e.onEvent(t, n) !== false && !n.defaultPrevented;
            });
            return i;
        }
        var Jt = location.pathname + location.search;
        function Zt() {
            var e = re().querySelector("[hx-history-elt],[data-hx-history-elt]");
            return e || re().body;
        }
        function Kt(e, t, r, n) {
            if (!U()) return;
            if (Q.config.historyCacheSize <= 0) {
                localStorage.removeItem("htmx-history-cache");
                return;
            }
            e = B(e);
            var i = E(localStorage.getItem("htmx-history-cache")) || [];
            for(var a = 0; a < i.length; a++)if (i[a].url === e) {
                i.splice(a, 1);
                break;
            }
            var o = {
                url: e,
                content: t,
                title: r,
                scroll: n
            };
            ce(re().body, "htmx:historyItemCreated", {
                item: o,
                cache: i
            });
            i.push(o);
            while(i.length > Q.config.historyCacheSize)i.shift();
            while(i.length > 0)try {
                localStorage.setItem("htmx-history-cache", JSON.stringify(i));
                break;
            } catch (e) {
                fe(re().body, "htmx:historyCacheError", {
                    cause: e,
                    cache: i
                });
                i.shift();
            }
        }
        function Yt(e) {
            if (!U()) return null;
            e = B(e);
            var t = E(localStorage.getItem("htmx-history-cache")) || [];
            for(var r = 0; r < t.length; r++){
                if (t[r].url === e) return t[r];
            }
            return null;
        }
        function Qt(e) {
            var t = Q.config.requestClass;
            var r = e.cloneNode(true);
            oe(f(r, "." + t), function(e) {
                n(e, t);
            });
            return r.innerHTML;
        }
        function er() {
            var e = Zt();
            var t = Jt || location.pathname + location.search;
            var r;
            try {
                r = re().querySelector('[hx-history="false" i],[data-hx-history="false" i]');
            } catch (e) {
                r = re().querySelector('[hx-history="false"],[data-hx-history="false"]');
            }
            if (!r) {
                ce(re().body, "htmx:beforeHistorySave", {
                    path: t,
                    historyElt: e
                });
                Kt(t, Qt(e), re().title, window.scrollY);
            }
            if (Q.config.historyEnabled) history.replaceState({
                htmx: true
            }, re().title, window.location.href);
        }
        function tr(e) {
            if (Q.config.getCacheBusterParam) {
                e = e.replace(/org\.htmx\.cache-buster=[^&]*&?/, "");
                if (G(e, "&") || G(e, "?")) e = e.slice(0, -1);
            }
            if (Q.config.historyEnabled) history.pushState({
                htmx: true
            }, "", e);
            Jt = e;
        }
        function rr(e) {
            if (Q.config.historyEnabled) history.replaceState({
                htmx: true
            }, "", e);
            Jt = e;
        }
        function nr(e) {
            oe(e, function(e) {
                e.call();
            });
        }
        function ir(a) {
            var e = new XMLHttpRequest;
            var o = {
                path: a,
                xhr: e
            };
            ce(re().body, "htmx:historyCacheMiss", o);
            e.open("GET", a, true);
            e.setRequestHeader("HX-Request", "true");
            e.setRequestHeader("HX-History-Restore-Request", "true");
            e.setRequestHeader("HX-Current-URL", re().location.href);
            e.onload = function() {
                if (this.status >= 200 && this.status < 400) {
                    ce(re().body, "htmx:historyCacheMissLoad", o);
                    var e = l(this.response);
                    e = e.querySelector("[hx-history-elt],[data-hx-history-elt]") || e;
                    var t = Zt();
                    var r = T(t);
                    var n = Ve(this.response);
                    if (n) {
                        var i = C("title");
                        if (i) i.innerHTML = n;
                        else window.document.title = n;
                    }
                    Ue(t, e, r);
                    nr(r.tasks);
                    Jt = a;
                    ce(re().body, "htmx:historyRestore", {
                        path: a,
                        cacheMiss: true,
                        serverResponse: this.response
                    });
                } else fe(re().body, "htmx:historyCacheMissLoadError", o);
            };
            e.send();
        }
        function ar(e) {
            er();
            e = e || location.pathname + location.search;
            var t = Yt(e);
            if (t) {
                var r = l(t.content);
                var n = Zt();
                var i = T(n);
                Ue(n, r, i);
                nr(i.tasks);
                document.title = t.title;
                setTimeout(function() {
                    window.scrollTo(0, t.scroll);
                }, 0);
                Jt = e;
                ce(re().body, "htmx:historyRestore", {
                    path: e,
                    item: t
                });
            } else if (Q.config.refreshOnHistoryMiss) window.location.reload(true);
            else ir(e);
        }
        function or(e) {
            var t = me(e, "hx-indicator");
            if (t == null) t = [
                e
            ];
            oe(t, function(e) {
                var t = ae(e);
                t.requestCount = (t.requestCount || 0) + 1;
                e.classList["add"].call(e.classList, Q.config.requestClass);
            });
            return t;
        }
        function sr(e) {
            var t = me(e, "hx-disabled-elt");
            if (t == null) t = [];
            oe(t, function(e) {
                var t = ae(e);
                t.requestCount = (t.requestCount || 0) + 1;
                e.setAttribute("disabled", "");
            });
            return t;
        }
        function lr(e, t) {
            oe(e, function(e) {
                var t = ae(e);
                t.requestCount = (t.requestCount || 0) - 1;
                if (t.requestCount === 0) e.classList["remove"].call(e.classList, Q.config.requestClass);
            });
            oe(t, function(e) {
                var t = ae(e);
                t.requestCount = (t.requestCount || 0) - 1;
                if (t.requestCount === 0) e.removeAttribute("disabled");
            });
        }
        function ur(e, t) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                if (n.isSameNode(t)) return true;
            }
            return false;
        }
        function fr(e) {
            if (e.name === "" || e.name == null || e.disabled || v(e, "fieldset[disabled]")) return false;
            if (e.type === "button" || e.type === "submit" || e.tagName === "image" || e.tagName === "reset" || e.tagName === "file") return false;
            if (e.type === "checkbox" || e.type === "radio") return e.checked;
            return true;
        }
        function cr(e, t, r) {
            if (e != null && t != null) {
                var n = r[e];
                if (n === undefined) r[e] = t;
                else if (Array.isArray(n)) {
                    if (Array.isArray(t)) r[e] = n.concat(t);
                    else n.push(t);
                } else if (Array.isArray(t)) r[e] = [
                    n
                ].concat(t);
                else r[e] = [
                    n,
                    t
                ];
            }
        }
        function hr(t, r, n, e, i) {
            if (e == null || ur(t, e)) return;
            else t.push(e);
            if (fr(e)) {
                var a = ee(e, "name");
                var o = e.value;
                if (e.multiple && e.tagName === "SELECT") o = M(e.querySelectorAll("option:checked")).map(function(e) {
                    return e.value;
                });
                if (e.files) o = M(e.files);
                cr(a, o, r);
                if (i) vr(e, n);
            }
            if (h(e, "form")) {
                var s = e.elements;
                oe(s, function(e) {
                    hr(t, r, n, e, i);
                });
            }
        }
        function vr(e, t) {
            if (e.willValidate) {
                ce(e, "htmx:validation:validate");
                if (!e.checkValidity()) {
                    t.push({
                        elt: e,
                        message: e.validationMessage,
                        validity: e.validity
                    });
                    ce(e, "htmx:validation:failed", {
                        message: e.validationMessage,
                        validity: e.validity
                    });
                }
            }
        }
        function dr(e, t) {
            var r = [];
            var n = {};
            var i = {};
            var a = [];
            var o = ae(e);
            if (o.lastButtonClicked && !se(o.lastButtonClicked)) o.lastButtonClicked = null;
            var s = h(e, "form") && e.noValidate !== true || te(e, "hx-validate") === "true";
            if (o.lastButtonClicked) s = s && o.lastButtonClicked.formNoValidate !== true;
            if (t !== "get") hr(r, i, a, v(e, "form"), s);
            hr(r, n, a, e, s);
            if (o.lastButtonClicked || e.tagName === "BUTTON" || e.tagName === "INPUT" && ee(e, "type") === "submit") {
                var l = o.lastButtonClicked || e;
                var u = ee(l, "name");
                cr(u, l.value, i);
            }
            var f = me(e, "hx-include");
            oe(f, function(e) {
                hr(r, n, a, e, s);
                if (!h(e, "form")) oe(e.querySelectorAll(rt), function(e) {
                    hr(r, n, a, e, s);
                });
            });
            n = le(n, i);
            return {
                errors: a,
                values: n
            };
        }
        function gr(e, t, r) {
            if (e !== "") e += "&";
            if (String(r) === "[object Object]") r = JSON.stringify(r);
            var n = encodeURIComponent(r);
            e += encodeURIComponent(t) + "=" + n;
            return e;
        }
        function pr(e) {
            var t = "";
            for(var r in e)if (e.hasOwnProperty(r)) {
                var n = e[r];
                if (Array.isArray(n)) oe(n, function(e) {
                    t = gr(t, r, e);
                });
                else t = gr(t, r, n);
            }
            return t;
        }
        function mr(e) {
            var t = new FormData;
            for(var r in e)if (e.hasOwnProperty(r)) {
                var n = e[r];
                if (Array.isArray(n)) oe(n, function(e) {
                    t.append(r, e);
                });
                else t.append(r, n);
            }
            return t;
        }
        function xr(e, t, r) {
            var n = {
                "HX-Request": "true",
                "HX-Trigger": ee(e, "id"),
                "HX-Trigger-Name": ee(e, "name"),
                "HX-Target": te(t, "id"),
                "HX-Current-URL": re().location.href
            };
            Rr(e, "hx-headers", false, n);
            if (r !== undefined) n["HX-Prompt"] = r;
            if (ae(e).boosted) n["HX-Boosted"] = "true";
            return n;
        }
        function yr(t, e) {
            var r = ne(e, "hx-params");
            if (r) {
                if (r === "none") return {};
                else if (r === "*") return t;
                else if (r.indexOf("not ") === 0) {
                    oe(r.substr(4).split(","), function(e) {
                        e = e.trim();
                        delete t[e];
                    });
                    return t;
                } else {
                    var n = {};
                    oe(r.split(","), function(e) {
                        e = e.trim();
                        n[e] = t[e];
                    });
                    return n;
                }
            } else return t;
        }
        function br(e) {
            return ee(e, "href") && ee(e, "href").indexOf("#") >= 0;
        }
        function wr(e, t) {
            var r = t ? t : ne(e, "hx-swap");
            var n = {
                swapStyle: ae(e).boosted ? "innerHTML" : Q.config.defaultSwapStyle,
                swapDelay: Q.config.defaultSwapDelay,
                settleDelay: Q.config.defaultSettleDelay
            };
            if (Q.config.scrollIntoViewOnBoost && ae(e).boosted && !br(e)) n["show"] = "top";
            if (r) {
                var i = D(r);
                if (i.length > 0) for(var a = 0; a < i.length; a++){
                    var o = i[a];
                    if (o.indexOf("swap:") === 0) n["swapDelay"] = d(o.substr(5));
                    else if (o.indexOf("settle:") === 0) n["settleDelay"] = d(o.substr(7));
                    else if (o.indexOf("transition:") === 0) n["transition"] = o.substr(11) === "true";
                    else if (o.indexOf("ignoreTitle:") === 0) n["ignoreTitle"] = o.substr(12) === "true";
                    else if (o.indexOf("scroll:") === 0) {
                        var s = o.substr(7);
                        var l = s.split(":");
                        var u = l.pop();
                        var f = l.length > 0 ? l.join(":") : null;
                        n["scroll"] = u;
                        n["scrollTarget"] = f;
                    } else if (o.indexOf("show:") === 0) {
                        var c = o.substr(5);
                        var l = c.split(":");
                        var h = l.pop();
                        var f = l.length > 0 ? l.join(":") : null;
                        n["show"] = h;
                        n["showTarget"] = f;
                    } else if (o.indexOf("focus-scroll:") === 0) {
                        var v = o.substr(13);
                        n["focusScroll"] = v == "true";
                    } else if (a == 0) n["swapStyle"] = o;
                    else b("Unknown modifier in hx-swap: " + o);
                }
            }
            return n;
        }
        function Sr(e) {
            return ne(e, "hx-encoding") === "multipart/form-data" || h(e, "form") && ee(e, "enctype") === "multipart/form-data";
        }
        function Er(t, r, n) {
            var i = null;
            R(r, function(e) {
                if (i == null) i = e.encodeParameters(t, n, r);
            });
            if (i != null) return i;
            else {
                if (Sr(r)) return mr(n);
                else return pr(n);
            }
        }
        function T(e) {
            return {
                tasks: [],
                elts: [
                    e
                ]
            };
        }
        function Cr(e, t) {
            var r = e[0];
            var n = e[e.length - 1];
            if (t.scroll) {
                var i = null;
                if (t.scrollTarget) i = ue(r, t.scrollTarget);
                if (t.scroll === "top" && (r || i)) {
                    i = i || r;
                    i.scrollTop = 0;
                }
                if (t.scroll === "bottom" && (n || i)) {
                    i = i || n;
                    i.scrollTop = i.scrollHeight;
                }
            }
            if (t.show) {
                var i = null;
                if (t.showTarget) {
                    var a = t.showTarget;
                    if (t.showTarget === "window") a = "body";
                    i = ue(r, a);
                }
                if (t.show === "top" && (r || i)) {
                    i = i || r;
                    i.scrollIntoView({
                        block: "start",
                        behavior: Q.config.scrollBehavior
                    });
                }
                if (t.show === "bottom" && (n || i)) {
                    i = i || n;
                    i.scrollIntoView({
                        block: "end",
                        behavior: Q.config.scrollBehavior
                    });
                }
            }
        }
        function Rr(e, t, r, n) {
            if (n == null) n = {};
            if (e == null) return n;
            var i = te(e, t);
            if (i) {
                var a = i.trim();
                var o = r;
                if (a === "unset") return null;
                if (a.indexOf("javascript:") === 0) {
                    a = a.substr(11);
                    o = true;
                } else if (a.indexOf("js:") === 0) {
                    a = a.substr(3);
                    o = true;
                }
                if (a.indexOf("{") !== 0) a = "{" + a + "}";
                var s;
                if (o) s = Tr(e, function() {
                    return Function("return (" + a + ")")();
                }, {});
                else s = E(a);
                for(var l in s){
                    if (s.hasOwnProperty(l)) {
                        if (n[l] == null) n[l] = s[l];
                    }
                }
            }
            return Rr(u(e), t, r, n);
        }
        function Tr(e, t, r) {
            if (Q.config.allowEval) return t();
            else {
                fe(e, "htmx:evalDisallowedError");
                return r;
            }
        }
        function Or(e, t) {
            return Rr(e, "hx-vars", true, t);
        }
        function qr(e, t) {
            return Rr(e, "hx-vals", false, t);
        }
        function Hr(e) {
            return le(Or(e), qr(e));
        }
        function Lr(t, r, n) {
            if (n !== null) try {
                t.setRequestHeader(r, n);
            } catch (e) {
                t.setRequestHeader(r, encodeURIComponent(n));
                t.setRequestHeader(r + "-URI-AutoEncoded", "true");
            }
        }
        function Ar(t) {
            if (t.responseURL && typeof URL !== "undefined") try {
                var e = new URL(t.responseURL);
                return e.pathname + e.search;
            } catch (e) {
                fe(re().body, "htmx:badResponseUrl", {
                    url: t.responseURL
                });
            }
        }
        function O(e, t) {
            return t.test(e.getAllResponseHeaders());
        }
        function Nr(e, t, r) {
            e = e.toLowerCase();
            if (r) {
                if (r instanceof Element || I(r, "String")) return he(e, t, null, null, {
                    targetOverride: p(r),
                    returnPromise: true
                });
                else return he(e, t, p(r.source), r.event, {
                    handler: r.handler,
                    headers: r.headers,
                    values: r.values,
                    targetOverride: p(r.target),
                    swapOverride: r.swap,
                    select: r.select,
                    returnPromise: true
                });
            } else return he(e, t, null, null, {
                returnPromise: true
            });
        }
        function Ir(e) {
            var t = [];
            while(e){
                t.push(e);
                e = e.parentElement;
            }
            return t;
        }
        function kr(e, t, r) {
            var n;
            var i;
            if (typeof URL === "function") {
                i = new URL(t, document.location.href);
                var a = document.location.origin;
                n = a === i.origin;
            } else {
                i = t;
                n = g(t, document.location.origin);
            }
            if (Q.config.selfRequestsOnly) {
                if (!n) return false;
            }
            return ce(e, "htmx:validateUrl", le({
                url: i,
                sameHost: n
            }, r));
        }
        function he(t, r, n, i, a, e) {
            var o = null;
            var s = null;
            a = a != null ? a : {};
            if (a.returnPromise && typeof Promise !== "undefined") var l = new Promise(function(e, t) {
                o = e;
                s = t;
            });
            if (n == null) n = re().body;
            var M = a.handler || Mr;
            var X = a.select || null;
            if (!se(n)) {
                ie(o);
                return l;
            }
            var u = a.targetOverride || ye(n);
            if (u == null || u == pe) {
                fe(n, "htmx:targetError", {
                    target: te(n, "hx-target")
                });
                ie(s);
                return l;
            }
            var f = ae(n);
            var c = f.lastButtonClicked;
            if (c) {
                var h = ee(c, "formaction");
                if (h != null) r = h;
                var v = ee(c, "formmethod");
                if (v != null) {
                    if (v.toLowerCase() !== "dialog") t = v;
                }
            }
            var d = ne(n, "hx-confirm");
            if (e === undefined) {
                var D = function(e) {
                    return he(t, r, n, i, a, !!e);
                };
                var U = {
                    target: u,
                    elt: n,
                    path: r,
                    verb: t,
                    triggeringEvent: i,
                    etc: a,
                    issueRequest: D,
                    question: d
                };
                if (ce(n, "htmx:confirm", U) === false) {
                    ie(o);
                    return l;
                }
            }
            var g = n;
            var p = ne(n, "hx-sync");
            var m = null;
            var x = false;
            if (p) {
                var B = p.split(":");
                var F = B[0].trim();
                if (F === "this") g = xe(n, "hx-sync");
                else g = ue(n, F);
                p = (B[1] || "drop").trim();
                f = ae(g);
                if (p === "drop" && f.xhr && f.abortable !== true) {
                    ie(o);
                    return l;
                } else if (p === "abort") {
                    if (f.xhr) {
                        ie(o);
                        return l;
                    } else x = true;
                } else if (p === "replace") ce(g, "htmx:abort");
                else if (p.indexOf("queue") === 0) {
                    var V = p.split(" ");
                    m = (V[1] || "last").trim();
                }
            }
            if (f.xhr) {
                if (f.abortable) ce(g, "htmx:abort");
                else {
                    if (m == null) {
                        if (i) {
                            var y = ae(i);
                            if (y && y.triggerSpec && y.triggerSpec.queue) m = y.triggerSpec.queue;
                        }
                        if (m == null) m = "last";
                    }
                    if (f.queuedRequests == null) f.queuedRequests = [];
                    if (m === "first" && f.queuedRequests.length === 0) f.queuedRequests.push(function() {
                        he(t, r, n, i, a);
                    });
                    else if (m === "all") f.queuedRequests.push(function() {
                        he(t, r, n, i, a);
                    });
                    else if (m === "last") {
                        f.queuedRequests = [];
                        f.queuedRequests.push(function() {
                            he(t, r, n, i, a);
                        });
                    }
                    ie(o);
                    return l;
                }
            }
            var b = new XMLHttpRequest;
            f.xhr = b;
            f.abortable = x;
            var w = function() {
                f.xhr = null;
                f.abortable = false;
                if (f.queuedRequests != null && f.queuedRequests.length > 0) {
                    var e = f.queuedRequests.shift();
                    e();
                }
            };
            var j = ne(n, "hx-prompt");
            if (j) {
                var S = prompt(j);
                if (S === null || !ce(n, "htmx:prompt", {
                    prompt: S,
                    target: u
                })) {
                    ie(o);
                    w();
                    return l;
                }
            }
            if (d && !e) {
                if (!confirm(d)) {
                    ie(o);
                    w();
                    return l;
                }
            }
            var E = xr(n, u, S);
            if (t !== "get" && !Sr(n)) E["Content-Type"] = "application/x-www-form-urlencoded";
            if (a.headers) E = le(E, a.headers);
            var _ = dr(n, t);
            var C = _.errors;
            var R = _.values;
            if (a.values) R = le(R, a.values);
            var z = Hr(n);
            var $ = le(R, z);
            var T = yr($, n);
            if (Q.config.getCacheBusterParam && t === "get") T["org.htmx.cache-buster"] = ee(u, "id") || "true";
            if (r == null || r === "") r = re().location.href;
            var O = Rr(n, "hx-request");
            var W = ae(n).boosted;
            var q = Q.config.methodsThatUseUrlParams.indexOf(t) >= 0;
            var H = {
                boosted: W,
                useUrlParams: q,
                parameters: T,
                unfilteredParameters: $,
                headers: E,
                target: u,
                verb: t,
                errors: C,
                withCredentials: a.credentials || O.credentials || Q.config.withCredentials,
                timeout: a.timeout || O.timeout || Q.config.timeout,
                path: r,
                triggeringEvent: i
            };
            if (!ce(n, "htmx:configRequest", H)) {
                ie(o);
                w();
                return l;
            }
            r = H.path;
            t = H.verb;
            E = H.headers;
            T = H.parameters;
            C = H.errors;
            q = H.useUrlParams;
            if (C && C.length > 0) {
                ce(n, "htmx:validation:halted", H);
                ie(o);
                w();
                return l;
            }
            var G = r.split("#");
            var J = G[0];
            var L = G[1];
            var A = r;
            if (q) {
                A = J;
                var Z = Object.keys(T).length !== 0;
                if (Z) {
                    if (A.indexOf("?") < 0) A += "?";
                    else A += "&";
                    A += pr(T);
                    if (L) A += "#" + L;
                }
            }
            if (!kr(n, A, H)) {
                fe(n, "htmx:invalidPath", H);
                ie(s);
                return l;
            }
            b.open(t.toUpperCase(), A, true);
            b.overrideMimeType("text/html");
            b.withCredentials = H.withCredentials;
            b.timeout = H.timeout;
            if (O.noHeaders) ;
            else {
                for(var N in E)if (E.hasOwnProperty(N)) {
                    var K = E[N];
                    Lr(b, N, K);
                }
            }
            var I = {
                xhr: b,
                target: u,
                requestConfig: H,
                etc: a,
                boosted: W,
                select: X,
                pathInfo: {
                    requestPath: r,
                    finalRequestPath: A,
                    anchor: L
                }
            };
            b.onload = function() {
                try {
                    var e = Ir(n);
                    I.pathInfo.responsePath = Ar(b);
                    M(n, I);
                    lr(k, P);
                    ce(n, "htmx:afterRequest", I);
                    ce(n, "htmx:afterOnLoad", I);
                    if (!se(n)) {
                        var t = null;
                        while(e.length > 0 && t == null){
                            var r = e.shift();
                            if (se(r)) t = r;
                        }
                        if (t) {
                            ce(t, "htmx:afterRequest", I);
                            ce(t, "htmx:afterOnLoad", I);
                        }
                    }
                    ie(o);
                    w();
                } catch (e) {
                    fe(n, "htmx:onLoadError", le({
                        error: e
                    }, I));
                    throw e;
                }
            };
            b.onerror = function() {
                lr(k, P);
                fe(n, "htmx:afterRequest", I);
                fe(n, "htmx:sendError", I);
                ie(s);
                w();
            };
            b.onabort = function() {
                lr(k, P);
                fe(n, "htmx:afterRequest", I);
                fe(n, "htmx:sendAbort", I);
                ie(s);
                w();
            };
            b.ontimeout = function() {
                lr(k, P);
                fe(n, "htmx:afterRequest", I);
                fe(n, "htmx:timeout", I);
                ie(s);
                w();
            };
            if (!ce(n, "htmx:beforeRequest", I)) {
                ie(o);
                w();
                return l;
            }
            var k = or(n);
            var P = sr(n);
            oe([
                "loadstart",
                "loadend",
                "progress",
                "abort"
            ], function(t) {
                oe([
                    b,
                    b.upload
                ], function(e) {
                    e.addEventListener(t, function(e) {
                        ce(n, "htmx:xhr:" + t, {
                            lengthComputable: e.lengthComputable,
                            loaded: e.loaded,
                            total: e.total
                        });
                    });
                });
            });
            ce(n, "htmx:beforeSend", I);
            var Y = q ? null : Er(b, n, T);
            b.send(Y);
            return l;
        }
        function Pr(e, t) {
            var r = t.xhr;
            var n = null;
            var i = null;
            if (O(r, /HX-Push:/i)) {
                n = r.getResponseHeader("HX-Push");
                i = "push";
            } else if (O(r, /HX-Push-Url:/i)) {
                n = r.getResponseHeader("HX-Push-Url");
                i = "push";
            } else if (O(r, /HX-Replace-Url:/i)) {
                n = r.getResponseHeader("HX-Replace-Url");
                i = "replace";
            }
            if (n) {
                if (n === "false") return {};
                else return {
                    type: i,
                    path: n
                };
            }
            var a = t.pathInfo.finalRequestPath;
            var o = t.pathInfo.responsePath;
            var s = ne(e, "hx-push-url");
            var l = ne(e, "hx-replace-url");
            var u = ae(e).boosted;
            var f = null;
            var c = null;
            if (s) {
                f = "push";
                c = s;
            } else if (l) {
                f = "replace";
                c = l;
            } else if (u) {
                f = "push";
                c = o || a;
            }
            if (c) {
                if (c === "false") return {};
                if (c === "true") c = o || a;
                if (t.pathInfo.anchor && c.indexOf("#") === -1) c = c + "#" + t.pathInfo.anchor;
                return {
                    type: f,
                    path: c
                };
            } else return {};
        }
        function Mr(l, u) {
            var f = u.xhr;
            var c = u.target;
            var e = u.etc;
            var t = u.requestConfig;
            var h = u.select;
            if (!ce(l, "htmx:beforeOnLoad", u)) return;
            if (O(f, /HX-Trigger:/i)) _e(f, "HX-Trigger", l);
            if (O(f, /HX-Location:/i)) {
                er();
                var r = f.getResponseHeader("HX-Location");
                var v;
                if (r.indexOf("{") === 0) {
                    v = E(r);
                    r = v["path"];
                    delete v["path"];
                }
                Nr("GET", r, v).then(function() {
                    tr(r);
                });
                return;
            }
            var n = O(f, /HX-Refresh:/i) && "true" === f.getResponseHeader("HX-Refresh");
            if (O(f, /HX-Redirect:/i)) {
                location.href = f.getResponseHeader("HX-Redirect");
                n && location.reload();
                return;
            }
            if (n) {
                location.reload();
                return;
            }
            if (O(f, /HX-Retarget:/i)) {
                if (f.getResponseHeader("HX-Retarget") === "this") u.target = l;
                else u.target = ue(l, f.getResponseHeader("HX-Retarget"));
            }
            var d = Pr(l, u);
            var i = f.status >= 200 && f.status < 400 && f.status !== 204;
            var g = f.response;
            var a = f.status >= 400;
            var p = Q.config.ignoreTitle;
            var o = le({
                shouldSwap: i,
                serverResponse: g,
                isError: a,
                ignoreTitle: p
            }, u);
            if (!ce(c, "htmx:beforeSwap", o)) return;
            c = o.target;
            g = o.serverResponse;
            a = o.isError;
            p = o.ignoreTitle;
            u.target = c;
            u.failed = a;
            u.successful = !a;
            if (o.shouldSwap) {
                if (f.status === 286) at(l);
                R(l, function(e) {
                    g = e.transformResponse(g, f, l);
                });
                if (d.type) er();
                var s = e.swapOverride;
                if (O(f, /HX-Reswap:/i)) s = f.getResponseHeader("HX-Reswap");
                var v = wr(l, s);
                if (v.hasOwnProperty("ignoreTitle")) p = v.ignoreTitle;
                c.classList.add(Q.config.swappingClass);
                var m = null;
                var x = null;
                var y = function() {
                    try {
                        var e = document.activeElement;
                        var t = {};
                        try {
                            t = {
                                elt: e,
                                start: e ? e.selectionStart : null,
                                end: e ? e.selectionEnd : null
                            };
                        } catch (e) {}
                        var r;
                        if (h) r = h;
                        if (O(f, /HX-Reselect:/i)) r = f.getResponseHeader("HX-Reselect");
                        if (d.type) {
                            ce(re().body, "htmx:beforeHistoryUpdate", le({
                                history: d
                            }, u));
                            if (d.type === "push") {
                                tr(d.path);
                                ce(re().body, "htmx:pushedIntoHistory", {
                                    path: d.path
                                });
                            } else {
                                rr(d.path);
                                ce(re().body, "htmx:replacedInHistory", {
                                    path: d.path
                                });
                            }
                        }
                        var n = T(c);
                        je(v.swapStyle, c, l, g, n, r);
                        if (t.elt && !se(t.elt) && ee(t.elt, "id")) {
                            var i = document.getElementById(ee(t.elt, "id"));
                            var a = {
                                preventScroll: v.focusScroll !== undefined ? !v.focusScroll : !Q.config.defaultFocusScroll
                            };
                            if (i) {
                                if (t.start && i.setSelectionRange) try {
                                    i.setSelectionRange(t.start, t.end);
                                } catch (e) {}
                                i.focus(a);
                            }
                        }
                        c.classList.remove(Q.config.swappingClass);
                        oe(n.elts, function(e) {
                            if (e.classList) e.classList.add(Q.config.settlingClass);
                            ce(e, "htmx:afterSwap", u);
                        });
                        if (O(f, /HX-Trigger-After-Swap:/i)) {
                            var o = l;
                            if (!se(l)) o = re().body;
                            _e(f, "HX-Trigger-After-Swap", o);
                        }
                        var s = function() {
                            oe(n.tasks, function(e) {
                                e.call();
                            });
                            oe(n.elts, function(e) {
                                if (e.classList) e.classList.remove(Q.config.settlingClass);
                                ce(e, "htmx:afterSettle", u);
                            });
                            if (u.pathInfo.anchor) {
                                var e = re().getElementById(u.pathInfo.anchor);
                                if (e) e.scrollIntoView({
                                    block: "start",
                                    behavior: "auto"
                                });
                            }
                            if (n.title && !p) {
                                var t = C("title");
                                if (t) t.innerHTML = n.title;
                                else window.document.title = n.title;
                            }
                            Cr(n.elts, v);
                            if (O(f, /HX-Trigger-After-Settle:/i)) {
                                var r = l;
                                if (!se(l)) r = re().body;
                                _e(f, "HX-Trigger-After-Settle", r);
                            }
                            ie(m);
                        };
                        if (v.settleDelay > 0) setTimeout(s, v.settleDelay);
                        else s();
                    } catch (e) {
                        fe(l, "htmx:swapError", u);
                        ie(x);
                        throw e;
                    }
                };
                var b = Q.config.globalViewTransitions;
                if (v.hasOwnProperty("transition")) b = v.transition;
                if (b && ce(l, "htmx:beforeTransition", u) && typeof Promise !== "undefined" && document.startViewTransition) {
                    var w = new Promise(function(e, t) {
                        m = e;
                        x = t;
                    });
                    var S = y;
                    y = function() {
                        document.startViewTransition(function() {
                            S();
                            return w;
                        });
                    };
                }
                if (v.swapDelay > 0) setTimeout(y, v.swapDelay);
                else y();
            }
            if (a) fe(l, "htmx:responseError", le({
                error: "Response Status Error Code " + f.status + " from " + u.pathInfo.requestPath
            }, u));
        }
        var Xr = {};
        function Dr() {
            return {
                init: function(e) {
                    return null;
                },
                onEvent: function(e, t) {
                    return true;
                },
                transformResponse: function(e, t, r) {
                    return e;
                },
                isInlineSwap: function(e) {
                    return false;
                },
                handleSwap: function(e, t, r, n) {
                    return false;
                },
                encodeParameters: function(e, t, r) {
                    return null;
                }
            };
        }
        function Ur(e, t) {
            if (t.init) t.init(r);
            Xr[e] = le(Dr(), t);
        }
        function Br(e) {
            delete Xr[e];
        }
        function Fr(e, r, n) {
            if (e == undefined) return r;
            if (r == undefined) r = [];
            if (n == undefined) n = [];
            var t = te(e, "hx-ext");
            if (t) oe(t.split(","), function(e) {
                e = e.replace(/ /g, "");
                if (e.slice(0, 7) == "ignore:") {
                    n.push(e.slice(7));
                    return;
                }
                if (n.indexOf(e) < 0) {
                    var t = Xr[e];
                    if (t && r.indexOf(t) < 0) r.push(t);
                }
            });
            return Fr(u(e), r, n);
        }
        var Vr = false;
        re().addEventListener("DOMContentLoaded", function() {
            Vr = true;
        });
        function jr(e) {
            if (Vr || re().readyState === "complete") e();
            else re().addEventListener("DOMContentLoaded", e);
        }
        function _r() {
            if (Q.config.includeIndicatorStyles !== false) re().head.insertAdjacentHTML("beforeend", "<style>                      ." + Q.config.indicatorClass + "{opacity:0}                      ." + Q.config.requestClass + " ." + Q.config.indicatorClass + "{opacity:1; transition: opacity 200ms ease-in;}                      ." + Q.config.requestClass + "." + Q.config.indicatorClass + "{opacity:1; transition: opacity 200ms ease-in;}                    </style>");
        }
        function zr() {
            var e = re().querySelector('meta[name="htmx-config"]');
            if (e) return E(e.content);
            else return null;
        }
        function $r() {
            var e = zr();
            if (e) Q.config = le(Q.config, e);
        }
        jr(function() {
            $r();
            _r();
            var e = re().body;
            zt(e);
            var t = re().querySelectorAll("[hx-trigger='restored'],[data-hx-trigger='restored']");
            e.addEventListener("htmx:abort", function(e) {
                var t = e.target;
                var r = ae(t);
                if (r && r.xhr) r.xhr.abort();
            });
            const r = window.onpopstate ? window.onpopstate.bind(window) : null;
            window.onpopstate = function(e) {
                if (e.state && e.state.htmx) {
                    ar();
                    oe(t, function(e) {
                        ce(e, "htmx:restored", {
                            document: re(),
                            triggerEvent: ce
                        });
                    });
                } else if (r) r(e);
            };
            setTimeout(function() {
                ce(e, "htmx:load", {});
                e = null;
            }, 0);
        });
        return Q;
    }();
});

});



var $l9SKL = parcelRequire("l9SKL");
var $586b16fccafeb372$exports = {};

$parcel$export($586b16fccafeb372$exports, "Alert", function () { return $586b16fccafeb372$export$caec2af78bcc877f; });
$parcel$export($586b16fccafeb372$exports, "Button", function () { return $586b16fccafeb372$export$353f5b6fc5456de1; });
$parcel$export($586b16fccafeb372$exports, "Carousel", function () { return $586b16fccafeb372$export$144901db2ea8e967; });
$parcel$export($586b16fccafeb372$exports, "Collapse", function () { return $586b16fccafeb372$export$78768a9af065a7b; });
$parcel$export($586b16fccafeb372$exports, "Dropdown", function () { return $586b16fccafeb372$export$931cbfb6bfb85fc; });
$parcel$export($586b16fccafeb372$exports, "Modal", function () { return $586b16fccafeb372$export$2b77a92f1a5ad772; });
$parcel$export($586b16fccafeb372$exports, "Offcanvas", function () { return $586b16fccafeb372$export$591ca0244c9dfcd4; });
$parcel$export($586b16fccafeb372$exports, "Tooltip", function () { return $586b16fccafeb372$export$28c660c63b792dea; });
$parcel$export($586b16fccafeb372$exports, "Popover", function () { return $586b16fccafeb372$export$5b6b19405a83ff9d; });
$parcel$export($586b16fccafeb372$exports, "ScrollSpy", function () { return $586b16fccafeb372$export$a6472a5298a374be; });
$parcel$export($586b16fccafeb372$exports, "Tab", function () { return $586b16fccafeb372$export$3e41faf802a29e71; });
$parcel$export($586b16fccafeb372$exports, "Toast", function () { return $586b16fccafeb372$export$8d8dc7d5f743331b; });
/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $2415630f543121c4$exports = {};

$parcel$export($2415630f543121c4$exports, "popperGenerator", function () { return $ce15fd4ee324a266$export$ed5e13716264f202; });
$parcel$export($2415630f543121c4$exports, "detectOverflow", function () { return $086c770dfd92987c$export$2e2bcd8739ae039; });
$parcel$export($2415630f543121c4$exports, "createPopperBase", function () { return $ce15fd4ee324a266$export$8f7491d57c8f97a9; });
$parcel$export($2415630f543121c4$exports, "createPopper", function () { return $19c7ba5e80710f89$export$8f7491d57c8f97a9; });
$parcel$export($2415630f543121c4$exports, "createPopperLite", function () { return $3523020281cc2339$export$8f7491d57c8f97a9; });
var $37abd1a1aec69ebe$exports = {};

$parcel$export($37abd1a1aec69ebe$exports, "top", function () { return $37abd1a1aec69ebe$export$1e95b668f3b82d; });
$parcel$export($37abd1a1aec69ebe$exports, "bottom", function () { return $37abd1a1aec69ebe$export$40e543e69a8b3fbb; });
$parcel$export($37abd1a1aec69ebe$exports, "right", function () { return $37abd1a1aec69ebe$export$79ffe56a765070d2; });
$parcel$export($37abd1a1aec69ebe$exports, "left", function () { return $37abd1a1aec69ebe$export$eabcd2c8791e7bf4; });
$parcel$export($37abd1a1aec69ebe$exports, "auto", function () { return $37abd1a1aec69ebe$export$dfb5619354ba860; });
$parcel$export($37abd1a1aec69ebe$exports, "basePlacements", function () { return $37abd1a1aec69ebe$export$aec2ce47c367b8c3; });
$parcel$export($37abd1a1aec69ebe$exports, "start", function () { return $37abd1a1aec69ebe$export$b3571188c770cc5a; });
$parcel$export($37abd1a1aec69ebe$exports, "end", function () { return $37abd1a1aec69ebe$export$bd5df0f255a350f8; });
$parcel$export($37abd1a1aec69ebe$exports, "clippingParents", function () { return $37abd1a1aec69ebe$export$390fd549c5303b4d; });
$parcel$export($37abd1a1aec69ebe$exports, "viewport", function () { return $37abd1a1aec69ebe$export$d7b7311ec04a3e8f; });
$parcel$export($37abd1a1aec69ebe$exports, "popper", function () { return $37abd1a1aec69ebe$export$ae5ab1c730825774; });
$parcel$export($37abd1a1aec69ebe$exports, "reference", function () { return $37abd1a1aec69ebe$export$ca50aac9f3ba507f; });
$parcel$export($37abd1a1aec69ebe$exports, "variationPlacements", function () { return $37abd1a1aec69ebe$export$368f9a87e87fa4e1; });
$parcel$export($37abd1a1aec69ebe$exports, "placements", function () { return $37abd1a1aec69ebe$export$803cd8101b6c182b; });
$parcel$export($37abd1a1aec69ebe$exports, "beforeRead", function () { return $37abd1a1aec69ebe$export$421679a7c3d56e; });
$parcel$export($37abd1a1aec69ebe$exports, "read", function () { return $37abd1a1aec69ebe$export$aafa59e2e03f2942; });
$parcel$export($37abd1a1aec69ebe$exports, "afterRead", function () { return $37abd1a1aec69ebe$export$6964f6c886723980; });
$parcel$export($37abd1a1aec69ebe$exports, "beforeMain", function () { return $37abd1a1aec69ebe$export$c65e99957a05207c; });
$parcel$export($37abd1a1aec69ebe$exports, "main", function () { return $37abd1a1aec69ebe$export$f22da7240b7add18; });
$parcel$export($37abd1a1aec69ebe$exports, "afterMain", function () { return $37abd1a1aec69ebe$export$bab79516f2d662fe; });
$parcel$export($37abd1a1aec69ebe$exports, "beforeWrite", function () { return $37abd1a1aec69ebe$export$8d4d2d70e7d46032; });
$parcel$export($37abd1a1aec69ebe$exports, "write", function () { return $37abd1a1aec69ebe$export$68d8715fc104d294; });
$parcel$export($37abd1a1aec69ebe$exports, "afterWrite", function () { return $37abd1a1aec69ebe$export$70a6e5159acce2e6; });
$parcel$export($37abd1a1aec69ebe$exports, "modifierPhases", function () { return $37abd1a1aec69ebe$export$d087d3878fdf71d5; });
var $37abd1a1aec69ebe$export$1e95b668f3b82d = "top";
var $37abd1a1aec69ebe$export$40e543e69a8b3fbb = "bottom";
var $37abd1a1aec69ebe$export$79ffe56a765070d2 = "right";
var $37abd1a1aec69ebe$export$eabcd2c8791e7bf4 = "left";
var $37abd1a1aec69ebe$export$dfb5619354ba860 = "auto";
var $37abd1a1aec69ebe$export$aec2ce47c367b8c3 = [
    $37abd1a1aec69ebe$export$1e95b668f3b82d,
    $37abd1a1aec69ebe$export$40e543e69a8b3fbb,
    $37abd1a1aec69ebe$export$79ffe56a765070d2,
    $37abd1a1aec69ebe$export$eabcd2c8791e7bf4
];
var $37abd1a1aec69ebe$export$b3571188c770cc5a = "start";
var $37abd1a1aec69ebe$export$bd5df0f255a350f8 = "end";
var $37abd1a1aec69ebe$export$390fd549c5303b4d = "clippingParents";
var $37abd1a1aec69ebe$export$d7b7311ec04a3e8f = "viewport";
var $37abd1a1aec69ebe$export$ae5ab1c730825774 = "popper";
var $37abd1a1aec69ebe$export$ca50aac9f3ba507f = "reference";
var $37abd1a1aec69ebe$export$368f9a87e87fa4e1 = /*#__PURE__*/ $37abd1a1aec69ebe$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $37abd1a1aec69ebe$export$b3571188c770cc5a,
        placement + "-" + $37abd1a1aec69ebe$export$bd5df0f255a350f8
    ]);
}, []);
var $37abd1a1aec69ebe$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($37abd1a1aec69ebe$export$aec2ce47c367b8c3, [
    $37abd1a1aec69ebe$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $37abd1a1aec69ebe$export$b3571188c770cc5a,
        placement + "-" + $37abd1a1aec69ebe$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $37abd1a1aec69ebe$export$421679a7c3d56e = "beforeRead";
var $37abd1a1aec69ebe$export$aafa59e2e03f2942 = "read";
var $37abd1a1aec69ebe$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $37abd1a1aec69ebe$export$c65e99957a05207c = "beforeMain";
var $37abd1a1aec69ebe$export$f22da7240b7add18 = "main";
var $37abd1a1aec69ebe$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $37abd1a1aec69ebe$export$8d4d2d70e7d46032 = "beforeWrite";
var $37abd1a1aec69ebe$export$68d8715fc104d294 = "write";
var $37abd1a1aec69ebe$export$70a6e5159acce2e6 = "afterWrite";
var $37abd1a1aec69ebe$export$d087d3878fdf71d5 = [
    $37abd1a1aec69ebe$export$421679a7c3d56e,
    $37abd1a1aec69ebe$export$aafa59e2e03f2942,
    $37abd1a1aec69ebe$export$6964f6c886723980,
    $37abd1a1aec69ebe$export$c65e99957a05207c,
    $37abd1a1aec69ebe$export$f22da7240b7add18,
    $37abd1a1aec69ebe$export$bab79516f2d662fe,
    $37abd1a1aec69ebe$export$8d4d2d70e7d46032,
    $37abd1a1aec69ebe$export$68d8715fc104d294,
    $37abd1a1aec69ebe$export$70a6e5159acce2e6
];


var $db55dff1757face0$exports = {};

$parcel$export($db55dff1757face0$exports, "applyStyles", function () { return $6e2d9c54aef83e8d$export$2e2bcd8739ae039; });
$parcel$export($db55dff1757face0$exports, "arrow", function () { return $5dade89d82270f44$export$2e2bcd8739ae039; });
$parcel$export($db55dff1757face0$exports, "computeStyles", function () { return $bb89d7c8ecc2992e$export$2e2bcd8739ae039; });
$parcel$export($db55dff1757face0$exports, "eventListeners", function () { return $c229d887e47c53dc$export$2e2bcd8739ae039; });
$parcel$export($db55dff1757face0$exports, "flip", function () { return $c0a2e9c5e59d97bb$export$2e2bcd8739ae039; });
$parcel$export($db55dff1757face0$exports, "hide", function () { return $344a01ad88fb3066$export$2e2bcd8739ae039; });
$parcel$export($db55dff1757face0$exports, "offset", function () { return $ed29c1414e9a2913$export$2e2bcd8739ae039; });
$parcel$export($db55dff1757face0$exports, "popperOffsets", function () { return $c4db4592a4e75418$export$2e2bcd8739ae039; });
$parcel$export($db55dff1757face0$exports, "preventOverflow", function () { return $6888318a531de88c$export$2e2bcd8739ae039; });
function $3789d4083501b3d6$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $23c7b9ba26a4727b$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $0b914caf24218936$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $23c7b9ba26a4727b$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $0b914caf24218936$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $23c7b9ba26a4727b$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $0b914caf24218936$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $23c7b9ba26a4727b$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $6e2d9c54aef83e8d$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $0b914caf24218936$export$1b3bfaa9684536aa)(element) || !(0, $3789d4083501b3d6$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $6e2d9c54aef83e8d$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $0b914caf24218936$export$1b3bfaa9684536aa)(element) || !(0, $3789d4083501b3d6$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $6e2d9c54aef83e8d$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $6e2d9c54aef83e8d$var$applyStyles,
    effect: $6e2d9c54aef83e8d$var$effect,
    requires: [
        "computeStyles"
    ]
};



function $eb8572d92f8eda98$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}



var $eaab23197938c54d$export$8960430cfd85939f = Math.max;
var $eaab23197938c54d$export$96ec731ed4dcb222 = Math.min;
var $eaab23197938c54d$export$2077e0241d6afd3c = Math.round;



function $89455cf04c857218$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $f69c112a03e52974$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $89455cf04c857218$export$2e2bcd8739ae039)());
}


function $d3782b8b409a4e03$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $0b914caf24218936$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $eaab23197938c54d$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $eaab23197938c54d$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $0b914caf24218936$export$45a5e7f76e0caa8d)(element) ? (0, $23c7b9ba26a4727b$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $f69c112a03e52974$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $6539f691330a105d$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $d3782b8b409a4e03$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $c9a4c4dd4ced4c52$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $0b914caf24218936$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $92e82e108612de62$export$2e2bcd8739ae039(element) {
    return (0, $23c7b9ba26a4727b$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $e8c4dff81b8443ef$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $3789d4083501b3d6$export$2e2bcd8739ae039)(element)) >= 0;
}




function $47a5c663cd7e1066$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $0b914caf24218936$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $c1c5b6268b3f1d4b$export$2e2bcd8739ae039(element) {
    if ((0, $3789d4083501b3d6$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $0b914caf24218936$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $47a5c663cd7e1066$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $d5d6de7f673c3f55$var$getTrueOffsetParent(element) {
    if (!(0, $0b914caf24218936$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $92e82e108612de62$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $d5d6de7f673c3f55$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $89455cf04c857218$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $89455cf04c857218$export$2e2bcd8739ae039)());
    if (isIE && (0, $0b914caf24218936$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $92e82e108612de62$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $c1c5b6268b3f1d4b$export$2e2bcd8739ae039)(element);
    if ((0, $0b914caf24218936$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $0b914caf24218936$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $3789d4083501b3d6$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $92e82e108612de62$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $d5d6de7f673c3f55$export$2e2bcd8739ae039(element) {
    var window = (0, $23c7b9ba26a4727b$export$2e2bcd8739ae039)(element);
    var offsetParent = $d5d6de7f673c3f55$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $e8c4dff81b8443ef$export$2e2bcd8739ae039)(offsetParent) && (0, $92e82e108612de62$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $d5d6de7f673c3f55$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3789d4083501b3d6$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $3789d4083501b3d6$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $92e82e108612de62$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $d5d6de7f673c3f55$var$getContainingBlock(element) || window;
}


function $74a567c1de35c4e5$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $33cf94e9e02608bc$export$f28d906d67a997f3(min, value, max) {
    return (0, $eaab23197938c54d$export$8960430cfd85939f)(min, (0, $eaab23197938c54d$export$96ec731ed4dcb222)(value, max));
}
function $33cf94e9e02608bc$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $33cf94e9e02608bc$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $dbe567f953bde93c$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $e01a8fc10bd7f73f$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $dbe567f953bde93c$export$2e2bcd8739ae039)(), paddingObject);
}


function $0f581d2285853b3a$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $5dade89d82270f44$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $e01a8fc10bd7f73f$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $0f581d2285853b3a$export$2e2bcd8739ae039)(padding, (0, $37abd1a1aec69ebe$export$aec2ce47c367b8c3)));
};
function $5dade89d82270f44$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $eb8572d92f8eda98$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $74a567c1de35c4e5$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $37abd1a1aec69ebe$export$eabcd2c8791e7bf4),
        (0, $37abd1a1aec69ebe$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $5dade89d82270f44$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $6539f691330a105d$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $37abd1a1aec69ebe$export$1e95b668f3b82d) : (0, $37abd1a1aec69ebe$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $37abd1a1aec69ebe$export$40e543e69a8b3fbb) : (0, $37abd1a1aec69ebe$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $d5d6de7f673c3f55$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $33cf94e9e02608bc$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $5dade89d82270f44$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $c9a4c4dd4ced4c52$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $5dade89d82270f44$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $5dade89d82270f44$var$arrow,
    effect: $5dade89d82270f44$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $1170d6e7939b10fb$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $bb89d7c8ecc2992e$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $bb89d7c8ecc2992e$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $eaab23197938c54d$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $eaab23197938c54d$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $bb89d7c8ecc2992e$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $37abd1a1aec69ebe$export$eabcd2c8791e7bf4);
    var sideY = (0, $37abd1a1aec69ebe$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $d5d6de7f673c3f55$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $23c7b9ba26a4727b$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $47a5c663cd7e1066$export$2e2bcd8739ae039)(popper);
            if ((0, $92e82e108612de62$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $37abd1a1aec69ebe$export$1e95b668f3b82d) || (placement === (0, $37abd1a1aec69ebe$export$eabcd2c8791e7bf4) || placement === (0, $37abd1a1aec69ebe$export$79ffe56a765070d2)) && variation === (0, $37abd1a1aec69ebe$export$bd5df0f255a350f8)) {
            sideY = (0, $37abd1a1aec69ebe$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $37abd1a1aec69ebe$export$eabcd2c8791e7bf4) || (placement === (0, $37abd1a1aec69ebe$export$1e95b668f3b82d) || placement === (0, $37abd1a1aec69ebe$export$40e543e69a8b3fbb)) && variation === (0, $37abd1a1aec69ebe$export$bd5df0f255a350f8)) {
            sideX = (0, $37abd1a1aec69ebe$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $bb89d7c8ecc2992e$var$unsetSides);
    var _ref4 = roundOffsets === true ? $bb89d7c8ecc2992e$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $23c7b9ba26a4727b$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $bb89d7c8ecc2992e$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $eb8572d92f8eda98$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $1170d6e7939b10fb$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $bb89d7c8ecc2992e$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $bb89d7c8ecc2992e$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $bb89d7c8ecc2992e$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $bb89d7c8ecc2992e$var$computeStyles,
    data: {}
};



var $c229d887e47c53dc$var$passive = {
    passive: true
};
function $c229d887e47c53dc$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $23c7b9ba26a4727b$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $c229d887e47c53dc$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $c229d887e47c53dc$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $c229d887e47c53dc$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $c229d887e47c53dc$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $c229d887e47c53dc$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $c229d887e47c53dc$var$effect,
    data: {}
};


var $33073f1c745ccb52$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $33073f1c745ccb52$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $33073f1c745ccb52$var$hash[matched];
    });
}



var $060827449093cba1$var$hash = {
    start: "end",
    end: "start"
};
function $060827449093cba1$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $060827449093cba1$var$hash[matched];
    });
}








function $1906d1315d22566c$export$2e2bcd8739ae039(node) {
    var win = (0, $23c7b9ba26a4727b$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $f6eeabbfd4a449dd$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $d3782b8b409a4e03$export$2e2bcd8739ae039)((0, $47a5c663cd7e1066$export$2e2bcd8739ae039)(element)).left + (0, $1906d1315d22566c$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $3a3389daccd6a8ad$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $23c7b9ba26a4727b$export$2e2bcd8739ae039)(element);
    var html = (0, $47a5c663cd7e1066$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $f69c112a03e52974$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $f6eeabbfd4a449dd$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a2ae24d3886c747b$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $47a5c663cd7e1066$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $1906d1315d22566c$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $eaab23197938c54d$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $eaab23197938c54d$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $f6eeabbfd4a449dd$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $92e82e108612de62$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $eaab23197938c54d$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $133489cd1ed3036a$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $92e82e108612de62$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $ed273e447e8bc36b$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $3789d4083501b3d6$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $0b914caf24218936$export$1b3bfaa9684536aa)(node) && (0, $133489cd1ed3036a$export$2e2bcd8739ae039)(node)) return node;
    return $ed273e447e8bc36b$export$2e2bcd8739ae039((0, $c1c5b6268b3f1d4b$export$2e2bcd8739ae039)(node));
}





function $822aa6290f8b95c0$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $ed273e447e8bc36b$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $23c7b9ba26a4727b$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $133489cd1ed3036a$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($822aa6290f8b95c0$export$2e2bcd8739ae039((0, $c1c5b6268b3f1d4b$export$2e2bcd8739ae039)(target)));
}










function $c030c8901b473c09$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $beb055a5191f6a67$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $d3782b8b409a4e03$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $beb055a5191f6a67$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $37abd1a1aec69ebe$export$d7b7311ec04a3e8f) ? (0, $c030c8901b473c09$export$2e2bcd8739ae039)((0, $3a3389daccd6a8ad$export$2e2bcd8739ae039)(element, strategy)) : (0, $0b914caf24218936$export$45a5e7f76e0caa8d)(clippingParent) ? $beb055a5191f6a67$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $c030c8901b473c09$export$2e2bcd8739ae039)((0, $a2ae24d3886c747b$export$2e2bcd8739ae039)((0, $47a5c663cd7e1066$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $beb055a5191f6a67$var$getClippingParents(element) {
    var clippingParents = (0, $822aa6290f8b95c0$export$2e2bcd8739ae039)((0, $c1c5b6268b3f1d4b$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $92e82e108612de62$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $0b914caf24218936$export$1b3bfaa9684536aa)(element) ? (0, $d5d6de7f673c3f55$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $0b914caf24218936$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $0b914caf24218936$export$45a5e7f76e0caa8d)(clippingParent) && (0, $c9a4c4dd4ced4c52$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $3789d4083501b3d6$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $beb055a5191f6a67$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $beb055a5191f6a67$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $beb055a5191f6a67$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $eaab23197938c54d$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $eaab23197938c54d$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $eaab23197938c54d$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $eaab23197938c54d$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $beb055a5191f6a67$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $7c63fabffb8f2d95$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $eb8572d92f8eda98$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $1170d6e7939b10fb$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $37abd1a1aec69ebe$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $37abd1a1aec69ebe$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $37abd1a1aec69ebe$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $37abd1a1aec69ebe$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $74a567c1de35c4e5$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $37abd1a1aec69ebe$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $37abd1a1aec69ebe$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $086c770dfd92987c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $37abd1a1aec69ebe$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $37abd1a1aec69ebe$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $37abd1a1aec69ebe$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $e01a8fc10bd7f73f$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $0f581d2285853b3a$export$2e2bcd8739ae039)(padding, (0, $37abd1a1aec69ebe$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $37abd1a1aec69ebe$export$ae5ab1c730825774) ? (0, $37abd1a1aec69ebe$export$ca50aac9f3ba507f) : (0, $37abd1a1aec69ebe$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $beb055a5191f6a67$export$2e2bcd8739ae039)((0, $0b914caf24218936$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $47a5c663cd7e1066$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $d3782b8b409a4e03$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $7c63fabffb8f2d95$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $c030c8901b473c09$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $37abd1a1aec69ebe$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $37abd1a1aec69ebe$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $37abd1a1aec69ebe$export$79ffe56a765070d2),
                (0, $37abd1a1aec69ebe$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $37abd1a1aec69ebe$export$1e95b668f3b82d),
                (0, $37abd1a1aec69ebe$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $1d5e404e04ce46cc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $37abd1a1aec69ebe$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $1170d6e7939b10fb$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $37abd1a1aec69ebe$export$368f9a87e87fa4e1) : (0, $37abd1a1aec69ebe$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $1170d6e7939b10fb$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $37abd1a1aec69ebe$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $086c770dfd92987c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $eb8572d92f8eda98$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $c0a2e9c5e59d97bb$var$getExpandedFallbackPlacements(placement) {
    if ((0, $eb8572d92f8eda98$export$2e2bcd8739ae039)(placement) === (0, $37abd1a1aec69ebe$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $33073f1c745ccb52$export$2e2bcd8739ae039)(placement);
    return [
        (0, $060827449093cba1$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $060827449093cba1$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $c0a2e9c5e59d97bb$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $eb8572d92f8eda98$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $33073f1c745ccb52$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $c0a2e9c5e59d97bb$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $eb8572d92f8eda98$export$2e2bcd8739ae039)(placement) === (0, $37abd1a1aec69ebe$export$dfb5619354ba860) ? (0, $1d5e404e04ce46cc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $eb8572d92f8eda98$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $1170d6e7939b10fb$export$2e2bcd8739ae039)(placement) === (0, $37abd1a1aec69ebe$export$b3571188c770cc5a);
        var isVertical = [
            (0, $37abd1a1aec69ebe$export$1e95b668f3b82d),
            (0, $37abd1a1aec69ebe$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $086c770dfd92987c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $37abd1a1aec69ebe$export$79ffe56a765070d2) : (0, $37abd1a1aec69ebe$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $37abd1a1aec69ebe$export$40e543e69a8b3fbb) : (0, $37abd1a1aec69ebe$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $33073f1c745ccb52$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $33073f1c745ccb52$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $c0a2e9c5e59d97bb$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $c0a2e9c5e59d97bb$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $344a01ad88fb3066$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $344a01ad88fb3066$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $37abd1a1aec69ebe$export$1e95b668f3b82d),
        (0, $37abd1a1aec69ebe$export$79ffe56a765070d2),
        (0, $37abd1a1aec69ebe$export$40e543e69a8b3fbb),
        (0, $37abd1a1aec69ebe$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $344a01ad88fb3066$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $086c770dfd92987c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $086c770dfd92987c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $344a01ad88fb3066$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $344a01ad88fb3066$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $344a01ad88fb3066$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $344a01ad88fb3066$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $344a01ad88fb3066$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $344a01ad88fb3066$var$hide
};




function $ed29c1414e9a2913$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $eb8572d92f8eda98$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $37abd1a1aec69ebe$export$eabcd2c8791e7bf4),
        (0, $37abd1a1aec69ebe$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $37abd1a1aec69ebe$export$eabcd2c8791e7bf4),
        (0, $37abd1a1aec69ebe$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ed29c1414e9a2913$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $37abd1a1aec69ebe$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ed29c1414e9a2913$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ed29c1414e9a2913$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ed29c1414e9a2913$var$offset
};



function $c4db4592a4e75418$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $7c63fabffb8f2d95$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c4db4592a4e75418$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $c4db4592a4e75418$var$popperOffsets,
    data: {}
};





function $1bea5d9e5d1c3c1f$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $6888318a531de88c$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $086c770dfd92987c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $eb8572d92f8eda98$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $1170d6e7939b10fb$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $74a567c1de35c4e5$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $1bea5d9e5d1c3c1f$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $37abd1a1aec69ebe$export$1e95b668f3b82d) : (0, $37abd1a1aec69ebe$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $37abd1a1aec69ebe$export$40e543e69a8b3fbb) : (0, $37abd1a1aec69ebe$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $37abd1a1aec69ebe$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $37abd1a1aec69ebe$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $6539f691330a105d$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $dbe567f953bde93c$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $33cf94e9e02608bc$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $d5d6de7f673c3f55$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $33cf94e9e02608bc$export$f28d906d67a997f3)(tether ? (0, $eaab23197938c54d$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $eaab23197938c54d$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $37abd1a1aec69ebe$export$1e95b668f3b82d) : (0, $37abd1a1aec69ebe$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $37abd1a1aec69ebe$export$40e543e69a8b3fbb) : (0, $37abd1a1aec69ebe$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $37abd1a1aec69ebe$export$1e95b668f3b82d),
            (0, $37abd1a1aec69ebe$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $33cf94e9e02608bc$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $33cf94e9e02608bc$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $6888318a531de88c$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $6888318a531de88c$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};








function $bd3061cd624598ca$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $fcf191d94c9f3204$export$2e2bcd8739ae039(node) {
    if (node === (0, $23c7b9ba26a4727b$export$2e2bcd8739ae039)(node) || !(0, $0b914caf24218936$export$1b3bfaa9684536aa)(node)) return (0, $1906d1315d22566c$export$2e2bcd8739ae039)(node);
    else return (0, $bd3061cd624598ca$export$2e2bcd8739ae039)(node);
}








function $10ca06a60a9ab274$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $eaab23197938c54d$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $eaab23197938c54d$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $10ca06a60a9ab274$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $0b914caf24218936$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $0b914caf24218936$export$1b3bfaa9684536aa)(offsetParent) && $10ca06a60a9ab274$var$isElementScaled(offsetParent);
    var documentElement = (0, $47a5c663cd7e1066$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $d3782b8b409a4e03$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3789d4083501b3d6$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $133489cd1ed3036a$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $fcf191d94c9f3204$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $0b914caf24218936$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $d3782b8b409a4e03$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $f6eeabbfd4a449dd$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $b6b2919090a43c0b$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $b6b2919090a43c0b$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $b6b2919090a43c0b$var$order(modifiers); // order based on phase
    return (0, $37abd1a1aec69ebe$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $6feebcc046862b35$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $4b55ac0654d185b9$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $ce15fd4ee324a266$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $ce15fd4ee324a266$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $ce15fd4ee324a266$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $ce15fd4ee324a266$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $ce15fd4ee324a266$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $0b914caf24218936$export$45a5e7f76e0caa8d)(reference) ? (0, $822aa6290f8b95c0$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $822aa6290f8b95c0$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $822aa6290f8b95c0$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $b6b2919090a43c0b$export$2e2bcd8739ae039)((0, $4b55ac0654d185b9$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$ce15fd4ee324a266$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $10ca06a60a9ab274$export$2e2bcd8739ae039)(reference, (0, $d5d6de7f673c3f55$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $6539f691330a105d$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6feebcc046862b35$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$ce15fd4ee324a266$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $ce15fd4ee324a266$export$8f7491d57c8f97a9 = /*#__PURE__*/ $ce15fd4ee324a266$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $19c7ba5e80710f89$export$d34966752335dd47 = [
    (0, $c229d887e47c53dc$export$2e2bcd8739ae039),
    (0, $c4db4592a4e75418$export$2e2bcd8739ae039),
    (0, $bb89d7c8ecc2992e$export$2e2bcd8739ae039),
    (0, $6e2d9c54aef83e8d$export$2e2bcd8739ae039),
    (0, $ed29c1414e9a2913$export$2e2bcd8739ae039),
    (0, $c0a2e9c5e59d97bb$export$2e2bcd8739ae039),
    (0, $6888318a531de88c$export$2e2bcd8739ae039),
    (0, $5dade89d82270f44$export$2e2bcd8739ae039),
    (0, $344a01ad88fb3066$export$2e2bcd8739ae039)
];
var $19c7ba5e80710f89$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $ce15fd4ee324a266$export$ed5e13716264f202)({
    defaultModifiers: $19c7ba5e80710f89$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $3523020281cc2339$export$d34966752335dd47 = [
    (0, $c229d887e47c53dc$export$2e2bcd8739ae039),
    (0, $c4db4592a4e75418$export$2e2bcd8739ae039),
    (0, $bb89d7c8ecc2992e$export$2e2bcd8739ae039),
    (0, $6e2d9c54aef83e8d$export$2e2bcd8739ae039)
];
var $3523020281cc2339$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $ce15fd4ee324a266$export$ed5e13716264f202)({
    defaultModifiers: $3523020281cc2339$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($2415630f543121c4$exports, $37abd1a1aec69ebe$exports);
$parcel$exportWildcard($2415630f543121c4$exports, $db55dff1757face0$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$elementMap = new Map();
const $586b16fccafeb372$var$Data = {
    set (element, key, instance) {
        if (!$586b16fccafeb372$var$elementMap.has(element)) $586b16fccafeb372$var$elementMap.set(element, new Map());
        const instanceMap = $586b16fccafeb372$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($586b16fccafeb372$var$elementMap.has(element)) return $586b16fccafeb372$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$586b16fccafeb372$var$elementMap.has(element)) return;
        const instanceMap = $586b16fccafeb372$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $586b16fccafeb372$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $586b16fccafeb372$var$MAX_UID = 1000000;
const $586b16fccafeb372$var$MILLISECONDS_MULTIPLIER = 1000;
const $586b16fccafeb372$var$TRANSITION_END = "transitionend";
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $586b16fccafeb372$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $586b16fccafeb372$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $586b16fccafeb372$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $586b16fccafeb372$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $586b16fccafeb372$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $586b16fccafeb372$var$MILLISECONDS_MULTIPLIER;
};
const $586b16fccafeb372$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($586b16fccafeb372$var$TRANSITION_END));
};
const $586b16fccafeb372$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $586b16fccafeb372$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($586b16fccafeb372$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector($586b16fccafeb372$var$parseSelector(object));
    return null;
};
const $586b16fccafeb372$var$isVisible = (element)=>{
    if (!$586b16fccafeb372$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $586b16fccafeb372$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const $586b16fccafeb372$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $586b16fccafeb372$var$findShadowRoot(element.parentNode);
};
const $586b16fccafeb372$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $586b16fccafeb372$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $586b16fccafeb372$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const $586b16fccafeb372$var$DOMContentLoadedCallbacks = [];
const $586b16fccafeb372$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!$586b16fccafeb372$var$DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of $586b16fccafeb372$var$DOMContentLoadedCallbacks)callback();
        });
        $586b16fccafeb372$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $586b16fccafeb372$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $586b16fccafeb372$var$defineJQueryPlugin = (plugin)=>{
    $586b16fccafeb372$var$onDOMContentLoaded(()=>{
        const $ = $586b16fccafeb372$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $586b16fccafeb372$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
};
const $586b16fccafeb372$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $586b16fccafeb372$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $586b16fccafeb372$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($586b16fccafeb372$var$TRANSITION_END, handler);
        $586b16fccafeb372$var$execute(callback);
    };
    transitionElement.addEventListener($586b16fccafeb372$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $586b16fccafeb372$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $586b16fccafeb372$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $586b16fccafeb372$var$stripNameRegex = /\..*/;
const $586b16fccafeb372$var$stripUidRegex = /::\d+$/;
const $586b16fccafeb372$var$eventRegistry = {}; // Events storage
let $586b16fccafeb372$var$uidEvent = 1;
const $586b16fccafeb372$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $586b16fccafeb372$var$nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function $586b16fccafeb372$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$586b16fccafeb372$var$uidEvent++}` || element.uidEvent || $586b16fccafeb372$var$uidEvent++;
}
function $586b16fccafeb372$var$getElementEvents(element) {
    const uid = $586b16fccafeb372$var$makeEventUid(element);
    element.uidEvent = uid;
    $586b16fccafeb372$var$eventRegistry[uid] = $586b16fccafeb372$var$eventRegistry[uid] || {};
    return $586b16fccafeb372$var$eventRegistry[uid];
}
function $586b16fccafeb372$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $586b16fccafeb372$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $586b16fccafeb372$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $586b16fccafeb372$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $586b16fccafeb372$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $586b16fccafeb372$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $586b16fccafeb372$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $586b16fccafeb372$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $586b16fccafeb372$var$getTypeEvent(originalTypeEvent);
    if (!$586b16fccafeb372$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $586b16fccafeb372$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = $586b16fccafeb372$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $586b16fccafeb372$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $586b16fccafeb372$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $586b16fccafeb372$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $586b16fccafeb372$var$makeEventUid(callable, originalTypeEvent.replace($586b16fccafeb372$var$namespaceRegex, ""));
    const fn = isDelegated ? $586b16fccafeb372$var$bootstrapDelegationHandler(element, handler, callable) : $586b16fccafeb372$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $586b16fccafeb372$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $586b16fccafeb372$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $586b16fccafeb372$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $586b16fccafeb372$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $586b16fccafeb372$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($586b16fccafeb372$var$stripNameRegex, "");
    return $586b16fccafeb372$var$customEvents[event] || event;
}
const $586b16fccafeb372$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $586b16fccafeb372$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $586b16fccafeb372$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = $586b16fccafeb372$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $586b16fccafeb372$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $586b16fccafeb372$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$586b16fccafeb372$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($586b16fccafeb372$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $586b16fccafeb372$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = $586b16fccafeb372$var$getjQuery();
        const typeEvent = $586b16fccafeb372$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $586b16fccafeb372$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $586b16fccafeb372$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $586b16fccafeb372$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $586b16fccafeb372$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $586b16fccafeb372$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$586b16fccafeb372$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$586b16fccafeb372$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $586b16fccafeb372$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $586b16fccafeb372$var$normalizeData(element.getAttribute(`data-bs-${$586b16fccafeb372$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $586b16fccafeb372$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $586b16fccafeb372$var$isElement(element) ? $586b16fccafeb372$var$Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$586b16fccafeb372$var$isElement(element) ? $586b16fccafeb372$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $586b16fccafeb372$var$isElement(value) ? "element" : $586b16fccafeb372$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$VERSION = "5.3.3";
/**
 * Class definition
 */ class $586b16fccafeb372$var$BaseComponent extends $586b16fccafeb372$var$Config {
    constructor(element, config){
        super();
        element = $586b16fccafeb372$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $586b16fccafeb372$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $586b16fccafeb372$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $586b16fccafeb372$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $586b16fccafeb372$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $586b16fccafeb372$var$Data.get($586b16fccafeb372$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $586b16fccafeb372$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $586b16fccafeb372$var$getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href");
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(",").map((sel)=>$586b16fccafeb372$var$parseSelector(sel)).join(",") : null;
};
const $586b16fccafeb372$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!$586b16fccafeb372$var$isDisabled(el) && $586b16fccafeb372$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $586b16fccafeb372$var$getSelector(element);
        if (selector) return $586b16fccafeb372$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $586b16fccafeb372$var$getSelector(element);
        return selector ? $586b16fccafeb372$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $586b16fccafeb372$var$getSelector(element);
        return selector ? $586b16fccafeb372$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $586b16fccafeb372$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $586b16fccafeb372$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($586b16fccafeb372$var$isDisabled(this)) return;
        const target = $586b16fccafeb372$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$f = "alert";
const $586b16fccafeb372$var$DATA_KEY$a = "bs.alert";
const $586b16fccafeb372$var$EVENT_KEY$b = `.${$586b16fccafeb372$var$DATA_KEY$a}`;
const $586b16fccafeb372$var$EVENT_CLOSE = `close${$586b16fccafeb372$var$EVENT_KEY$b}`;
const $586b16fccafeb372$var$EVENT_CLOSED = `closed${$586b16fccafeb372$var$EVENT_KEY$b}`;
const $586b16fccafeb372$var$CLASS_NAME_FADE$5 = "fade";
const $586b16fccafeb372$var$CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class $586b16fccafeb372$export$caec2af78bcc877f extends $586b16fccafeb372$var$BaseComponent {
    // Getters
    static get NAME() {
        return $586b16fccafeb372$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($586b16fccafeb372$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($586b16fccafeb372$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $586b16fccafeb372$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $586b16fccafeb372$var$enableDismissTrigger($586b16fccafeb372$export$caec2af78bcc877f, "close");
/**
 * jQuery
 */ $586b16fccafeb372$var$defineJQueryPlugin($586b16fccafeb372$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$e = "button";
const $586b16fccafeb372$var$DATA_KEY$9 = "bs.button";
const $586b16fccafeb372$var$EVENT_KEY$a = `.${$586b16fccafeb372$var$DATA_KEY$9}`;
const $586b16fccafeb372$var$DATA_API_KEY$6 = ".data-api";
const $586b16fccafeb372$var$CLASS_NAME_ACTIVE$3 = "active";
const $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $586b16fccafeb372$var$EVENT_CLICK_DATA_API$6 = `click${$586b16fccafeb372$var$EVENT_KEY$a}${$586b16fccafeb372$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $586b16fccafeb372$export$353f5b6fc5456de1 extends $586b16fccafeb372$var$BaseComponent {
    // Getters
    static get NAME() {
        return $586b16fccafeb372$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($586b16fccafeb372$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $586b16fccafeb372$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $586b16fccafeb372$var$EventHandler.on(document, $586b16fccafeb372$var$EVENT_CLICK_DATA_API$6, $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$5);
    const data = $586b16fccafeb372$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $586b16fccafeb372$var$defineJQueryPlugin($586b16fccafeb372$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$d = "swipe";
const $586b16fccafeb372$var$EVENT_KEY$9 = ".bs.swipe";
const $586b16fccafeb372$var$EVENT_TOUCHSTART = `touchstart${$586b16fccafeb372$var$EVENT_KEY$9}`;
const $586b16fccafeb372$var$EVENT_TOUCHMOVE = `touchmove${$586b16fccafeb372$var$EVENT_KEY$9}`;
const $586b16fccafeb372$var$EVENT_TOUCHEND = `touchend${$586b16fccafeb372$var$EVENT_KEY$9}`;
const $586b16fccafeb372$var$EVENT_POINTERDOWN = `pointerdown${$586b16fccafeb372$var$EVENT_KEY$9}`;
const $586b16fccafeb372$var$EVENT_POINTERUP = `pointerup${$586b16fccafeb372$var$EVENT_KEY$9}`;
const $586b16fccafeb372$var$POINTER_TYPE_TOUCH = "touch";
const $586b16fccafeb372$var$POINTER_TYPE_PEN = "pen";
const $586b16fccafeb372$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $586b16fccafeb372$var$SWIPE_THRESHOLD = 40;
const $586b16fccafeb372$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $586b16fccafeb372$var$DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class $586b16fccafeb372$var$Swipe extends $586b16fccafeb372$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$586b16fccafeb372$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $586b16fccafeb372$var$Default$c;
    }
    static get DefaultType() {
        return $586b16fccafeb372$var$DefaultType$c;
    }
    static get NAME() {
        return $586b16fccafeb372$var$NAME$d;
    }
    // Public
    dispose() {
        $586b16fccafeb372$var$EventHandler.off(this._element, $586b16fccafeb372$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $586b16fccafeb372$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $586b16fccafeb372$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $586b16fccafeb372$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $586b16fccafeb372$var$POINTER_TYPE_PEN || event.pointerType === $586b16fccafeb372$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$c = "carousel";
const $586b16fccafeb372$var$DATA_KEY$8 = "bs.carousel";
const $586b16fccafeb372$var$EVENT_KEY$8 = `.${$586b16fccafeb372$var$DATA_KEY$8}`;
const $586b16fccafeb372$var$DATA_API_KEY$5 = ".data-api";
const $586b16fccafeb372$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $586b16fccafeb372$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $586b16fccafeb372$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $586b16fccafeb372$var$ORDER_NEXT = "next";
const $586b16fccafeb372$var$ORDER_PREV = "prev";
const $586b16fccafeb372$var$DIRECTION_LEFT = "left";
const $586b16fccafeb372$var$DIRECTION_RIGHT = "right";
const $586b16fccafeb372$var$EVENT_SLIDE = `slide${$586b16fccafeb372$var$EVENT_KEY$8}`;
const $586b16fccafeb372$var$EVENT_SLID = `slid${$586b16fccafeb372$var$EVENT_KEY$8}`;
const $586b16fccafeb372$var$EVENT_KEYDOWN$1 = `keydown${$586b16fccafeb372$var$EVENT_KEY$8}`;
const $586b16fccafeb372$var$EVENT_MOUSEENTER$1 = `mouseenter${$586b16fccafeb372$var$EVENT_KEY$8}`;
const $586b16fccafeb372$var$EVENT_MOUSELEAVE$1 = `mouseleave${$586b16fccafeb372$var$EVENT_KEY$8}`;
const $586b16fccafeb372$var$EVENT_DRAG_START = `dragstart${$586b16fccafeb372$var$EVENT_KEY$8}`;
const $586b16fccafeb372$var$EVENT_LOAD_DATA_API$3 = `load${$586b16fccafeb372$var$EVENT_KEY$8}${$586b16fccafeb372$var$DATA_API_KEY$5}`;
const $586b16fccafeb372$var$EVENT_CLICK_DATA_API$5 = `click${$586b16fccafeb372$var$EVENT_KEY$8}${$586b16fccafeb372$var$DATA_API_KEY$5}`;
const $586b16fccafeb372$var$CLASS_NAME_CAROUSEL = "carousel";
const $586b16fccafeb372$var$CLASS_NAME_ACTIVE$2 = "active";
const $586b16fccafeb372$var$CLASS_NAME_SLIDE = "slide";
const $586b16fccafeb372$var$CLASS_NAME_END = "carousel-item-end";
const $586b16fccafeb372$var$CLASS_NAME_START = "carousel-item-start";
const $586b16fccafeb372$var$CLASS_NAME_NEXT = "carousel-item-next";
const $586b16fccafeb372$var$CLASS_NAME_PREV = "carousel-item-prev";
const $586b16fccafeb372$var$SELECTOR_ACTIVE = ".active";
const $586b16fccafeb372$var$SELECTOR_ITEM = ".carousel-item";
const $586b16fccafeb372$var$SELECTOR_ACTIVE_ITEM = $586b16fccafeb372$var$SELECTOR_ACTIVE + $586b16fccafeb372$var$SELECTOR_ITEM;
const $586b16fccafeb372$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $586b16fccafeb372$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $586b16fccafeb372$var$SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const $586b16fccafeb372$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $586b16fccafeb372$var$KEY_TO_DIRECTION = {
    [$586b16fccafeb372$var$ARROW_LEFT_KEY$1]: $586b16fccafeb372$var$DIRECTION_RIGHT,
    [$586b16fccafeb372$var$ARROW_RIGHT_KEY$1]: $586b16fccafeb372$var$DIRECTION_LEFT
};
const $586b16fccafeb372$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $586b16fccafeb372$var$DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class $586b16fccafeb372$export$144901db2ea8e967 extends $586b16fccafeb372$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $586b16fccafeb372$var$SelectorEngine.findOne($586b16fccafeb372$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $586b16fccafeb372$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $586b16fccafeb372$var$Default$b;
    }
    static get DefaultType() {
        return $586b16fccafeb372$var$DefaultType$b;
    }
    static get NAME() {
        return $586b16fccafeb372$var$NAME$c;
    }
    // Public
    next() {
        this._slide($586b16fccafeb372$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $586b16fccafeb372$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($586b16fccafeb372$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $586b16fccafeb372$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $586b16fccafeb372$var$EventHandler.one(this._element, $586b16fccafeb372$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $586b16fccafeb372$var$EventHandler.one(this._element, $586b16fccafeb372$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $586b16fccafeb372$var$ORDER_NEXT : $586b16fccafeb372$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $586b16fccafeb372$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $586b16fccafeb372$var$SelectorEngine.find($586b16fccafeb372$var$SELECTOR_ITEM_IMG, this._element))$586b16fccafeb372$var$EventHandler.on(img, $586b16fccafeb372$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $586b16fccafeb372$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($586b16fccafeb372$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($586b16fccafeb372$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $586b16fccafeb372$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $586b16fccafeb372$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $586b16fccafeb372$var$SelectorEngine.findOne($586b16fccafeb372$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($586b16fccafeb372$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $586b16fccafeb372$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($586b16fccafeb372$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $586b16fccafeb372$var$ORDER_NEXT;
        const nextElement = element || $586b16fccafeb372$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $586b16fccafeb372$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($586b16fccafeb372$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $586b16fccafeb372$var$CLASS_NAME_START : $586b16fccafeb372$var$CLASS_NAME_END;
        const orderClassName = isNext ? $586b16fccafeb372$var$CLASS_NAME_NEXT : $586b16fccafeb372$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $586b16fccafeb372$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($586b16fccafeb372$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($586b16fccafeb372$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($586b16fccafeb372$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($586b16fccafeb372$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $586b16fccafeb372$var$SelectorEngine.findOne($586b16fccafeb372$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $586b16fccafeb372$var$SelectorEngine.find($586b16fccafeb372$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($586b16fccafeb372$var$isRTL()) return direction === $586b16fccafeb372$var$DIRECTION_LEFT ? $586b16fccafeb372$var$ORDER_PREV : $586b16fccafeb372$var$ORDER_NEXT;
        return direction === $586b16fccafeb372$var$DIRECTION_LEFT ? $586b16fccafeb372$var$ORDER_NEXT : $586b16fccafeb372$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($586b16fccafeb372$var$isRTL()) return order === $586b16fccafeb372$var$ORDER_PREV ? $586b16fccafeb372$var$DIRECTION_LEFT : $586b16fccafeb372$var$DIRECTION_RIGHT;
        return order === $586b16fccafeb372$var$ORDER_PREV ? $586b16fccafeb372$var$DIRECTION_RIGHT : $586b16fccafeb372$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $586b16fccafeb372$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $586b16fccafeb372$var$EventHandler.on(document, $586b16fccafeb372$var$EVENT_CLICK_DATA_API$5, $586b16fccafeb372$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $586b16fccafeb372$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($586b16fccafeb372$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $586b16fccafeb372$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($586b16fccafeb372$var$Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$586b16fccafeb372$var$EventHandler.on(window, $586b16fccafeb372$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $586b16fccafeb372$var$SelectorEngine.find($586b16fccafeb372$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$586b16fccafeb372$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $586b16fccafeb372$var$defineJQueryPlugin($586b16fccafeb372$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$b = "collapse";
const $586b16fccafeb372$var$DATA_KEY$7 = "bs.collapse";
const $586b16fccafeb372$var$EVENT_KEY$7 = `.${$586b16fccafeb372$var$DATA_KEY$7}`;
const $586b16fccafeb372$var$DATA_API_KEY$4 = ".data-api";
const $586b16fccafeb372$var$EVENT_SHOW$6 = `show${$586b16fccafeb372$var$EVENT_KEY$7}`;
const $586b16fccafeb372$var$EVENT_SHOWN$6 = `shown${$586b16fccafeb372$var$EVENT_KEY$7}`;
const $586b16fccafeb372$var$EVENT_HIDE$6 = `hide${$586b16fccafeb372$var$EVENT_KEY$7}`;
const $586b16fccafeb372$var$EVENT_HIDDEN$6 = `hidden${$586b16fccafeb372$var$EVENT_KEY$7}`;
const $586b16fccafeb372$var$EVENT_CLICK_DATA_API$4 = `click${$586b16fccafeb372$var$EVENT_KEY$7}${$586b16fccafeb372$var$DATA_API_KEY$4}`;
const $586b16fccafeb372$var$CLASS_NAME_SHOW$7 = "show";
const $586b16fccafeb372$var$CLASS_NAME_COLLAPSE = "collapse";
const $586b16fccafeb372$var$CLASS_NAME_COLLAPSING = "collapsing";
const $586b16fccafeb372$var$CLASS_NAME_COLLAPSED = "collapsed";
const $586b16fccafeb372$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$586b16fccafeb372$var$CLASS_NAME_COLLAPSE} .${$586b16fccafeb372$var$CLASS_NAME_COLLAPSE}`;
const $586b16fccafeb372$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $586b16fccafeb372$var$WIDTH = "width";
const $586b16fccafeb372$var$HEIGHT = "height";
const $586b16fccafeb372$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $586b16fccafeb372$var$Default$a = {
    parent: null,
    toggle: true
};
const $586b16fccafeb372$var$DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class $586b16fccafeb372$export$78768a9af065a7b extends $586b16fccafeb372$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $586b16fccafeb372$var$SelectorEngine.find($586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $586b16fccafeb372$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $586b16fccafeb372$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $586b16fccafeb372$var$Default$a;
    }
    static get DefaultType() {
        return $586b16fccafeb372$var$DefaultType$a;
    }
    static get NAME() {
        return $586b16fccafeb372$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($586b16fccafeb372$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$586b16fccafeb372$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($586b16fccafeb372$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($586b16fccafeb372$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_COLLAPSE, $586b16fccafeb372$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $586b16fccafeb372$var$reflow(this._element);
        this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($586b16fccafeb372$var$CLASS_NAME_COLLAPSE, $586b16fccafeb372$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $586b16fccafeb372$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($586b16fccafeb372$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_COLLAPSE);
            $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($586b16fccafeb372$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $586b16fccafeb372$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($586b16fccafeb372$var$CLASS_NAME_HORIZONTAL) ? $586b16fccafeb372$var$WIDTH : $586b16fccafeb372$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $586b16fccafeb372$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $586b16fccafeb372$var$SelectorEngine.find($586b16fccafeb372$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $586b16fccafeb372$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($586b16fccafeb372$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $586b16fccafeb372$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $586b16fccafeb372$var$EventHandler.on(document, $586b16fccafeb372$var$EVENT_CLICK_DATA_API$4, $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    for (const element of $586b16fccafeb372$var$SelectorEngine.getMultipleElementsFromSelector(this))$586b16fccafeb372$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $586b16fccafeb372$var$defineJQueryPlugin($586b16fccafeb372$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$a = "dropdown";
const $586b16fccafeb372$var$DATA_KEY$6 = "bs.dropdown";
const $586b16fccafeb372$var$EVENT_KEY$6 = `.${$586b16fccafeb372$var$DATA_KEY$6}`;
const $586b16fccafeb372$var$DATA_API_KEY$3 = ".data-api";
const $586b16fccafeb372$var$ESCAPE_KEY$2 = "Escape";
const $586b16fccafeb372$var$TAB_KEY$1 = "Tab";
const $586b16fccafeb372$var$ARROW_UP_KEY$1 = "ArrowUp";
const $586b16fccafeb372$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $586b16fccafeb372$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $586b16fccafeb372$var$EVENT_HIDE$5 = `hide${$586b16fccafeb372$var$EVENT_KEY$6}`;
const $586b16fccafeb372$var$EVENT_HIDDEN$5 = `hidden${$586b16fccafeb372$var$EVENT_KEY$6}`;
const $586b16fccafeb372$var$EVENT_SHOW$5 = `show${$586b16fccafeb372$var$EVENT_KEY$6}`;
const $586b16fccafeb372$var$EVENT_SHOWN$5 = `shown${$586b16fccafeb372$var$EVENT_KEY$6}`;
const $586b16fccafeb372$var$EVENT_CLICK_DATA_API$3 = `click${$586b16fccafeb372$var$EVENT_KEY$6}${$586b16fccafeb372$var$DATA_API_KEY$3}`;
const $586b16fccafeb372$var$EVENT_KEYDOWN_DATA_API = `keydown${$586b16fccafeb372$var$EVENT_KEY$6}${$586b16fccafeb372$var$DATA_API_KEY$3}`;
const $586b16fccafeb372$var$EVENT_KEYUP_DATA_API = `keyup${$586b16fccafeb372$var$EVENT_KEY$6}${$586b16fccafeb372$var$DATA_API_KEY$3}`;
const $586b16fccafeb372$var$CLASS_NAME_SHOW$6 = "show";
const $586b16fccafeb372$var$CLASS_NAME_DROPUP = "dropup";
const $586b16fccafeb372$var$CLASS_NAME_DROPEND = "dropend";
const $586b16fccafeb372$var$CLASS_NAME_DROPSTART = "dropstart";
const $586b16fccafeb372$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $586b16fccafeb372$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$3}.${$586b16fccafeb372$var$CLASS_NAME_SHOW$6}`;
const $586b16fccafeb372$var$SELECTOR_MENU = ".dropdown-menu";
const $586b16fccafeb372$var$SELECTOR_NAVBAR = ".navbar";
const $586b16fccafeb372$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $586b16fccafeb372$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $586b16fccafeb372$var$PLACEMENT_TOP = $586b16fccafeb372$var$isRTL() ? "top-end" : "top-start";
const $586b16fccafeb372$var$PLACEMENT_TOPEND = $586b16fccafeb372$var$isRTL() ? "top-start" : "top-end";
const $586b16fccafeb372$var$PLACEMENT_BOTTOM = $586b16fccafeb372$var$isRTL() ? "bottom-end" : "bottom-start";
const $586b16fccafeb372$var$PLACEMENT_BOTTOMEND = $586b16fccafeb372$var$isRTL() ? "bottom-start" : "bottom-end";
const $586b16fccafeb372$var$PLACEMENT_RIGHT = $586b16fccafeb372$var$isRTL() ? "left-start" : "right-start";
const $586b16fccafeb372$var$PLACEMENT_LEFT = $586b16fccafeb372$var$isRTL() ? "right-start" : "left-start";
const $586b16fccafeb372$var$PLACEMENT_TOPCENTER = "top";
const $586b16fccafeb372$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $586b16fccafeb372$var$Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $586b16fccafeb372$var$DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class $586b16fccafeb372$export$931cbfb6bfb85fc extends $586b16fccafeb372$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $586b16fccafeb372$var$SelectorEngine.next(this._element, $586b16fccafeb372$var$SELECTOR_MENU)[0] || $586b16fccafeb372$var$SelectorEngine.prev(this._element, $586b16fccafeb372$var$SELECTOR_MENU)[0] || $586b16fccafeb372$var$SelectorEngine.findOne($586b16fccafeb372$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $586b16fccafeb372$var$Default$9;
    }
    static get DefaultType() {
        return $586b16fccafeb372$var$DefaultType$9;
    }
    static get NAME() {
        return $586b16fccafeb372$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($586b16fccafeb372$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest($586b16fccafeb372$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$586b16fccafeb372$var$EventHandler.on(element, "mouseover", $586b16fccafeb372$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($586b16fccafeb372$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_SHOW$6);
        $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($586b16fccafeb372$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$586b16fccafeb372$var$EventHandler.off(element, "mouseover", $586b16fccafeb372$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($586b16fccafeb372$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($586b16fccafeb372$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        $586b16fccafeb372$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$586b16fccafeb372$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$586b16fccafeb372$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $2415630f543121c4$exports === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($586b16fccafeb372$var$isElement(this._config.reference)) referenceElement = $586b16fccafeb372$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $2415630f543121c4$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($586b16fccafeb372$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($586b16fccafeb372$var$CLASS_NAME_DROPEND)) return $586b16fccafeb372$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($586b16fccafeb372$var$CLASS_NAME_DROPSTART)) return $586b16fccafeb372$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($586b16fccafeb372$var$CLASS_NAME_DROPUP_CENTER)) return $586b16fccafeb372$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($586b16fccafeb372$var$CLASS_NAME_DROPDOWN_CENTER)) return $586b16fccafeb372$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains($586b16fccafeb372$var$CLASS_NAME_DROPUP)) return isEnd ? $586b16fccafeb372$var$PLACEMENT_TOPEND : $586b16fccafeb372$var$PLACEMENT_TOP;
        return isEnd ? $586b16fccafeb372$var$PLACEMENT_BOTTOMEND : $586b16fccafeb372$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($586b16fccafeb372$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            $586b16fccafeb372$var$Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$586b16fccafeb372$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $586b16fccafeb372$var$SelectorEngine.find($586b16fccafeb372$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$586b16fccafeb372$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $586b16fccafeb372$var$getNextActiveElement(items, target, key === $586b16fccafeb372$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $586b16fccafeb372$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $586b16fccafeb372$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $586b16fccafeb372$var$TAB_KEY$1) return;
        const openToggles = $586b16fccafeb372$var$SelectorEngine.find($586b16fccafeb372$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $586b16fccafeb372$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $586b16fccafeb372$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $586b16fccafeb372$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $586b16fccafeb372$var$ARROW_UP_KEY$1,
            $586b16fccafeb372$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$3) ? this : $586b16fccafeb372$var$SelectorEngine.prev(this, $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$3)[0] || $586b16fccafeb372$var$SelectorEngine.next(this, $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$3)[0] || $586b16fccafeb372$var$SelectorEngine.findOne($586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $586b16fccafeb372$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $586b16fccafeb372$var$EventHandler.on(document, $586b16fccafeb372$var$EVENT_KEYDOWN_DATA_API, $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$3, $586b16fccafeb372$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$586b16fccafeb372$var$EventHandler.on(document, $586b16fccafeb372$var$EVENT_KEYDOWN_DATA_API, $586b16fccafeb372$var$SELECTOR_MENU, $586b16fccafeb372$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$586b16fccafeb372$var$EventHandler.on(document, $586b16fccafeb372$var$EVENT_CLICK_DATA_API$3, $586b16fccafeb372$export$931cbfb6bfb85fc.clearMenus);
$586b16fccafeb372$var$EventHandler.on(document, $586b16fccafeb372$var$EVENT_KEYUP_DATA_API, $586b16fccafeb372$export$931cbfb6bfb85fc.clearMenus);
$586b16fccafeb372$var$EventHandler.on(document, $586b16fccafeb372$var$EVENT_CLICK_DATA_API$3, $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $586b16fccafeb372$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $586b16fccafeb372$var$defineJQueryPlugin($586b16fccafeb372$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$9 = "backdrop";
const $586b16fccafeb372$var$CLASS_NAME_FADE$4 = "fade";
const $586b16fccafeb372$var$CLASS_NAME_SHOW$5 = "show";
const $586b16fccafeb372$var$EVENT_MOUSEDOWN = `mousedown.bs.${$586b16fccafeb372$var$NAME$9}`;
const $586b16fccafeb372$var$Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const $586b16fccafeb372$var$DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class $586b16fccafeb372$var$Backdrop extends $586b16fccafeb372$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $586b16fccafeb372$var$Default$8;
    }
    static get DefaultType() {
        return $586b16fccafeb372$var$DefaultType$8;
    }
    static get NAME() {
        return $586b16fccafeb372$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $586b16fccafeb372$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $586b16fccafeb372$var$reflow(element);
        element.classList.add($586b16fccafeb372$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $586b16fccafeb372$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $586b16fccafeb372$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($586b16fccafeb372$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $586b16fccafeb372$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $586b16fccafeb372$var$EventHandler.off(this._element, $586b16fccafeb372$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($586b16fccafeb372$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $586b16fccafeb372$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $586b16fccafeb372$var$EventHandler.on(element, $586b16fccafeb372$var$EVENT_MOUSEDOWN, ()=>{
            $586b16fccafeb372$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $586b16fccafeb372$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$8 = "focustrap";
const $586b16fccafeb372$var$DATA_KEY$5 = "bs.focustrap";
const $586b16fccafeb372$var$EVENT_KEY$5 = `.${$586b16fccafeb372$var$DATA_KEY$5}`;
const $586b16fccafeb372$var$EVENT_FOCUSIN$2 = `focusin${$586b16fccafeb372$var$EVENT_KEY$5}`;
const $586b16fccafeb372$var$EVENT_KEYDOWN_TAB = `keydown.tab${$586b16fccafeb372$var$EVENT_KEY$5}`;
const $586b16fccafeb372$var$TAB_KEY = "Tab";
const $586b16fccafeb372$var$TAB_NAV_FORWARD = "forward";
const $586b16fccafeb372$var$TAB_NAV_BACKWARD = "backward";
const $586b16fccafeb372$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $586b16fccafeb372$var$DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class $586b16fccafeb372$var$FocusTrap extends $586b16fccafeb372$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $586b16fccafeb372$var$Default$7;
    }
    static get DefaultType() {
        return $586b16fccafeb372$var$DefaultType$7;
    }
    static get NAME() {
        return $586b16fccafeb372$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $586b16fccafeb372$var$EventHandler.off(document, $586b16fccafeb372$var$EVENT_KEY$5); // guard against infinite focus loop
        $586b16fccafeb372$var$EventHandler.on(document, $586b16fccafeb372$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $586b16fccafeb372$var$EventHandler.on(document, $586b16fccafeb372$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $586b16fccafeb372$var$EventHandler.off(document, $586b16fccafeb372$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $586b16fccafeb372$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $586b16fccafeb372$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $586b16fccafeb372$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $586b16fccafeb372$var$TAB_NAV_BACKWARD : $586b16fccafeb372$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $586b16fccafeb372$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $586b16fccafeb372$var$PROPERTY_PADDING = "padding-right";
const $586b16fccafeb372$var$PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class $586b16fccafeb372$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $586b16fccafeb372$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($586b16fccafeb372$var$SELECTOR_FIXED_CONTENT, $586b16fccafeb372$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($586b16fccafeb372$var$SELECTOR_STICKY_CONTENT, $586b16fccafeb372$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $586b16fccafeb372$var$PROPERTY_PADDING);
        this._resetElementAttributes($586b16fccafeb372$var$SELECTOR_FIXED_CONTENT, $586b16fccafeb372$var$PROPERTY_PADDING);
        this._resetElementAttributes($586b16fccafeb372$var$SELECTOR_STICKY_CONTENT, $586b16fccafeb372$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $586b16fccafeb372$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $586b16fccafeb372$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $586b16fccafeb372$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($586b16fccafeb372$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $586b16fccafeb372$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$7 = "modal";
const $586b16fccafeb372$var$DATA_KEY$4 = "bs.modal";
const $586b16fccafeb372$var$EVENT_KEY$4 = `.${$586b16fccafeb372$var$DATA_KEY$4}`;
const $586b16fccafeb372$var$DATA_API_KEY$2 = ".data-api";
const $586b16fccafeb372$var$ESCAPE_KEY$1 = "Escape";
const $586b16fccafeb372$var$EVENT_HIDE$4 = `hide${$586b16fccafeb372$var$EVENT_KEY$4}`;
const $586b16fccafeb372$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$586b16fccafeb372$var$EVENT_KEY$4}`;
const $586b16fccafeb372$var$EVENT_HIDDEN$4 = `hidden${$586b16fccafeb372$var$EVENT_KEY$4}`;
const $586b16fccafeb372$var$EVENT_SHOW$4 = `show${$586b16fccafeb372$var$EVENT_KEY$4}`;
const $586b16fccafeb372$var$EVENT_SHOWN$4 = `shown${$586b16fccafeb372$var$EVENT_KEY$4}`;
const $586b16fccafeb372$var$EVENT_RESIZE$1 = `resize${$586b16fccafeb372$var$EVENT_KEY$4}`;
const $586b16fccafeb372$var$EVENT_CLICK_DISMISS = `click.dismiss${$586b16fccafeb372$var$EVENT_KEY$4}`;
const $586b16fccafeb372$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$586b16fccafeb372$var$EVENT_KEY$4}`;
const $586b16fccafeb372$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$586b16fccafeb372$var$EVENT_KEY$4}`;
const $586b16fccafeb372$var$EVENT_CLICK_DATA_API$2 = `click${$586b16fccafeb372$var$EVENT_KEY$4}${$586b16fccafeb372$var$DATA_API_KEY$2}`;
const $586b16fccafeb372$var$CLASS_NAME_OPEN = "modal-open";
const $586b16fccafeb372$var$CLASS_NAME_FADE$3 = "fade";
const $586b16fccafeb372$var$CLASS_NAME_SHOW$4 = "show";
const $586b16fccafeb372$var$CLASS_NAME_STATIC = "modal-static";
const $586b16fccafeb372$var$OPEN_SELECTOR$1 = ".modal.show";
const $586b16fccafeb372$var$SELECTOR_DIALOG = ".modal-dialog";
const $586b16fccafeb372$var$SELECTOR_MODAL_BODY = ".modal-body";
const $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $586b16fccafeb372$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $586b16fccafeb372$var$DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class $586b16fccafeb372$export$2b77a92f1a5ad772 extends $586b16fccafeb372$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $586b16fccafeb372$var$SelectorEngine.findOne($586b16fccafeb372$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $586b16fccafeb372$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $586b16fccafeb372$var$Default$6;
    }
    static get DefaultType() {
        return $586b16fccafeb372$var$DefaultType$6;
    }
    static get NAME() {
        return $586b16fccafeb372$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($586b16fccafeb372$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($586b16fccafeb372$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $586b16fccafeb372$var$EventHandler.off(window, $586b16fccafeb372$var$EVENT_KEY$4);
        $586b16fccafeb372$var$EventHandler.off(this._dialog, $586b16fccafeb372$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $586b16fccafeb372$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $586b16fccafeb372$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $586b16fccafeb372$var$SelectorEngine.findOne($586b16fccafeb372$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $586b16fccafeb372$var$reflow(this._element);
        this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $586b16fccafeb372$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $586b16fccafeb372$var$EventHandler.on(window, $586b16fccafeb372$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $586b16fccafeb372$var$EventHandler.one(this._element, $586b16fccafeb372$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($586b16fccafeb372$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($586b16fccafeb372$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains($586b16fccafeb372$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($586b16fccafeb372$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $586b16fccafeb372$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $586b16fccafeb372$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $586b16fccafeb372$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $586b16fccafeb372$var$EventHandler.on(document, $586b16fccafeb372$var$EVENT_CLICK_DATA_API$2, $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $586b16fccafeb372$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    $586b16fccafeb372$var$EventHandler.one(target, $586b16fccafeb372$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $586b16fccafeb372$var$EventHandler.one(target, $586b16fccafeb372$var$EVENT_HIDDEN$4, ()=>{
            if ($586b16fccafeb372$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $586b16fccafeb372$var$SelectorEngine.findOne($586b16fccafeb372$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $586b16fccafeb372$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $586b16fccafeb372$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$586b16fccafeb372$var$enableDismissTrigger($586b16fccafeb372$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $586b16fccafeb372$var$defineJQueryPlugin($586b16fccafeb372$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$6 = "offcanvas";
const $586b16fccafeb372$var$DATA_KEY$3 = "bs.offcanvas";
const $586b16fccafeb372$var$EVENT_KEY$3 = `.${$586b16fccafeb372$var$DATA_KEY$3}`;
const $586b16fccafeb372$var$DATA_API_KEY$1 = ".data-api";
const $586b16fccafeb372$var$EVENT_LOAD_DATA_API$2 = `load${$586b16fccafeb372$var$EVENT_KEY$3}${$586b16fccafeb372$var$DATA_API_KEY$1}`;
const $586b16fccafeb372$var$ESCAPE_KEY = "Escape";
const $586b16fccafeb372$var$CLASS_NAME_SHOW$3 = "show";
const $586b16fccafeb372$var$CLASS_NAME_SHOWING$1 = "showing";
const $586b16fccafeb372$var$CLASS_NAME_HIDING = "hiding";
const $586b16fccafeb372$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $586b16fccafeb372$var$OPEN_SELECTOR = ".offcanvas.show";
const $586b16fccafeb372$var$EVENT_SHOW$3 = `show${$586b16fccafeb372$var$EVENT_KEY$3}`;
const $586b16fccafeb372$var$EVENT_SHOWN$3 = `shown${$586b16fccafeb372$var$EVENT_KEY$3}`;
const $586b16fccafeb372$var$EVENT_HIDE$3 = `hide${$586b16fccafeb372$var$EVENT_KEY$3}`;
const $586b16fccafeb372$var$EVENT_HIDE_PREVENTED = `hidePrevented${$586b16fccafeb372$var$EVENT_KEY$3}`;
const $586b16fccafeb372$var$EVENT_HIDDEN$3 = `hidden${$586b16fccafeb372$var$EVENT_KEY$3}`;
const $586b16fccafeb372$var$EVENT_RESIZE = `resize${$586b16fccafeb372$var$EVENT_KEY$3}`;
const $586b16fccafeb372$var$EVENT_CLICK_DATA_API$1 = `click${$586b16fccafeb372$var$EVENT_KEY$3}${$586b16fccafeb372$var$DATA_API_KEY$1}`;
const $586b16fccafeb372$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$586b16fccafeb372$var$EVENT_KEY$3}`;
const $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $586b16fccafeb372$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $586b16fccafeb372$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class $586b16fccafeb372$export$591ca0244c9dfcd4 extends $586b16fccafeb372$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $586b16fccafeb372$var$Default$5;
    }
    static get DefaultType() {
        return $586b16fccafeb372$var$DefaultType$5;
    }
    static get NAME() {
        return $586b16fccafeb372$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $586b16fccafeb372$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($586b16fccafeb372$var$CLASS_NAME_SHOWING$1);
            $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($586b16fccafeb372$var$CLASS_NAME_SHOW$3, $586b16fccafeb372$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $586b16fccafeb372$var$ScrollBarHelper().reset();
            $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $586b16fccafeb372$var$Backdrop({
            className: $586b16fccafeb372$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $586b16fccafeb372$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $586b16fccafeb372$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $586b16fccafeb372$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $586b16fccafeb372$var$EventHandler.on(document, $586b16fccafeb372$var$EVENT_CLICK_DATA_API$1, $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $586b16fccafeb372$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($586b16fccafeb372$var$isDisabled(this)) return;
    $586b16fccafeb372$var$EventHandler.one(target, $586b16fccafeb372$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($586b16fccafeb372$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $586b16fccafeb372$var$SelectorEngine.findOne($586b16fccafeb372$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $586b16fccafeb372$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $586b16fccafeb372$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$586b16fccafeb372$var$EventHandler.on(window, $586b16fccafeb372$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $586b16fccafeb372$var$SelectorEngine.find($586b16fccafeb372$var$OPEN_SELECTOR))$586b16fccafeb372$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$586b16fccafeb372$var$EventHandler.on(window, $586b16fccafeb372$var$EVENT_RESIZE, ()=>{
    for (const element of $586b16fccafeb372$var$SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") $586b16fccafeb372$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$586b16fccafeb372$var$enableDismissTrigger($586b16fccafeb372$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $586b16fccafeb372$var$defineJQueryPlugin($586b16fccafeb372$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $586b16fccafeb372$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $586b16fccafeb372$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $586b16fccafeb372$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $586b16fccafeb372$var$uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $586b16fccafeb372$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $586b16fccafeb372$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($586b16fccafeb372$var$uriAttributes.has(attributeName)) return Boolean($586b16fccafeb372$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $586b16fccafeb372$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$586b16fccafeb372$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$5 = "TemplateFactory";
const $586b16fccafeb372$var$Default$4 = {
    allowList: $586b16fccafeb372$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $586b16fccafeb372$var$DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $586b16fccafeb372$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class $586b16fccafeb372$var$TemplateFactory extends $586b16fccafeb372$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $586b16fccafeb372$var$Default$4;
    }
    static get DefaultType() {
        return $586b16fccafeb372$var$DefaultType$4;
    }
    static get NAME() {
        return $586b16fccafeb372$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $586b16fccafeb372$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $586b16fccafeb372$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($586b16fccafeb372$var$isElement(content)) {
            this._putElementInTemplate($586b16fccafeb372$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $586b16fccafeb372$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $586b16fccafeb372$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$4 = "tooltip";
const $586b16fccafeb372$var$DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $586b16fccafeb372$var$CLASS_NAME_FADE$2 = "fade";
const $586b16fccafeb372$var$CLASS_NAME_MODAL = "modal";
const $586b16fccafeb372$var$CLASS_NAME_SHOW$2 = "show";
const $586b16fccafeb372$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $586b16fccafeb372$var$SELECTOR_MODAL = `.${$586b16fccafeb372$var$CLASS_NAME_MODAL}`;
const $586b16fccafeb372$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $586b16fccafeb372$var$TRIGGER_HOVER = "hover";
const $586b16fccafeb372$var$TRIGGER_FOCUS = "focus";
const $586b16fccafeb372$var$TRIGGER_CLICK = "click";
const $586b16fccafeb372$var$TRIGGER_MANUAL = "manual";
const $586b16fccafeb372$var$EVENT_HIDE$2 = "hide";
const $586b16fccafeb372$var$EVENT_HIDDEN$2 = "hidden";
const $586b16fccafeb372$var$EVENT_SHOW$2 = "show";
const $586b16fccafeb372$var$EVENT_SHOWN$2 = "shown";
const $586b16fccafeb372$var$EVENT_INSERTED = "inserted";
const $586b16fccafeb372$var$EVENT_CLICK$1 = "click";
const $586b16fccafeb372$var$EVENT_FOCUSIN$1 = "focusin";
const $586b16fccafeb372$var$EVENT_FOCUSOUT$1 = "focusout";
const $586b16fccafeb372$var$EVENT_MOUSEENTER = "mouseenter";
const $586b16fccafeb372$var$EVENT_MOUSELEAVE = "mouseleave";
const $586b16fccafeb372$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $586b16fccafeb372$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $586b16fccafeb372$var$isRTL() ? "right" : "left"
};
const $586b16fccafeb372$var$Default$3 = {
    allowList: $586b16fccafeb372$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $586b16fccafeb372$var$DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class $586b16fccafeb372$export$28c660c63b792dea extends $586b16fccafeb372$var$BaseComponent {
    constructor(element, config){
        if (typeof $2415630f543121c4$exports === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $586b16fccafeb372$var$Default$3;
    }
    static get DefaultType() {
        return $586b16fccafeb372$var$DefaultType$3;
    }
    static get NAME() {
        return $586b16fccafeb372$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $586b16fccafeb372$var$EventHandler.off(this._element.closest($586b16fccafeb372$var$SELECTOR_MODAL), $586b16fccafeb372$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $586b16fccafeb372$var$EventHandler.trigger(this._element, this.constructor.eventName($586b16fccafeb372$var$EVENT_SHOW$2));
        const shadowRoot = $586b16fccafeb372$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $586b16fccafeb372$var$EventHandler.trigger(this._element, this.constructor.eventName($586b16fccafeb372$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($586b16fccafeb372$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$586b16fccafeb372$var$EventHandler.on(element, "mouseover", $586b16fccafeb372$var$noop);
        const complete = ()=>{
            $586b16fccafeb372$var$EventHandler.trigger(this._element, this.constructor.eventName($586b16fccafeb372$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $586b16fccafeb372$var$EventHandler.trigger(this._element, this.constructor.eventName($586b16fccafeb372$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($586b16fccafeb372$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$586b16fccafeb372$var$EventHandler.off(element, "mouseover", $586b16fccafeb372$var$noop);
        this._activeTrigger[$586b16fccafeb372$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$586b16fccafeb372$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$586b16fccafeb372$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $586b16fccafeb372$var$EventHandler.trigger(this._element, this.constructor.eventName($586b16fccafeb372$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($586b16fccafeb372$var$CLASS_NAME_FADE$2, $586b16fccafeb372$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $586b16fccafeb372$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($586b16fccafeb372$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $586b16fccafeb372$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$586b16fccafeb372$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($586b16fccafeb372$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($586b16fccafeb372$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $586b16fccafeb372$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $586b16fccafeb372$var$AttachmentMap[placement.toUpperCase()];
        return $2415630f543121c4$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $586b16fccafeb372$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$586b16fccafeb372$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $586b16fccafeb372$var$EventHandler.on(this._element, this.constructor.eventName($586b16fccafeb372$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $586b16fccafeb372$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $586b16fccafeb372$var$TRIGGER_HOVER ? this.constructor.eventName($586b16fccafeb372$var$EVENT_MOUSEENTER) : this.constructor.eventName($586b16fccafeb372$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $586b16fccafeb372$var$TRIGGER_HOVER ? this.constructor.eventName($586b16fccafeb372$var$EVENT_MOUSELEAVE) : this.constructor.eventName($586b16fccafeb372$var$EVENT_FOCUSOUT$1);
                $586b16fccafeb372$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $586b16fccafeb372$var$TRIGGER_FOCUS : $586b16fccafeb372$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $586b16fccafeb372$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $586b16fccafeb372$var$TRIGGER_FOCUS : $586b16fccafeb372$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $586b16fccafeb372$var$EventHandler.on(this._element.closest($586b16fccafeb372$var$SELECTOR_MODAL), $586b16fccafeb372$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $586b16fccafeb372$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($586b16fccafeb372$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $586b16fccafeb372$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $586b16fccafeb372$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $586b16fccafeb372$var$defineJQueryPlugin($586b16fccafeb372$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$3 = "popover";
const $586b16fccafeb372$var$SELECTOR_TITLE = ".popover-header";
const $586b16fccafeb372$var$SELECTOR_CONTENT = ".popover-body";
const $586b16fccafeb372$var$Default$2 = {
    ...$586b16fccafeb372$export$28c660c63b792dea.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $586b16fccafeb372$var$DefaultType$2 = {
    ...$586b16fccafeb372$export$28c660c63b792dea.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class $586b16fccafeb372$export$5b6b19405a83ff9d extends $586b16fccafeb372$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $586b16fccafeb372$var$Default$2;
    }
    static get DefaultType() {
        return $586b16fccafeb372$var$DefaultType$2;
    }
    static get NAME() {
        return $586b16fccafeb372$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$586b16fccafeb372$var$SELECTOR_TITLE]: this._getTitle(),
            [$586b16fccafeb372$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $586b16fccafeb372$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $586b16fccafeb372$var$defineJQueryPlugin($586b16fccafeb372$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$2 = "scrollspy";
const $586b16fccafeb372$var$DATA_KEY$2 = "bs.scrollspy";
const $586b16fccafeb372$var$EVENT_KEY$2 = `.${$586b16fccafeb372$var$DATA_KEY$2}`;
const $586b16fccafeb372$var$DATA_API_KEY = ".data-api";
const $586b16fccafeb372$var$EVENT_ACTIVATE = `activate${$586b16fccafeb372$var$EVENT_KEY$2}`;
const $586b16fccafeb372$var$EVENT_CLICK = `click${$586b16fccafeb372$var$EVENT_KEY$2}`;
const $586b16fccafeb372$var$EVENT_LOAD_DATA_API$1 = `load${$586b16fccafeb372$var$EVENT_KEY$2}${$586b16fccafeb372$var$DATA_API_KEY}`;
const $586b16fccafeb372$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $586b16fccafeb372$var$CLASS_NAME_ACTIVE$1 = "active";
const $586b16fccafeb372$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $586b16fccafeb372$var$SELECTOR_TARGET_LINKS = "[href]";
const $586b16fccafeb372$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $586b16fccafeb372$var$SELECTOR_NAV_LINKS = ".nav-link";
const $586b16fccafeb372$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $586b16fccafeb372$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $586b16fccafeb372$var$SELECTOR_LINK_ITEMS = `${$586b16fccafeb372$var$SELECTOR_NAV_LINKS}, ${$586b16fccafeb372$var$SELECTOR_NAV_ITEMS} > ${$586b16fccafeb372$var$SELECTOR_NAV_LINKS}, ${$586b16fccafeb372$var$SELECTOR_LIST_ITEMS}`;
const $586b16fccafeb372$var$SELECTOR_DROPDOWN = ".dropdown";
const $586b16fccafeb372$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $586b16fccafeb372$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $586b16fccafeb372$var$DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class $586b16fccafeb372$export$a6472a5298a374be extends $586b16fccafeb372$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $586b16fccafeb372$var$Default$1;
    }
    static get DefaultType() {
        return $586b16fccafeb372$var$DefaultType$1;
    }
    static get NAME() {
        return $586b16fccafeb372$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $586b16fccafeb372$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $586b16fccafeb372$var$EventHandler.off(this._config.target, $586b16fccafeb372$var$EVENT_CLICK);
        $586b16fccafeb372$var$EventHandler.on(this._config.target, $586b16fccafeb372$var$EVENT_CLICK, $586b16fccafeb372$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $586b16fccafeb372$var$SelectorEngine.find($586b16fccafeb372$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $586b16fccafeb372$var$isDisabled(anchor)) continue;
            const observableSection = $586b16fccafeb372$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($586b16fccafeb372$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($586b16fccafeb372$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($586b16fccafeb372$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $586b16fccafeb372$var$SelectorEngine.findOne($586b16fccafeb372$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($586b16fccafeb372$var$SELECTOR_DROPDOWN)).classList.add($586b16fccafeb372$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $586b16fccafeb372$var$SelectorEngine.parents(target, $586b16fccafeb372$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $586b16fccafeb372$var$SelectorEngine.prev(listGroup, $586b16fccafeb372$var$SELECTOR_LINK_ITEMS))item.classList.add($586b16fccafeb372$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($586b16fccafeb372$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $586b16fccafeb372$var$SelectorEngine.find(`${$586b16fccafeb372$var$SELECTOR_TARGET_LINKS}.${$586b16fccafeb372$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($586b16fccafeb372$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $586b16fccafeb372$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $586b16fccafeb372$var$EventHandler.on(window, $586b16fccafeb372$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $586b16fccafeb372$var$SelectorEngine.find($586b16fccafeb372$var$SELECTOR_DATA_SPY))$586b16fccafeb372$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $586b16fccafeb372$var$defineJQueryPlugin($586b16fccafeb372$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME$1 = "tab";
const $586b16fccafeb372$var$DATA_KEY$1 = "bs.tab";
const $586b16fccafeb372$var$EVENT_KEY$1 = `.${$586b16fccafeb372$var$DATA_KEY$1}`;
const $586b16fccafeb372$var$EVENT_HIDE$1 = `hide${$586b16fccafeb372$var$EVENT_KEY$1}`;
const $586b16fccafeb372$var$EVENT_HIDDEN$1 = `hidden${$586b16fccafeb372$var$EVENT_KEY$1}`;
const $586b16fccafeb372$var$EVENT_SHOW$1 = `show${$586b16fccafeb372$var$EVENT_KEY$1}`;
const $586b16fccafeb372$var$EVENT_SHOWN$1 = `shown${$586b16fccafeb372$var$EVENT_KEY$1}`;
const $586b16fccafeb372$var$EVENT_CLICK_DATA_API = `click${$586b16fccafeb372$var$EVENT_KEY$1}`;
const $586b16fccafeb372$var$EVENT_KEYDOWN = `keydown${$586b16fccafeb372$var$EVENT_KEY$1}`;
const $586b16fccafeb372$var$EVENT_LOAD_DATA_API = `load${$586b16fccafeb372$var$EVENT_KEY$1}`;
const $586b16fccafeb372$var$ARROW_LEFT_KEY = "ArrowLeft";
const $586b16fccafeb372$var$ARROW_RIGHT_KEY = "ArrowRight";
const $586b16fccafeb372$var$ARROW_UP_KEY = "ArrowUp";
const $586b16fccafeb372$var$ARROW_DOWN_KEY = "ArrowDown";
const $586b16fccafeb372$var$HOME_KEY = "Home";
const $586b16fccafeb372$var$END_KEY = "End";
const $586b16fccafeb372$var$CLASS_NAME_ACTIVE = "active";
const $586b16fccafeb372$var$CLASS_NAME_FADE$1 = "fade";
const $586b16fccafeb372$var$CLASS_NAME_SHOW$1 = "show";
const $586b16fccafeb372$var$CLASS_DROPDOWN = "dropdown";
const $586b16fccafeb372$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $586b16fccafeb372$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $586b16fccafeb372$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$586b16fccafeb372$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $586b16fccafeb372$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $586b16fccafeb372$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $586b16fccafeb372$var$SELECTOR_INNER = `.nav-link${$586b16fccafeb372$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$586b16fccafeb372$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$586b16fccafeb372$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $586b16fccafeb372$var$SELECTOR_INNER_ELEM = `${$586b16fccafeb372$var$SELECTOR_INNER}, ${$586b16fccafeb372$var$SELECTOR_DATA_TOGGLE}`;
const $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$586b16fccafeb372$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$586b16fccafeb372$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$586b16fccafeb372$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $586b16fccafeb372$export$3e41faf802a29e71 extends $586b16fccafeb372$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($586b16fccafeb372$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $586b16fccafeb372$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $586b16fccafeb372$var$EventHandler.trigger(active, $586b16fccafeb372$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $586b16fccafeb372$var$EventHandler.trigger(innerElem, $586b16fccafeb372$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($586b16fccafeb372$var$CLASS_NAME_ACTIVE);
        this._activate($586b16fccafeb372$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add($586b16fccafeb372$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            $586b16fccafeb372$var$EventHandler.trigger(element, $586b16fccafeb372$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($586b16fccafeb372$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($586b16fccafeb372$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($586b16fccafeb372$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove($586b16fccafeb372$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            $586b16fccafeb372$var$EventHandler.trigger(element, $586b16fccafeb372$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($586b16fccafeb372$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $586b16fccafeb372$var$ARROW_LEFT_KEY,
            $586b16fccafeb372$var$ARROW_RIGHT_KEY,
            $586b16fccafeb372$var$ARROW_UP_KEY,
            $586b16fccafeb372$var$ARROW_DOWN_KEY,
            $586b16fccafeb372$var$HOME_KEY,
            $586b16fccafeb372$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$586b16fccafeb372$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $586b16fccafeb372$var$HOME_KEY,
            $586b16fccafeb372$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $586b16fccafeb372$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $586b16fccafeb372$var$ARROW_RIGHT_KEY,
                $586b16fccafeb372$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $586b16fccafeb372$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $586b16fccafeb372$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $586b16fccafeb372$var$SelectorEngine.find($586b16fccafeb372$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $586b16fccafeb372$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($586b16fccafeb372$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $586b16fccafeb372$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($586b16fccafeb372$var$SELECTOR_DROPDOWN_TOGGLE, $586b16fccafeb372$var$CLASS_NAME_ACTIVE);
        toggle($586b16fccafeb372$var$SELECTOR_DROPDOWN_MENU, $586b16fccafeb372$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($586b16fccafeb372$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($586b16fccafeb372$var$SELECTOR_INNER_ELEM) ? elem : $586b16fccafeb372$var$SelectorEngine.findOne($586b16fccafeb372$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($586b16fccafeb372$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $586b16fccafeb372$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $586b16fccafeb372$var$EventHandler.on(document, $586b16fccafeb372$var$EVENT_CLICK_DATA_API, $586b16fccafeb372$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($586b16fccafeb372$var$isDisabled(this)) return;
    $586b16fccafeb372$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $586b16fccafeb372$var$EventHandler.on(window, $586b16fccafeb372$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $586b16fccafeb372$var$SelectorEngine.find($586b16fccafeb372$var$SELECTOR_DATA_TOGGLE_ACTIVE))$586b16fccafeb372$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $586b16fccafeb372$var$defineJQueryPlugin($586b16fccafeb372$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $586b16fccafeb372$var$NAME = "toast";
const $586b16fccafeb372$var$DATA_KEY = "bs.toast";
const $586b16fccafeb372$var$EVENT_KEY = `.${$586b16fccafeb372$var$DATA_KEY}`;
const $586b16fccafeb372$var$EVENT_MOUSEOVER = `mouseover${$586b16fccafeb372$var$EVENT_KEY}`;
const $586b16fccafeb372$var$EVENT_MOUSEOUT = `mouseout${$586b16fccafeb372$var$EVENT_KEY}`;
const $586b16fccafeb372$var$EVENT_FOCUSIN = `focusin${$586b16fccafeb372$var$EVENT_KEY}`;
const $586b16fccafeb372$var$EVENT_FOCUSOUT = `focusout${$586b16fccafeb372$var$EVENT_KEY}`;
const $586b16fccafeb372$var$EVENT_HIDE = `hide${$586b16fccafeb372$var$EVENT_KEY}`;
const $586b16fccafeb372$var$EVENT_HIDDEN = `hidden${$586b16fccafeb372$var$EVENT_KEY}`;
const $586b16fccafeb372$var$EVENT_SHOW = `show${$586b16fccafeb372$var$EVENT_KEY}`;
const $586b16fccafeb372$var$EVENT_SHOWN = `shown${$586b16fccafeb372$var$EVENT_KEY}`;
const $586b16fccafeb372$var$CLASS_NAME_FADE = "fade";
const $586b16fccafeb372$var$CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const $586b16fccafeb372$var$CLASS_NAME_SHOW = "show";
const $586b16fccafeb372$var$CLASS_NAME_SHOWING = "showing";
const $586b16fccafeb372$var$DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $586b16fccafeb372$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $586b16fccafeb372$export$8d8dc7d5f743331b extends $586b16fccafeb372$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $586b16fccafeb372$var$Default;
    }
    static get DefaultType() {
        return $586b16fccafeb372$var$DefaultType;
    }
    static get NAME() {
        return $586b16fccafeb372$var$NAME;
    }
    // Public
    show() {
        const showEvent = $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($586b16fccafeb372$var$CLASS_NAME_SHOWING);
            $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($586b16fccafeb372$var$CLASS_NAME_HIDE); // @deprecated
        $586b16fccafeb372$var$reflow(this._element);
        this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_SHOW, $586b16fccafeb372$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($586b16fccafeb372$var$CLASS_NAME_SHOWING, $586b16fccafeb372$var$CLASS_NAME_SHOW);
            $586b16fccafeb372$var$EventHandler.trigger(this._element, $586b16fccafeb372$var$EVENT_HIDDEN);
        };
        this._element.classList.add($586b16fccafeb372$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($586b16fccafeb372$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($586b16fccafeb372$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $586b16fccafeb372$var$EventHandler.on(this._element, $586b16fccafeb372$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $586b16fccafeb372$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $586b16fccafeb372$var$enableDismissTrigger($586b16fccafeb372$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $586b16fccafeb372$var$defineJQueryPlugin($586b16fccafeb372$export$8d8dc7d5f743331b);


// packages/alpinejs/src/scheduler.js
var $044706a3922c0aa1$var$flushPending = false;
var $044706a3922c0aa1$var$flushing = false;
var $044706a3922c0aa1$var$queue = [];
var $044706a3922c0aa1$var$lastFlushedIndex = -1;
function $044706a3922c0aa1$var$scheduler(callback) {
    $044706a3922c0aa1$var$queueJob(callback);
}
function $044706a3922c0aa1$var$queueJob(job) {
    if (!$044706a3922c0aa1$var$queue.includes(job)) $044706a3922c0aa1$var$queue.push(job);
    $044706a3922c0aa1$var$queueFlush();
}
function $044706a3922c0aa1$var$dequeueJob(job) {
    let index = $044706a3922c0aa1$var$queue.indexOf(job);
    if (index !== -1 && index > $044706a3922c0aa1$var$lastFlushedIndex) $044706a3922c0aa1$var$queue.splice(index, 1);
}
function $044706a3922c0aa1$var$queueFlush() {
    if (!$044706a3922c0aa1$var$flushing && !$044706a3922c0aa1$var$flushPending) {
        $044706a3922c0aa1$var$flushPending = true;
        queueMicrotask($044706a3922c0aa1$var$flushJobs);
    }
}
function $044706a3922c0aa1$var$flushJobs() {
    $044706a3922c0aa1$var$flushPending = false;
    $044706a3922c0aa1$var$flushing = true;
    for(let i = 0; i < $044706a3922c0aa1$var$queue.length; i++){
        $044706a3922c0aa1$var$queue[i]();
        $044706a3922c0aa1$var$lastFlushedIndex = i;
    }
    $044706a3922c0aa1$var$queue.length = 0;
    $044706a3922c0aa1$var$lastFlushedIndex = -1;
    $044706a3922c0aa1$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $044706a3922c0aa1$var$reactive;
var $044706a3922c0aa1$var$effect;
var $044706a3922c0aa1$var$release;
var $044706a3922c0aa1$var$raw;
var $044706a3922c0aa1$var$shouldSchedule = true;
function $044706a3922c0aa1$var$disableEffectScheduling(callback) {
    $044706a3922c0aa1$var$shouldSchedule = false;
    callback();
    $044706a3922c0aa1$var$shouldSchedule = true;
}
function $044706a3922c0aa1$var$setReactivityEngine(engine) {
    $044706a3922c0aa1$var$reactive = engine.reactive;
    $044706a3922c0aa1$var$release = engine.release;
    $044706a3922c0aa1$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($044706a3922c0aa1$var$shouldSchedule) $044706a3922c0aa1$var$scheduler(task);
                else task();
            }
        });
    $044706a3922c0aa1$var$raw = engine.raw;
}
function $044706a3922c0aa1$var$overrideEffect(override) {
    $044706a3922c0aa1$var$effect = override;
}
function $044706a3922c0aa1$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $044706a3922c0aa1$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $044706a3922c0aa1$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $044706a3922c0aa1$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $044706a3922c0aa1$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$044706a3922c0aa1$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $044706a3922c0aa1$var$onAttributeAddeds = [];
var $044706a3922c0aa1$var$onElRemoveds = [];
var $044706a3922c0aa1$var$onElAddeds = [];
function $044706a3922c0aa1$var$onElAdded(callback) {
    $044706a3922c0aa1$var$onElAddeds.push(callback);
}
function $044706a3922c0aa1$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $044706a3922c0aa1$var$onElRemoveds.push(callback);
    }
}
function $044706a3922c0aa1$var$onAttributesAdded(callback) {
    $044706a3922c0aa1$var$onAttributeAddeds.push(callback);
}
function $044706a3922c0aa1$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $044706a3922c0aa1$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $044706a3922c0aa1$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $044706a3922c0aa1$var$observer = new MutationObserver($044706a3922c0aa1$var$onMutate);
var $044706a3922c0aa1$var$currentlyObserving = false;
function $044706a3922c0aa1$var$startObservingMutations() {
    $044706a3922c0aa1$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $044706a3922c0aa1$var$currentlyObserving = true;
}
function $044706a3922c0aa1$var$stopObservingMutations() {
    $044706a3922c0aa1$var$flushObserver();
    $044706a3922c0aa1$var$observer.disconnect();
    $044706a3922c0aa1$var$currentlyObserving = false;
}
var $044706a3922c0aa1$var$queuedMutations = [];
function $044706a3922c0aa1$var$flushObserver() {
    let records = $044706a3922c0aa1$var$observer.takeRecords();
    $044706a3922c0aa1$var$queuedMutations.push(()=>records.length > 0 && $044706a3922c0aa1$var$onMutate(records));
    let queueLengthWhenTriggered = $044706a3922c0aa1$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($044706a3922c0aa1$var$queuedMutations.length === queueLengthWhenTriggered) while($044706a3922c0aa1$var$queuedMutations.length > 0)$044706a3922c0aa1$var$queuedMutations.shift()();
    });
}
function $044706a3922c0aa1$var$mutateDom(callback) {
    if (!$044706a3922c0aa1$var$currentlyObserving) return callback();
    $044706a3922c0aa1$var$stopObservingMutations();
    let result = callback();
    $044706a3922c0aa1$var$startObservingMutations();
    return result;
}
var $044706a3922c0aa1$var$isCollecting = false;
var $044706a3922c0aa1$var$deferredMutations = [];
function $044706a3922c0aa1$var$deferMutations() {
    $044706a3922c0aa1$var$isCollecting = true;
}
function $044706a3922c0aa1$var$flushAndStopDeferringMutations() {
    $044706a3922c0aa1$var$isCollecting = false;
    $044706a3922c0aa1$var$onMutate($044706a3922c0aa1$var$deferredMutations);
    $044706a3922c0aa1$var$deferredMutations = [];
}
function $044706a3922c0aa1$var$onMutate(mutations) {
    if ($044706a3922c0aa1$var$isCollecting) {
        $044706a3922c0aa1$var$deferredMutations = $044706a3922c0aa1$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = /* @__PURE__ */ new Set();
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.add(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.add(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $044706a3922c0aa1$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $044706a3922c0aa1$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.has(node)) continue;
        $044706a3922c0aa1$var$onElRemoveds.forEach((i)=>i(node));
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.has(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $044706a3922c0aa1$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $044706a3922c0aa1$var$scope(node) {
    return $044706a3922c0aa1$var$mergeProxies($044706a3922c0aa1$var$closestDataStack(node));
}
function $044706a3922c0aa1$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$044706a3922c0aa1$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $044706a3922c0aa1$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $044706a3922c0aa1$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $044706a3922c0aa1$var$closestDataStack(node.parentNode);
}
function $044706a3922c0aa1$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $044706a3922c0aa1$var$mergeProxyTrap);
}
var $044706a3922c0aa1$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $044706a3922c0aa1$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $044706a3922c0aa1$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $044706a3922c0aa1$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $044706a3922c0aa1$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$044706a3922c0aa1$var$get(data2, path), (value)=>$044706a3922c0aa1$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $044706a3922c0aa1$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $044706a3922c0aa1$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $044706a3922c0aa1$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $044706a3922c0aa1$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $044706a3922c0aa1$var$magics = {};
function $044706a3922c0aa1$var$magic(name, callback) {
    $044706a3922c0aa1$var$magics[name] = callback;
}
function $044706a3922c0aa1$var$injectMagics(obj, el) {
    Object.entries($044706a3922c0aa1$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $044706a3922c0aa1$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $044706a3922c0aa1$var$interceptor,
                    ...utilities
                };
                $044706a3922c0aa1$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $044706a3922c0aa1$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $044706a3922c0aa1$var$handleError(e, el, expression);
    }
}
function $044706a3922c0aa1$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $044706a3922c0aa1$var$shouldAutoEvaluateFunctions = true;
function $044706a3922c0aa1$var$dontAutoEvaluateFunctions(callback) {
    let cache = $044706a3922c0aa1$var$shouldAutoEvaluateFunctions;
    $044706a3922c0aa1$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $044706a3922c0aa1$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $044706a3922c0aa1$var$evaluate(el, expression, extras = {}) {
    let result;
    $044706a3922c0aa1$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $044706a3922c0aa1$var$evaluateLater(...args) {
    return $044706a3922c0aa1$var$theEvaluatorFunction(...args);
}
var $044706a3922c0aa1$var$theEvaluatorFunction = $044706a3922c0aa1$var$normalEvaluator;
function $044706a3922c0aa1$var$setEvaluator(newEvaluator) {
    $044706a3922c0aa1$var$theEvaluatorFunction = newEvaluator;
}
function $044706a3922c0aa1$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $044706a3922c0aa1$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$044706a3922c0aa1$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $044706a3922c0aa1$var$generateEvaluatorFromFunction(dataStack, expression) : $044706a3922c0aa1$var$generateEvaluatorFromString(dataStack, expression, el);
    return $044706a3922c0aa1$var$tryCatch.bind(null, el, expression, evaluator);
}
function $044706a3922c0aa1$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($044706a3922c0aa1$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $044706a3922c0aa1$var$runIfTypeOfFunction(receiver, result);
    };
}
var $044706a3922c0aa1$var$evaluatorMemo = {};
function $044706a3922c0aa1$var$generateFunctionFromString(expression, el) {
    if ($044706a3922c0aa1$var$evaluatorMemo[expression]) return $044706a3922c0aa1$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $044706a3922c0aa1$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $044706a3922c0aa1$var$evaluatorMemo[expression] = func;
    return func;
}
function $044706a3922c0aa1$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $044706a3922c0aa1$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $044706a3922c0aa1$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$044706a3922c0aa1$var$handleError(error2, el, expression));
            if (func.finished) {
                $044706a3922c0aa1$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $044706a3922c0aa1$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$044706a3922c0aa1$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $044706a3922c0aa1$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($044706a3922c0aa1$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$044706a3922c0aa1$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$044706a3922c0aa1$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $044706a3922c0aa1$var$prefixAsString = "x-";
function $044706a3922c0aa1$var$prefix(subject = "") {
    return $044706a3922c0aa1$var$prefixAsString + subject;
}
function $044706a3922c0aa1$var$setPrefix(newPrefix) {
    $044706a3922c0aa1$var$prefixAsString = newPrefix;
}
var $044706a3922c0aa1$var$directiveHandlers = {};
function $044706a3922c0aa1$var$directive(name, callback) {
    $044706a3922c0aa1$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$044706a3922c0aa1$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $044706a3922c0aa1$var$directiveOrder.indexOf(directive2);
            $044706a3922c0aa1$var$directiveOrder.splice(pos >= 0 ? pos : $044706a3922c0aa1$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $044706a3922c0aa1$var$directiveExists(name) {
    return Object.keys($044706a3922c0aa1$var$directiveHandlers).includes(name);
}
function $044706a3922c0aa1$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $044706a3922c0aa1$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($044706a3922c0aa1$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($044706a3922c0aa1$var$outNonAlpineAttributes).map($044706a3922c0aa1$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($044706a3922c0aa1$var$byPriority);
    return directives2.map((directive2)=>{
        return $044706a3922c0aa1$var$getDirectiveHandler(el, directive2);
    });
}
function $044706a3922c0aa1$var$attributesOnly(attributes) {
    return Array.from(attributes).map($044706a3922c0aa1$var$toTransformedAttributes()).filter((attr)=>!$044706a3922c0aa1$var$outNonAlpineAttributes(attr));
}
var $044706a3922c0aa1$var$isDeferringHandlers = false;
var $044706a3922c0aa1$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $044706a3922c0aa1$var$currentHandlerStackKey = Symbol();
function $044706a3922c0aa1$var$deferHandlingDirectives(callback) {
    $044706a3922c0aa1$var$isDeferringHandlers = true;
    let key = Symbol();
    $044706a3922c0aa1$var$currentHandlerStackKey = key;
    $044706a3922c0aa1$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($044706a3922c0aa1$var$directiveHandlerStacks.get(key).length)$044706a3922c0aa1$var$directiveHandlerStacks.get(key).shift()();
        $044706a3922c0aa1$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $044706a3922c0aa1$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $044706a3922c0aa1$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $044706a3922c0aa1$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $044706a3922c0aa1$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $044706a3922c0aa1$var$evaluateLater.bind($044706a3922c0aa1$var$evaluateLater, el),
        evaluate: $044706a3922c0aa1$var$evaluate.bind($044706a3922c0aa1$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $044706a3922c0aa1$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $044706a3922c0aa1$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $044706a3922c0aa1$var$getElementBoundUtilities(el);
    $044706a3922c0aa1$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $044706a3922c0aa1$var$isDeferringHandlers ? $044706a3922c0aa1$var$directiveHandlerStacks.get($044706a3922c0aa1$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $044706a3922c0aa1$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $044706a3922c0aa1$var$into = (i)=>i;
function $044706a3922c0aa1$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $044706a3922c0aa1$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $044706a3922c0aa1$var$attributeTransformers = [];
function $044706a3922c0aa1$var$mapAttributes(callback) {
    $044706a3922c0aa1$var$attributeTransformers.push(callback);
}
function $044706a3922c0aa1$var$outNonAlpineAttributes({ name: name }) {
    return $044706a3922c0aa1$var$alpineAttributeRegex().test(name);
}
var $044706a3922c0aa1$var$alpineAttributeRegex = ()=>new RegExp(`^${$044706a3922c0aa1$var$prefixAsString}([^:^.]+)\\b`);
function $044706a3922c0aa1$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($044706a3922c0aa1$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $044706a3922c0aa1$var$DEFAULT = "DEFAULT";
var $044706a3922c0aa1$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $044706a3922c0aa1$var$DEFAULT,
    "teleport"
];
function $044706a3922c0aa1$var$byPriority(a, b) {
    let typeA = $044706a3922c0aa1$var$directiveOrder.indexOf(a.type) === -1 ? $044706a3922c0aa1$var$DEFAULT : a.type;
    let typeB = $044706a3922c0aa1$var$directiveOrder.indexOf(b.type) === -1 ? $044706a3922c0aa1$var$DEFAULT : b.type;
    return $044706a3922c0aa1$var$directiveOrder.indexOf(typeA) - $044706a3922c0aa1$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $044706a3922c0aa1$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $044706a3922c0aa1$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$044706a3922c0aa1$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $044706a3922c0aa1$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $044706a3922c0aa1$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $044706a3922c0aa1$var$started = false;
function $044706a3922c0aa1$var$start() {
    if ($044706a3922c0aa1$var$started) $044706a3922c0aa1$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $044706a3922c0aa1$var$started = true;
    if (!document.body) $044706a3922c0aa1$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $044706a3922c0aa1$var$dispatch(document, "alpine:init");
    $044706a3922c0aa1$var$dispatch(document, "alpine:initializing");
    $044706a3922c0aa1$var$startObservingMutations();
    $044706a3922c0aa1$var$onElAdded((el)=>$044706a3922c0aa1$var$initTree(el, $044706a3922c0aa1$var$walk));
    $044706a3922c0aa1$var$onElRemoved((el)=>$044706a3922c0aa1$var$destroyTree(el));
    $044706a3922c0aa1$var$onAttributesAdded((el, attrs)=>{
        $044706a3922c0aa1$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$044706a3922c0aa1$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($044706a3922c0aa1$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $044706a3922c0aa1$var$initTree(el);
    });
    $044706a3922c0aa1$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $044706a3922c0aa1$var$warnAboutMissingPlugins();
    });
}
var $044706a3922c0aa1$var$rootSelectorCallbacks = [];
var $044706a3922c0aa1$var$initSelectorCallbacks = [];
function $044706a3922c0aa1$var$rootSelectors() {
    return $044706a3922c0aa1$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $044706a3922c0aa1$var$allSelectors() {
    return $044706a3922c0aa1$var$rootSelectorCallbacks.concat($044706a3922c0aa1$var$initSelectorCallbacks).map((fn)=>fn());
}
function $044706a3922c0aa1$var$addRootSelector(selectorCallback) {
    $044706a3922c0aa1$var$rootSelectorCallbacks.push(selectorCallback);
}
function $044706a3922c0aa1$var$addInitSelector(selectorCallback) {
    $044706a3922c0aa1$var$initSelectorCallbacks.push(selectorCallback);
}
function $044706a3922c0aa1$var$closestRoot(el, includeInitSelectors = false) {
    return $044706a3922c0aa1$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $044706a3922c0aa1$var$allSelectors() : $044706a3922c0aa1$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $044706a3922c0aa1$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $044706a3922c0aa1$var$findClosest(el.parentElement, callback);
}
function $044706a3922c0aa1$var$isRoot(el) {
    return $044706a3922c0aa1$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $044706a3922c0aa1$var$initInterceptors2 = [];
function $044706a3922c0aa1$var$interceptInit(callback) {
    $044706a3922c0aa1$var$initInterceptors2.push(callback);
}
function $044706a3922c0aa1$var$initTree(el, walker = $044706a3922c0aa1$var$walk, intercept = ()=>{}) {
    $044706a3922c0aa1$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $044706a3922c0aa1$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $044706a3922c0aa1$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $044706a3922c0aa1$var$destroyTree(root, walker = $044706a3922c0aa1$var$walk) {
    walker(root, (el)=>{
        $044706a3922c0aa1$var$cleanupAttributes(el);
        $044706a3922c0aa1$var$cleanupElement(el);
    });
}
function $044706a3922c0aa1$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($044706a3922c0aa1$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $044706a3922c0aa1$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $044706a3922c0aa1$var$tickStack = [];
var $044706a3922c0aa1$var$isHolding = false;
function $044706a3922c0aa1$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $044706a3922c0aa1$var$isHolding || setTimeout(()=>{
            $044706a3922c0aa1$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $044706a3922c0aa1$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $044706a3922c0aa1$var$releaseNextTicks() {
    $044706a3922c0aa1$var$isHolding = false;
    while($044706a3922c0aa1$var$tickStack.length)$044706a3922c0aa1$var$tickStack.shift()();
}
function $044706a3922c0aa1$var$holdNextTicks() {
    $044706a3922c0aa1$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $044706a3922c0aa1$var$setClasses(el, value) {
    if (Array.isArray(value)) return $044706a3922c0aa1$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $044706a3922c0aa1$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $044706a3922c0aa1$var$setClasses(el, value());
    return $044706a3922c0aa1$var$setClassesFromString(el, value);
}
function $044706a3922c0aa1$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $044706a3922c0aa1$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $044706a3922c0aa1$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $044706a3922c0aa1$var$setStylesFromObject(el, value);
    return $044706a3922c0aa1$var$setStylesFromString(el, value);
}
function $044706a3922c0aa1$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $044706a3922c0aa1$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $044706a3922c0aa1$var$setStyles(el, previousStyles);
    };
}
function $044706a3922c0aa1$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $044706a3922c0aa1$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $044706a3922c0aa1$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$044706a3922c0aa1$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $044706a3922c0aa1$var$registerTransitionsFromHelper(el, modifiers, value);
    else $044706a3922c0aa1$var$registerTransitionsFromClassString(el, expression, value);
});
function $044706a3922c0aa1$var$registerTransitionsFromClassString(el, classString, stage) {
    $044706a3922c0aa1$var$registerTransitionObject(el, $044706a3922c0aa1$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $044706a3922c0aa1$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $044706a3922c0aa1$var$registerTransitionObject(el, $044706a3922c0aa1$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $044706a3922c0aa1$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $044706a3922c0aa1$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $044706a3922c0aa1$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $044706a3922c0aa1$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $044706a3922c0aa1$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $044706a3922c0aa1$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $044706a3922c0aa1$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $044706a3922c0aa1$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $044706a3922c0aa1$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $044706a3922c0aa1$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $044706a3922c0aa1$var$closestHide(parent);
}
function $044706a3922c0aa1$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $044706a3922c0aa1$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $044706a3922c0aa1$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $044706a3922c0aa1$var$once(()=>{
        $044706a3922c0aa1$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $044706a3922c0aa1$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $044706a3922c0aa1$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $044706a3922c0aa1$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $044706a3922c0aa1$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $044706a3922c0aa1$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $044706a3922c0aa1$var$mutateDom(()=>{
                stages.end();
            });
            $044706a3922c0aa1$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $044706a3922c0aa1$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $044706a3922c0aa1$var$isCloning = false;
function $044706a3922c0aa1$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$044706a3922c0aa1$var$isCloning ? fallback(...args) : callback(...args);
}
function $044706a3922c0aa1$var$onlyDuringClone(callback) {
    return (...args)=>$044706a3922c0aa1$var$isCloning && callback(...args);
}
var $044706a3922c0aa1$var$interceptors = [];
function $044706a3922c0aa1$var$interceptClone(callback) {
    $044706a3922c0aa1$var$interceptors.push(callback);
}
function $044706a3922c0aa1$var$cloneNode(from, to) {
    $044706a3922c0aa1$var$interceptors.forEach((i)=>i(from, to));
    $044706a3922c0aa1$var$isCloning = true;
    $044706a3922c0aa1$var$dontRegisterReactiveSideEffects(()=>{
        $044706a3922c0aa1$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $044706a3922c0aa1$var$isCloning = false;
}
var $044706a3922c0aa1$var$isCloningLegacy = false;
function $044706a3922c0aa1$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $044706a3922c0aa1$var$isCloning = true;
    $044706a3922c0aa1$var$isCloningLegacy = true;
    $044706a3922c0aa1$var$dontRegisterReactiveSideEffects(()=>{
        $044706a3922c0aa1$var$cloneTree(newEl);
    });
    $044706a3922c0aa1$var$isCloning = false;
    $044706a3922c0aa1$var$isCloningLegacy = false;
}
function $044706a3922c0aa1$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $044706a3922c0aa1$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $044706a3922c0aa1$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $044706a3922c0aa1$var$initTree(el, shallowWalker);
}
function $044706a3922c0aa1$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $044706a3922c0aa1$var$effect;
    $044706a3922c0aa1$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $044706a3922c0aa1$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $044706a3922c0aa1$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $044706a3922c0aa1$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $044706a3922c0aa1$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $044706a3922c0aa1$var$camelCase(name) : name;
    switch(name){
        case "value":
            $044706a3922c0aa1$var$bindInputValue(el, value);
            break;
        case "style":
            $044706a3922c0aa1$var$bindStyles(el, value);
            break;
        case "class":
            $044706a3922c0aa1$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $044706a3922c0aa1$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $044706a3922c0aa1$var$bindAttribute(el, name, value);
            break;
    }
}
function $044706a3922c0aa1$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $044706a3922c0aa1$var$safeParseBoolean(el.value) === value;
            else el.checked = $044706a3922c0aa1$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$044706a3922c0aa1$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $044706a3922c0aa1$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $044706a3922c0aa1$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $044706a3922c0aa1$var$setClasses(el, value);
}
function $044706a3922c0aa1$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $044706a3922c0aa1$var$setStyles(el, value);
}
function $044706a3922c0aa1$var$bindAttributeAndProperty(el, name, value) {
    $044706a3922c0aa1$var$bindAttribute(el, name, value);
    $044706a3922c0aa1$var$setPropertyIfChanged(el, name, value);
}
function $044706a3922c0aa1$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $044706a3922c0aa1$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($044706a3922c0aa1$var$isBooleanAttr(name)) value = name;
        $044706a3922c0aa1$var$setIfChanged(el, name, value);
    }
}
function $044706a3922c0aa1$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $044706a3922c0aa1$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $044706a3922c0aa1$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $044706a3922c0aa1$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $044706a3922c0aa1$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $044706a3922c0aa1$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
function $044706a3922c0aa1$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $044706a3922c0aa1$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $044706a3922c0aa1$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $044706a3922c0aa1$var$getAttributeBinding(el, name, fallback);
}
function $044706a3922c0aa1$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $044706a3922c0aa1$var$dontAutoEvaluateFunctions(()=>{
            return $044706a3922c0aa1$var$evaluate(el, binding.expression);
        });
    }
    return $044706a3922c0aa1$var$getAttributeBinding(el, name, fallback);
}
function $044706a3922c0aa1$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($044706a3922c0aa1$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $044706a3922c0aa1$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $044706a3922c0aa1$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $044706a3922c0aa1$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $044706a3922c0aa1$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($044706a3922c0aa1$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($044706a3922c0aa1$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($044706a3922c0aa1$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $044706a3922c0aa1$var$release(reference);
    };
}
function $044706a3922c0aa1$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $044706a3922c0aa1$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($044706a3922c0aa1$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $044706a3922c0aa1$var$stores = {};
var $044706a3922c0aa1$var$isReactive = false;
function $044706a3922c0aa1$var$store(name, value) {
    if (!$044706a3922c0aa1$var$isReactive) {
        $044706a3922c0aa1$var$stores = $044706a3922c0aa1$var$reactive($044706a3922c0aa1$var$stores);
        $044706a3922c0aa1$var$isReactive = true;
    }
    if (value === void 0) return $044706a3922c0aa1$var$stores[name];
    $044706a3922c0aa1$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $044706a3922c0aa1$var$stores[name].init();
    $044706a3922c0aa1$var$initInterceptors($044706a3922c0aa1$var$stores[name]);
}
function $044706a3922c0aa1$var$getStores() {
    return $044706a3922c0aa1$var$stores;
}
// packages/alpinejs/src/binds.js
var $044706a3922c0aa1$var$binds = {};
function $044706a3922c0aa1$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $044706a3922c0aa1$var$applyBindingsObject(name, getBindings());
    else $044706a3922c0aa1$var$binds[name] = getBindings;
    return ()=>{};
}
function $044706a3922c0aa1$var$injectBindingProviders(obj) {
    Object.entries($044706a3922c0aa1$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $044706a3922c0aa1$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $044706a3922c0aa1$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $044706a3922c0aa1$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $044706a3922c0aa1$var$datas = {};
function $044706a3922c0aa1$var$data(name, callback) {
    $044706a3922c0aa1$var$datas[name] = callback;
}
function $044706a3922c0aa1$var$injectDataProviders(obj, context) {
    Object.entries($044706a3922c0aa1$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $044706a3922c0aa1$var$Alpine = {
    get reactive () {
        return $044706a3922c0aa1$var$reactive;
    },
    get release () {
        return $044706a3922c0aa1$var$release;
    },
    get effect () {
        return $044706a3922c0aa1$var$effect;
    },
    get raw () {
        return $044706a3922c0aa1$var$raw;
    },
    version: "3.14.1",
    flushAndStopDeferringMutations: $044706a3922c0aa1$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $044706a3922c0aa1$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $044706a3922c0aa1$var$disableEffectScheduling,
    startObservingMutations: $044706a3922c0aa1$var$startObservingMutations,
    stopObservingMutations: $044706a3922c0aa1$var$stopObservingMutations,
    setReactivityEngine: $044706a3922c0aa1$var$setReactivityEngine,
    onAttributeRemoved: $044706a3922c0aa1$var$onAttributeRemoved,
    onAttributesAdded: $044706a3922c0aa1$var$onAttributesAdded,
    closestDataStack: $044706a3922c0aa1$var$closestDataStack,
    skipDuringClone: $044706a3922c0aa1$var$skipDuringClone,
    onlyDuringClone: $044706a3922c0aa1$var$onlyDuringClone,
    addRootSelector: $044706a3922c0aa1$var$addRootSelector,
    addInitSelector: $044706a3922c0aa1$var$addInitSelector,
    interceptClone: $044706a3922c0aa1$var$interceptClone,
    addScopeToNode: $044706a3922c0aa1$var$addScopeToNode,
    deferMutations: $044706a3922c0aa1$var$deferMutations,
    mapAttributes: $044706a3922c0aa1$var$mapAttributes,
    evaluateLater: $044706a3922c0aa1$var$evaluateLater,
    interceptInit: $044706a3922c0aa1$var$interceptInit,
    setEvaluator: $044706a3922c0aa1$var$setEvaluator,
    mergeProxies: $044706a3922c0aa1$var$mergeProxies,
    extractProp: $044706a3922c0aa1$var$extractProp,
    findClosest: $044706a3922c0aa1$var$findClosest,
    onElRemoved: $044706a3922c0aa1$var$onElRemoved,
    closestRoot: $044706a3922c0aa1$var$closestRoot,
    destroyTree: $044706a3922c0aa1$var$destroyTree,
    interceptor: $044706a3922c0aa1$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $044706a3922c0aa1$var$transition,
    setStyles: // INTERNAL
    $044706a3922c0aa1$var$setStyles,
    mutateDom: // INTERNAL
    $044706a3922c0aa1$var$mutateDom,
    directive: $044706a3922c0aa1$var$directive,
    entangle: $044706a3922c0aa1$var$entangle,
    throttle: $044706a3922c0aa1$var$throttle,
    debounce: $044706a3922c0aa1$var$debounce,
    evaluate: $044706a3922c0aa1$var$evaluate,
    initTree: $044706a3922c0aa1$var$initTree,
    nextTick: $044706a3922c0aa1$var$nextTick,
    prefixed: $044706a3922c0aa1$var$prefix,
    prefix: $044706a3922c0aa1$var$setPrefix,
    plugin: $044706a3922c0aa1$var$plugin,
    magic: $044706a3922c0aa1$var$magic,
    store: $044706a3922c0aa1$var$store,
    start: $044706a3922c0aa1$var$start,
    clone: $044706a3922c0aa1$var$clone,
    cloneNode: // INTERNAL
    $044706a3922c0aa1$var$cloneNode,
    // INTERNAL
    bound: $044706a3922c0aa1$var$getBinding,
    $data: $044706a3922c0aa1$var$scope,
    watch: $044706a3922c0aa1$var$watch,
    walk: $044706a3922c0aa1$var$walk,
    data: $044706a3922c0aa1$var$data,
    bind: $044706a3922c0aa1$var$bind2
};
var $044706a3922c0aa1$var$alpine_default = $044706a3922c0aa1$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $044706a3922c0aa1$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $044706a3922c0aa1$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $044706a3922c0aa1$var$isBooleanAttr2 = /* @__PURE__ */ $044706a3922c0aa1$var$makeMap($044706a3922c0aa1$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $044706a3922c0aa1$var$EMPTY_OBJ = Object.freeze({});
var $044706a3922c0aa1$var$EMPTY_ARR = Object.freeze([]);
var $044706a3922c0aa1$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $044706a3922c0aa1$var$hasOwn = (val, key)=>$044706a3922c0aa1$var$hasOwnProperty.call(val, key);
var $044706a3922c0aa1$var$isArray = Array.isArray;
var $044706a3922c0aa1$var$isMap = (val)=>$044706a3922c0aa1$var$toTypeString(val) === "[object Map]";
var $044706a3922c0aa1$var$isString = (val)=>typeof val === "string";
var $044706a3922c0aa1$var$isSymbol = (val)=>typeof val === "symbol";
var $044706a3922c0aa1$var$isObject = (val)=>val !== null && typeof val === "object";
var $044706a3922c0aa1$var$objectToString = Object.prototype.toString;
var $044706a3922c0aa1$var$toTypeString = (value)=>$044706a3922c0aa1$var$objectToString.call(value);
var $044706a3922c0aa1$var$toRawType = (value)=>{
    return $044706a3922c0aa1$var$toTypeString(value).slice(8, -1);
};
var $044706a3922c0aa1$var$isIntegerKey = (key)=>$044706a3922c0aa1$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $044706a3922c0aa1$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $044706a3922c0aa1$var$camelizeRE = /-(\w)/g;
var $044706a3922c0aa1$var$camelize = $044706a3922c0aa1$var$cacheStringFunction((str)=>{
    return str.replace($044706a3922c0aa1$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $044706a3922c0aa1$var$hyphenateRE = /\B([A-Z])/g;
var $044706a3922c0aa1$var$hyphenate = $044706a3922c0aa1$var$cacheStringFunction((str)=>str.replace($044706a3922c0aa1$var$hyphenateRE, "-$1").toLowerCase());
var $044706a3922c0aa1$var$capitalize = $044706a3922c0aa1$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $044706a3922c0aa1$var$toHandlerKey = $044706a3922c0aa1$var$cacheStringFunction((str)=>str ? `on${$044706a3922c0aa1$var$capitalize(str)}` : ``);
var $044706a3922c0aa1$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $044706a3922c0aa1$var$targetMap = /* @__PURE__ */ new WeakMap();
var $044706a3922c0aa1$var$effectStack = [];
var $044706a3922c0aa1$var$activeEffect;
var $044706a3922c0aa1$var$ITERATE_KEY = Symbol("iterate");
var $044706a3922c0aa1$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $044706a3922c0aa1$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $044706a3922c0aa1$var$effect2(fn, options = $044706a3922c0aa1$var$EMPTY_OBJ) {
    if ($044706a3922c0aa1$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $044706a3922c0aa1$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $044706a3922c0aa1$var$stop(effect3) {
    if (effect3.active) {
        $044706a3922c0aa1$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $044706a3922c0aa1$var$uid = 0;
function $044706a3922c0aa1$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$044706a3922c0aa1$var$effectStack.includes(effect3)) {
            $044706a3922c0aa1$var$cleanup(effect3);
            try {
                $044706a3922c0aa1$var$enableTracking();
                $044706a3922c0aa1$var$effectStack.push(effect3);
                $044706a3922c0aa1$var$activeEffect = effect3;
                return fn();
            } finally{
                $044706a3922c0aa1$var$effectStack.pop();
                $044706a3922c0aa1$var$resetTracking();
                $044706a3922c0aa1$var$activeEffect = $044706a3922c0aa1$var$effectStack[$044706a3922c0aa1$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $044706a3922c0aa1$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $044706a3922c0aa1$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $044706a3922c0aa1$var$shouldTrack = true;
var $044706a3922c0aa1$var$trackStack = [];
function $044706a3922c0aa1$var$pauseTracking() {
    $044706a3922c0aa1$var$trackStack.push($044706a3922c0aa1$var$shouldTrack);
    $044706a3922c0aa1$var$shouldTrack = false;
}
function $044706a3922c0aa1$var$enableTracking() {
    $044706a3922c0aa1$var$trackStack.push($044706a3922c0aa1$var$shouldTrack);
    $044706a3922c0aa1$var$shouldTrack = true;
}
function $044706a3922c0aa1$var$resetTracking() {
    const last = $044706a3922c0aa1$var$trackStack.pop();
    $044706a3922c0aa1$var$shouldTrack = last === void 0 ? true : last;
}
function $044706a3922c0aa1$var$track(target, type, key) {
    if (!$044706a3922c0aa1$var$shouldTrack || $044706a3922c0aa1$var$activeEffect === void 0) return;
    let depsMap = $044706a3922c0aa1$var$targetMap.get(target);
    if (!depsMap) $044706a3922c0aa1$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($044706a3922c0aa1$var$activeEffect)) {
        dep.add($044706a3922c0aa1$var$activeEffect);
        $044706a3922c0aa1$var$activeEffect.deps.push(dep);
        if ($044706a3922c0aa1$var$activeEffect.options.onTrack) $044706a3922c0aa1$var$activeEffect.options.onTrack({
            effect: $044706a3922c0aa1$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $044706a3922c0aa1$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $044706a3922c0aa1$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $044706a3922c0aa1$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $044706a3922c0aa1$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$044706a3922c0aa1$var$isArray(target)) {
                    add2(depsMap.get($044706a3922c0aa1$var$ITERATE_KEY));
                    if ($044706a3922c0aa1$var$isMap(target)) add2(depsMap.get($044706a3922c0aa1$var$MAP_KEY_ITERATE_KEY));
                } else if ($044706a3922c0aa1$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$044706a3922c0aa1$var$isArray(target)) {
                    add2(depsMap.get($044706a3922c0aa1$var$ITERATE_KEY));
                    if ($044706a3922c0aa1$var$isMap(target)) add2(depsMap.get($044706a3922c0aa1$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($044706a3922c0aa1$var$isMap(target)) add2(depsMap.get($044706a3922c0aa1$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $044706a3922c0aa1$var$isNonTrackableKeys = /* @__PURE__ */ $044706a3922c0aa1$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $044706a3922c0aa1$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($044706a3922c0aa1$var$isSymbol));
var $044706a3922c0aa1$var$get2 = /* @__PURE__ */ $044706a3922c0aa1$var$createGetter();
var $044706a3922c0aa1$var$readonlyGet = /* @__PURE__ */ $044706a3922c0aa1$var$createGetter(true);
var $044706a3922c0aa1$var$arrayInstrumentations = /* @__PURE__ */ $044706a3922c0aa1$var$createArrayInstrumentations();
function $044706a3922c0aa1$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $044706a3922c0aa1$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$044706a3922c0aa1$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($044706a3922c0aa1$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $044706a3922c0aa1$var$pauseTracking();
            const res = $044706a3922c0aa1$var$toRaw(this)[key].apply(this, args);
            $044706a3922c0aa1$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $044706a3922c0aa1$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $044706a3922c0aa1$var$shallowReadonlyMap : $044706a3922c0aa1$var$readonlyMap : shallow ? $044706a3922c0aa1$var$shallowReactiveMap : $044706a3922c0aa1$var$reactiveMap).get(target)) return target;
        const targetIsArray = $044706a3922c0aa1$var$isArray(target);
        if (!isReadonly && targetIsArray && $044706a3922c0aa1$var$hasOwn($044706a3922c0aa1$var$arrayInstrumentations, key)) return Reflect.get($044706a3922c0aa1$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($044706a3922c0aa1$var$isSymbol(key) ? $044706a3922c0aa1$var$builtInSymbols.has(key) : $044706a3922c0aa1$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $044706a3922c0aa1$var$track(target, "get", key);
        if (shallow) return res;
        if ($044706a3922c0aa1$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$044706a3922c0aa1$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($044706a3922c0aa1$var$isObject(res)) return isReadonly ? $044706a3922c0aa1$var$readonly(res) : $044706a3922c0aa1$var$reactive2(res);
        return res;
    };
}
var $044706a3922c0aa1$var$set2 = /* @__PURE__ */ $044706a3922c0aa1$var$createSetter();
function $044706a3922c0aa1$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $044706a3922c0aa1$var$toRaw(value);
            oldValue = $044706a3922c0aa1$var$toRaw(oldValue);
            if (!$044706a3922c0aa1$var$isArray(target) && $044706a3922c0aa1$var$isRef(oldValue) && !$044706a3922c0aa1$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $044706a3922c0aa1$var$isArray(target) && $044706a3922c0aa1$var$isIntegerKey(key) ? Number(key) < target.length : $044706a3922c0aa1$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $044706a3922c0aa1$var$toRaw(receiver)) {
            if (!hadKey) $044706a3922c0aa1$var$trigger(target, "add", key, value);
            else if ($044706a3922c0aa1$var$hasChanged(value, oldValue)) $044706a3922c0aa1$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $044706a3922c0aa1$var$deleteProperty(target, key) {
    const hadKey = $044706a3922c0aa1$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $044706a3922c0aa1$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $044706a3922c0aa1$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$044706a3922c0aa1$var$isSymbol(key) || !$044706a3922c0aa1$var$builtInSymbols.has(key)) $044706a3922c0aa1$var$track(target, "has", key);
    return result;
}
function $044706a3922c0aa1$var$ownKeys(target) {
    $044706a3922c0aa1$var$track(target, "iterate", $044706a3922c0aa1$var$isArray(target) ? "length" : $044706a3922c0aa1$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $044706a3922c0aa1$var$mutableHandlers = {
    get: $044706a3922c0aa1$var$get2,
    set: $044706a3922c0aa1$var$set2,
    deleteProperty: $044706a3922c0aa1$var$deleteProperty,
    has: $044706a3922c0aa1$var$has,
    ownKeys: $044706a3922c0aa1$var$ownKeys
};
var $044706a3922c0aa1$var$readonlyHandlers = {
    get: $044706a3922c0aa1$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $044706a3922c0aa1$var$toReactive = (value)=>$044706a3922c0aa1$var$isObject(value) ? $044706a3922c0aa1$var$reactive2(value) : value;
var $044706a3922c0aa1$var$toReadonly = (value)=>$044706a3922c0aa1$var$isObject(value) ? $044706a3922c0aa1$var$readonly(value) : value;
var $044706a3922c0aa1$var$toShallow = (value)=>value;
var $044706a3922c0aa1$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $044706a3922c0aa1$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $044706a3922c0aa1$var$toRaw(target);
    const rawKey = $044706a3922c0aa1$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $044706a3922c0aa1$var$track(rawTarget, "get", key);
    !isReadonly && $044706a3922c0aa1$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $044706a3922c0aa1$var$getProto(rawTarget);
    const wrap = isShallow ? $044706a3922c0aa1$var$toShallow : isReadonly ? $044706a3922c0aa1$var$toReadonly : $044706a3922c0aa1$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $044706a3922c0aa1$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $044706a3922c0aa1$var$toRaw(target);
    const rawKey = $044706a3922c0aa1$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $044706a3922c0aa1$var$track(rawTarget, "has", key);
    !isReadonly && $044706a3922c0aa1$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $044706a3922c0aa1$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $044706a3922c0aa1$var$track($044706a3922c0aa1$var$toRaw(target), "iterate", $044706a3922c0aa1$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $044706a3922c0aa1$var$add(value) {
    value = $044706a3922c0aa1$var$toRaw(value);
    const target = $044706a3922c0aa1$var$toRaw(this);
    const proto = $044706a3922c0aa1$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $044706a3922c0aa1$var$trigger(target, "add", value, value);
    }
    return this;
}
function $044706a3922c0aa1$var$set$1(key, value) {
    value = $044706a3922c0aa1$var$toRaw(value);
    const target = $044706a3922c0aa1$var$toRaw(this);
    const { has: has2, get: get3 } = $044706a3922c0aa1$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $044706a3922c0aa1$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $044706a3922c0aa1$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $044706a3922c0aa1$var$trigger(target, "add", key, value);
    else if ($044706a3922c0aa1$var$hasChanged(value, oldValue)) $044706a3922c0aa1$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $044706a3922c0aa1$var$deleteEntry(key) {
    const target = $044706a3922c0aa1$var$toRaw(this);
    const { has: has2, get: get3 } = $044706a3922c0aa1$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $044706a3922c0aa1$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $044706a3922c0aa1$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $044706a3922c0aa1$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $044706a3922c0aa1$var$clear() {
    const target = $044706a3922c0aa1$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $044706a3922c0aa1$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $044706a3922c0aa1$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $044706a3922c0aa1$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $044706a3922c0aa1$var$toRaw(target);
        const wrap = isShallow ? $044706a3922c0aa1$var$toShallow : isReadonly ? $044706a3922c0aa1$var$toReadonly : $044706a3922c0aa1$var$toReactive;
        !isReadonly && $044706a3922c0aa1$var$track(rawTarget, "iterate", $044706a3922c0aa1$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $044706a3922c0aa1$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $044706a3922c0aa1$var$toRaw(target);
        const targetIsMap = $044706a3922c0aa1$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $044706a3922c0aa1$var$toShallow : isReadonly ? $044706a3922c0aa1$var$toReadonly : $044706a3922c0aa1$var$toReactive;
        !isReadonly && $044706a3922c0aa1$var$track(rawTarget, "iterate", isKeyOnly ? $044706a3922c0aa1$var$MAP_KEY_ITERATE_KEY : $044706a3922c0aa1$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $044706a3922c0aa1$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$044706a3922c0aa1$var$capitalize(type)} operation ${key}failed: target is readonly.`, $044706a3922c0aa1$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $044706a3922c0aa1$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $044706a3922c0aa1$var$get$1(this, key);
        },
        get size () {
            return $044706a3922c0aa1$var$size(this);
        },
        has: $044706a3922c0aa1$var$has$1,
        add: $044706a3922c0aa1$var$add,
        set: $044706a3922c0aa1$var$set$1,
        delete: $044706a3922c0aa1$var$deleteEntry,
        clear: $044706a3922c0aa1$var$clear,
        forEach: $044706a3922c0aa1$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $044706a3922c0aa1$var$get$1(this, key, false, true);
        },
        get size () {
            return $044706a3922c0aa1$var$size(this);
        },
        has: $044706a3922c0aa1$var$has$1,
        add: $044706a3922c0aa1$var$add,
        set: $044706a3922c0aa1$var$set$1,
        delete: $044706a3922c0aa1$var$deleteEntry,
        clear: $044706a3922c0aa1$var$clear,
        forEach: $044706a3922c0aa1$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $044706a3922c0aa1$var$get$1(this, key, true);
        },
        get size () {
            return $044706a3922c0aa1$var$size(this, true);
        },
        has (key) {
            return $044706a3922c0aa1$var$has$1.call(this, key, true);
        },
        add: $044706a3922c0aa1$var$createReadonlyMethod("add"),
        set: $044706a3922c0aa1$var$createReadonlyMethod("set"),
        delete: $044706a3922c0aa1$var$createReadonlyMethod("delete"),
        clear: $044706a3922c0aa1$var$createReadonlyMethod("clear"),
        forEach: $044706a3922c0aa1$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $044706a3922c0aa1$var$get$1(this, key, true, true);
        },
        get size () {
            return $044706a3922c0aa1$var$size(this, true);
        },
        has (key) {
            return $044706a3922c0aa1$var$has$1.call(this, key, true);
        },
        add: $044706a3922c0aa1$var$createReadonlyMethod("add"),
        set: $044706a3922c0aa1$var$createReadonlyMethod("set"),
        delete: $044706a3922c0aa1$var$createReadonlyMethod("delete"),
        clear: $044706a3922c0aa1$var$createReadonlyMethod("clear"),
        forEach: $044706a3922c0aa1$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $044706a3922c0aa1$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $044706a3922c0aa1$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $044706a3922c0aa1$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $044706a3922c0aa1$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$044706a3922c0aa1$var$mutableInstrumentations, $044706a3922c0aa1$var$readonlyInstrumentations, $044706a3922c0aa1$var$shallowInstrumentations, $044706a3922c0aa1$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $044706a3922c0aa1$var$createInstrumentations();
function $044706a3922c0aa1$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $044706a3922c0aa1$var$shallowReadonlyInstrumentations : $044706a3922c0aa1$var$shallowInstrumentations : isReadonly ? $044706a3922c0aa1$var$readonlyInstrumentations : $044706a3922c0aa1$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($044706a3922c0aa1$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $044706a3922c0aa1$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $044706a3922c0aa1$var$createInstrumentationGetter(false, false)
};
var $044706a3922c0aa1$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $044706a3922c0aa1$var$createInstrumentationGetter(true, false)
};
function $044706a3922c0aa1$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $044706a3922c0aa1$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $044706a3922c0aa1$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $044706a3922c0aa1$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $044706a3922c0aa1$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $044706a3922c0aa1$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $044706a3922c0aa1$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $044706a3922c0aa1$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $044706a3922c0aa1$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $044706a3922c0aa1$var$targetTypeMap($044706a3922c0aa1$var$toRawType(value));
}
function $044706a3922c0aa1$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $044706a3922c0aa1$var$createReactiveObject(target, false, $044706a3922c0aa1$var$mutableHandlers, $044706a3922c0aa1$var$mutableCollectionHandlers, $044706a3922c0aa1$var$reactiveMap);
}
function $044706a3922c0aa1$var$readonly(target) {
    return $044706a3922c0aa1$var$createReactiveObject(target, true, $044706a3922c0aa1$var$readonlyHandlers, $044706a3922c0aa1$var$readonlyCollectionHandlers, $044706a3922c0aa1$var$readonlyMap);
}
function $044706a3922c0aa1$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$044706a3922c0aa1$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $044706a3922c0aa1$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $044706a3922c0aa1$var$toRaw(observed) {
    return observed && $044706a3922c0aa1$var$toRaw(observed["__v_raw"]) || observed;
}
function $044706a3922c0aa1$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$044706a3922c0aa1$var$magic("nextTick", ()=>$044706a3922c0aa1$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$044706a3922c0aa1$var$magic("dispatch", (el)=>$044706a3922c0aa1$var$dispatch.bind($044706a3922c0aa1$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$044706a3922c0aa1$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $044706a3922c0aa1$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$044706a3922c0aa1$var$magic("store", $044706a3922c0aa1$var$getStores);
// packages/alpinejs/src/magics/$data.js
$044706a3922c0aa1$var$magic("data", (el)=>$044706a3922c0aa1$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$044706a3922c0aa1$var$magic("root", (el)=>$044706a3922c0aa1$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$044706a3922c0aa1$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $044706a3922c0aa1$var$mergeProxies($044706a3922c0aa1$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $044706a3922c0aa1$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $044706a3922c0aa1$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $044706a3922c0aa1$var$globalIdMemo = {};
function $044706a3922c0aa1$var$findAndIncrementId(name) {
    if (!$044706a3922c0aa1$var$globalIdMemo[name]) $044706a3922c0aa1$var$globalIdMemo[name] = 0;
    return ++$044706a3922c0aa1$var$globalIdMemo[name];
}
function $044706a3922c0aa1$var$closestIdRoot(el, name) {
    return $044706a3922c0aa1$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $044706a3922c0aa1$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $044706a3922c0aa1$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$044706a3922c0aa1$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $044706a3922c0aa1$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $044706a3922c0aa1$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $044706a3922c0aa1$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$044706a3922c0aa1$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $044706a3922c0aa1$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$044706a3922c0aa1$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$044706a3922c0aa1$var$warnMissingPluginMagic("Focus", "focus", "focus");
$044706a3922c0aa1$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $044706a3922c0aa1$var$warnMissingPluginMagic(name, magicName, slug) {
    $044706a3922c0aa1$var$magic(magicName, (el)=>$044706a3922c0aa1$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$044706a3922c0aa1$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $044706a3922c0aa1$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$044706a3922c0aa1$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $044706a3922c0aa1$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $044706a3922c0aa1$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $044706a3922c0aa1$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $044706a3922c0aa1$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $044706a3922c0aa1$var$skipDuringClone(()=>{
            $044706a3922c0aa1$var$initTree(clone2);
            clone2._x_ignore = true;
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $044706a3922c0aa1$var$getTarget(expression);
        $044706a3922c0aa1$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>clone2.remove());
});
var $044706a3922c0aa1$var$teleportContainerDuringClone = document.createElement("div");
function $044706a3922c0aa1$var$getTarget(expression) {
    let target = $044706a3922c0aa1$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $044706a3922c0aa1$var$teleportContainerDuringClone;
    })();
    if (!target) $044706a3922c0aa1$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $044706a3922c0aa1$var$handler = ()=>{};
$044706a3922c0aa1$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$044706a3922c0aa1$var$directive("ignore", $044706a3922c0aa1$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$044706a3922c0aa1$var$directive("effect", $044706a3922c0aa1$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($044706a3922c0aa1$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $044706a3922c0aa1$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $044706a3922c0aa1$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $044706a3922c0aa1$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $044706a3922c0aa1$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $044706a3922c0aa1$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $044706a3922c0aa1$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $044706a3922c0aa1$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($044706a3922c0aa1$var$isKeyEvent(event) || $044706a3922c0aa1$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($044706a3922c0aa1$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $044706a3922c0aa1$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $044706a3922c0aa1$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $044706a3922c0aa1$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $044706a3922c0aa1$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $044706a3922c0aa1$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $044706a3922c0aa1$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $044706a3922c0aa1$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $044706a3922c0aa1$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $044706a3922c0aa1$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $044706a3922c0aa1$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($044706a3922c0aa1$var$isClickEvent(e.type)) return false;
            if ($044706a3922c0aa1$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $044706a3922c0aa1$var$keyToModifiers(key) {
    if (!key) return [];
    key = $044706a3922c0aa1$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$044706a3922c0aa1$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $044706a3922c0aa1$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $044706a3922c0aa1$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $044706a3922c0aa1$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $044706a3922c0aa1$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($044706a3922c0aa1$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $044706a3922c0aa1$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $044706a3922c0aa1$var$isCloning ? ()=>{} : $044706a3922c0aa1$var$on(el, event, modifiers, (e)=>{
        setValue($044706a3922c0aa1$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($044706a3922c0aa1$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $044706a3922c0aa1$var$on(el.form, "reset", [], (e)=>{
            $044706a3922c0aa1$var$nextTick(()=>el._x_model && el._x_model.set($044706a3922c0aa1$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $044706a3922c0aa1$var$mutateDom(()=>$044706a3922c0aa1$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $044706a3922c0aa1$var$getInputValue(el, modifiers, event, currentValue) {
    return $044706a3922c0aa1$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $044706a3922c0aa1$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $044706a3922c0aa1$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$044706a3922c0aa1$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $044706a3922c0aa1$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $044706a3922c0aa1$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if (el.type === "radio") {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $044706a3922c0aa1$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $044706a3922c0aa1$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $044706a3922c0aa1$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $044706a3922c0aa1$var$isNumeric2(number) ? number : rawValue;
}
function $044706a3922c0aa1$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $044706a3922c0aa1$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $044706a3922c0aa1$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$044706a3922c0aa1$var$directive("cloak", (el)=>queueMicrotask(()=>$044706a3922c0aa1$var$mutateDom(()=>el.removeAttribute($044706a3922c0aa1$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$044706a3922c0aa1$var$addInitSelector(()=>`[${$044706a3922c0aa1$var$prefix("init")}]`);
$044706a3922c0aa1$var$directive("init", $044706a3922c0aa1$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$044706a3922c0aa1$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $044706a3922c0aa1$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$044706a3922c0aa1$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $044706a3922c0aa1$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $044706a3922c0aa1$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$044706a3922c0aa1$var$mapAttributes($044706a3922c0aa1$var$startingWith(":", $044706a3922c0aa1$var$into($044706a3922c0aa1$var$prefix("bind:"))));
var $044706a3922c0aa1$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $044706a3922c0aa1$var$injectBindingProviders(bindingProviders);
        let getBindings = $044706a3922c0aa1$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $044706a3922c0aa1$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $044706a3922c0aa1$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $044706a3922c0aa1$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $044706a3922c0aa1$var$mutateDom(()=>$044706a3922c0aa1$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$044706a3922c0aa1$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$044706a3922c0aa1$var$directive("bind", $044706a3922c0aa1$var$handler2);
function $044706a3922c0aa1$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$044706a3922c0aa1$var$addRootSelector(()=>`[${$044706a3922c0aa1$var$prefix("data")}]`);
$044706a3922c0aa1$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($044706a3922c0aa1$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $044706a3922c0aa1$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $044706a3922c0aa1$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $044706a3922c0aa1$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $044706a3922c0aa1$var$injectMagics(data2, el);
    let reactiveData = $044706a3922c0aa1$var$reactive(data2);
    $044706a3922c0aa1$var$initInterceptors(reactiveData);
    let undo = $044706a3922c0aa1$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $044706a3922c0aa1$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $044706a3922c0aa1$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$044706a3922c0aa1$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $044706a3922c0aa1$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$044706a3922c0aa1$var$isCloning) return false;
    if ($044706a3922c0aa1$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$044706a3922c0aa1$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $044706a3922c0aa1$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $044706a3922c0aa1$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $044706a3922c0aa1$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $044706a3922c0aa1$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$044706a3922c0aa1$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $044706a3922c0aa1$var$parseForExpression(expression);
    let evaluateItems = $044706a3922c0aa1$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $044706a3922c0aa1$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$044706a3922c0aa1$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $044706a3922c0aa1$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($044706a3922c0aa1$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $044706a3922c0aa1$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $044706a3922c0aa1$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $044706a3922c0aa1$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $044706a3922c0aa1$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($044706a3922c0aa1$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $044706a3922c0aa1$var$mutateDom(()=>{
                if (!elForSpot) $044706a3922c0aa1$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $044706a3922c0aa1$var$reactive(scope2);
            $044706a3922c0aa1$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $044706a3922c0aa1$var$mutateDom(()=>{
                lastEl.after(clone2);
                $044706a3922c0aa1$var$skipDuringClone(()=>$044706a3922c0aa1$var$initTree(clone2))();
            });
            if (typeof key === "object") $044706a3922c0aa1$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $044706a3922c0aa1$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $044706a3922c0aa1$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $044706a3922c0aa1$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $044706a3922c0aa1$var$handler3() {}
$044706a3922c0aa1$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $044706a3922c0aa1$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$044706a3922c0aa1$var$directive("ref", $044706a3922c0aa1$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$044706a3922c0aa1$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $044706a3922c0aa1$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $044706a3922c0aa1$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $044706a3922c0aa1$var$addScopeToNode(clone2, {}, el);
        $044706a3922c0aa1$var$mutateDom(()=>{
            el.after(clone2);
            $044706a3922c0aa1$var$skipDuringClone(()=>$044706a3922c0aa1$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $044706a3922c0aa1$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($044706a3922c0aa1$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$044706a3922c0aa1$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$044706a3922c0aa1$var$setIdRoot(el, name));
});
$044706a3922c0aa1$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$044706a3922c0aa1$var$mapAttributes($044706a3922c0aa1$var$startingWith("@", $044706a3922c0aa1$var$into($044706a3922c0aa1$var$prefix("on:"))));
$044706a3922c0aa1$var$directive("on", $044706a3922c0aa1$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $044706a3922c0aa1$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $044706a3922c0aa1$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$044706a3922c0aa1$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$044706a3922c0aa1$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$044706a3922c0aa1$var$warnMissingPluginDirective("Focus", "trap", "focus");
$044706a3922c0aa1$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $044706a3922c0aa1$var$warnMissingPluginDirective(name, directiveName, slug) {
    $044706a3922c0aa1$var$directive(directiveName, (el)=>$044706a3922c0aa1$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$044706a3922c0aa1$var$alpine_default.setEvaluator($044706a3922c0aa1$var$normalEvaluator);
$044706a3922c0aa1$var$alpine_default.setReactivityEngine({
    reactive: $044706a3922c0aa1$var$reactive2,
    effect: $044706a3922c0aa1$var$effect2,
    release: $044706a3922c0aa1$var$stop,
    raw: $044706a3922c0aa1$var$toRaw
});
var $044706a3922c0aa1$export$b7ee041e4ad2afec = $044706a3922c0aa1$var$alpine_default;
// packages/alpinejs/builds/module.js
var $044706a3922c0aa1$export$2e2bcd8739ae039 = $044706a3922c0aa1$export$b7ee041e4ad2afec;


// src/dialog.js
function $2b75121244c3e66d$var$dialog_default(Alpine) {
    Alpine.directive("htmldialog", fylgjaAlpineDialog);
    function fylgjaAlpineDialog(el, { expression: expression, modifiers: modifiers }, { evaluateLater: evaluateLater, cleanup: cleanup }) {
        const evaluate = expression.length ? evaluateLater(expression) : ()=>{};
        const lockPageScroll = modifiers.includes("noscroll");
        el.style.display = null;
        el.hidden = false;
        el.style.length === 0 && el.removeAttribute("style");
        function scrollLock(use = true) {
            document.body.style.overflow = use ? "hidden" : "";
        }
        function escapeDialog(event) {
            if (event.key !== "Escape") return;
            event.preventDefault();
            evaluate();
        }
        function backdropDialog(event) {
            const rect = el.getBoundingClientRect();
            const isInDialog = rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
            if (isInDialog) return;
            evaluate();
        }
        el._x_doShow = ()=>{
            if (el.hasAttribute("open")) return;
            el.showModal();
            document.addEventListener("keydown", escapeDialog);
            el.addEventListener("click", backdropDialog);
            scrollLock(lockPageScroll);
        };
        el._x_doHide = ()=>{
            if (!el.hasAttribute("open")) return;
            el.close();
            document.removeEventListener("keydown", escapeDialog);
            el.removeEventListener("click", backdropDialog);
            scrollLock(false);
        };
        cleanup(()=>{
            document.removeEventListener("keydown", escapeDialog);
            el.removeEventListener("click", backdropDialog);
            scrollLock(false);
        });
    }
}
// src/module.js
var $2b75121244c3e66d$export$2e2bcd8739ae039 = $2b75121244c3e66d$var$dialog_default;


window.Alpine = (0, $044706a3922c0aa1$export$2e2bcd8739ae039);
window.bootstrap = $586b16fccafeb372$exports;
window.htmx = $l9SKL;
(0, $044706a3922c0aa1$export$2e2bcd8739ae039).plugin((0, $2b75121244c3e66d$export$2e2bcd8739ae039));
(0, $044706a3922c0aa1$export$2e2bcd8739ae039).start();

})();
//# sourceMappingURL=index.js.map
